webpackJsonp([31],{

/***/ 108:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = login;
/* harmony export (immutable) */ __webpack_exports__["c"] = logout;
/* harmony export (immutable) */ __webpack_exports__["a"] = clearCache;
/* harmony export (immutable) */ __webpack_exports__["b"] = isLoggedIn;
/* harmony export (immutable) */ __webpack_exports__["d"] = getUserDevId;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_app_cfg__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_app_cfg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__config_app_cfg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);





function login(id, mobile, apiKey) {
  // set user id for further transactions
  __WEBPACK_IMPORTED_MODULE_2__config_app_cfg___default.a.USER_ID = Number(id);
  __WEBPACK_IMPORTED_MODULE_2__config_app_cfg___default.a.MOBILE_NO = mobile;
  localStorage.setItem('USER_ID', id);
  localStorage.setItem('MOBILE_NO', mobile);
  localStorage.setItem('API_KEY', apiKey);
}

function logout() {
  localStorage.removeItem('USER_ID');
  localStorage.removeItem('MOBILE_NO');
  localStorage.removeItem('SECURITY_POST');
  localStorage.removeItem('API_KEY');
  __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].go('/');
}

function clearCache() {
  localStorage.removeItem('USER_ID');
  localStorage.removeItem('MOBILE_NO');
  localStorage.removeItem('SECURITY_POST');
  localStorage.removeItem('API_KEY');
  localStorage.removeItem('LAST_COMM_ID');
  localStorage.removeItem('WELCOME_COUNTRY_CODE');
  __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push('/');
}

function isLoggedIn() {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_2__config_app_cfg___default.a.USER_ID = Number(localStorage.getItem('USER_ID'));
    __WEBPACK_IMPORTED_MODULE_2__config_app_cfg___default.a.MOBILE_NO = localStorage.getItem('MOBILE_NO');
    __WEBPACK_IMPORTED_MODULE_2__config_app_cfg___default.a.API_KEY = localStorage.getItem('API_KEY') + __WEBPACK_IMPORTED_MODULE_2__config_app_cfg___default.a.USER_ID;

    // check for genuine access
    if (__WEBPACK_IMPORTED_MODULE_2__config_app_cfg___default.a.USER_ID) {
      var req = {
        user_id: __WEBPACK_IMPORTED_MODULE_2__config_app_cfg___default.a.USER_ID,
        user_device_id: getUserDevId(),
        api_key: __WEBPACK_IMPORTED_MODULE_2__config_app_cfg___default.a.API_KEY,
        device_os: 'PWA',
        device_os_ver: navigator.platform,
        device_make: '',
        device_model: '',
        app_ver: __WEBPACK_IMPORTED_MODULE_2__config_app_cfg___default.a.APP_VER,
        is_web_mob_device: checkForMobDevice() !== ''
      };
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config_app_cfg___default.a.API_URL + '/authorize-api-key/', req).then(function (response) {
        resolve(__WEBPACK_IMPORTED_MODULE_2__config_app_cfg___default.a.USER_ID);
      }).catch(function (err) {
        localStorage.removeItem('USER_ID');
        localStorage.removeItem('MOBILE_NO');
        localStorage.removeItem('API_KEY');
        reject('Access denied:' + err.response.data);
      });
    } else {
      reject('No user info available');
    }
  });
}

function getUserDevId() {
  return navigator.userAgent.slice(-35);
}

function checkForMobDevice() {
  if (navigator.userAgent.match(/Android/i)) {
    return 'Android';
  } else if (navigator.userAgent.match(/iPhone/i)) {
    return 'iPhone';
  } else if (navigator.userAgent.match(/iPad/i)) {
    return 'iPad';
  } else if (navigator.userAgent.match(/BlackBerry/i)) {
    return 'BlackBerry';
  } else if (navigator.userAgent.match(/Opera Mini/i)) {
    return 'Opera Mini';
  } else if (navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i)) {
    return 'Windows';
  } else {
    return '';
  }
}

/***/ }),

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(35)(
  /* script */
  __webpack_require__(457),
  /* template */
  __webpack_require__(759),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(35)(
  /* script */
  __webpack_require__(458),
  /* template */
  __webpack_require__(764),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 157:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(35)(
  /* script */
  __webpack_require__(459),
  /* template */
  __webpack_require__(761),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 158:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(35)(
  /* script */
  __webpack_require__(460),
  /* template */
  __webpack_require__(762),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 159:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(716)
}
var Component = __webpack_require__(35)(
  /* script */
  __webpack_require__(461),
  /* template */
  __webpack_require__(760),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(717)
}
var Component = __webpack_require__(35)(
  /* script */
  __webpack_require__(462),
  /* template */
  __webpack_require__(763),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a67123e0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/integra_logo.5935a45.png";

/***/ }),

/***/ 183:
/***/ (function(module, exports) {

/* Staging Environment Configuration */

module.exports = {
  ENV_NAME: 'staging',
  APP_TEST_MODE: false, // Set to false to enable all features (SMS, emails, etc.)
  API_URL: 'https://staging.uniservice.in/api',
  ADMIN_CORNER_URL: 'https://staging.admin.integrafms.com/admin',
  FM_SPACES_BASE_URL: 'https://staging-fm-space.blr1.digitaloceanspaces.com/',
  STATIC_FILES_DIR: 'https://staging-fm-space.blr1.digitaloceanspaces.com/',
  ASSET_FILES_DIR: '/src/asset/'
};

/***/ }),

/***/ 184:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Welcome__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Welcome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Welcome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DailyReport__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DailyReport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_DailyReport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_WeeklyReport__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_WeeklyReport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_WeeklyReport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Compset__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Compset___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Compset__);







__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_router___default.a);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router___default.a({
  routes: [{ name: 'Welcome', path: '/', component: __WEBPACK_IMPORTED_MODULE_2__components_Welcome___default.a, meta: { title: 'Welcome' } }, { name: 'Create', path: '/welcome/:action', component: __WEBPACK_IMPORTED_MODULE_2__components_Welcome___default.a, meta: { title: 'Welcome' }, props: true },
  // DailyReport & WeeklyReport  is needed for GENERATE  reports
  { name: 'DailyReport', path: '/DailyReport/:action', component: __WEBPACK_IMPORTED_MODULE_3__components_DailyReport___default.a, meta: { title: 'DailyReport' }, props: true }, { name: 'WeeklyReport', path: '/WeeklyReport/:action', component: __WEBPACK_IMPORTED_MODULE_4__components_WeeklyReport___default.a, meta: { title: 'WeeklyReport' }, props: true },
  // Compset is needed to add Service category for tasks from create task. This is needed for the communities does not have helpdesk menus
  { name: 'Compset', path: '/Compset', component: __WEBPACK_IMPORTED_MODULE_5__components_Compset___default.a, meta: { title: 'Settings' }, props: true
    // remaining routers are added dynamically in App.vue while creating menu
  }],
  mode: 'history'
});

// Menu-driven routes are code-split (see App.vue's `() => import(...)`), so a
// browser tab left open across a deployment still holds the old chunk-id ->
// filename map. Navigating to a not-yet-loaded chunk then requests a file the
// new deploy no longer has, the server's history-mode fallback returns
// index.html for it, and the script tag fails with a MIME-type error
// ("Loading chunk N failed."). Reload once to pick up the freshly deployed
// bundle instead of leaving the user stuck on a broken navigation.
var CHUNK_RELOAD_KEY = 'chunk-load-error-reloaded';

router.onError(function (error) {
  var isChunkLoadError = /Loading( CSS)? chunk (\d)+ failed/.test(error.message) || error.name === 'ChunkLoadError';
  if (isChunkLoadError && !sessionStorage.getItem(CHUNK_RELOAD_KEY)) {
    sessionStorage.setItem(CHUNK_RELOAD_KEY, '1');
    window.location.reload();
  }
});

// A route that resolves normally means the current bundle is good again
// (e.g. after the reload above), so allow future chunk failures to trigger
// another recovery reload instead of permanently suppressing it.
router.afterEach(function () {
  sessionStorage.removeItem(CHUNK_RELOAD_KEY);
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 32:
/***/ (function(module, exports, __webpack_require__) {

/* front end application config */

/* Load environment-specific configuration */
var envConfig = void 0;
try {
  // BUILD_ENV is set by build.sh script during build time
  var BUILD_ENV = "production" || 'production';
  envConfig = __webpack_require__(773)("./env." + BUILD_ENV + '.js');
  console.log('Loaded ' + BUILD_ENV + ' environment configuration');
} catch (error) {
  console.warn('Failed to load environment config, using staging as default');
  envConfig = __webpack_require__(183);
}

module.exports = {
  // app configs
  APP_VER: '2.0',
  API_URL: envConfig.API_URL,
  ADMIN_CORNER_URL: envConfig.ADMIN_CORNER_URL,
  FM_SPACES_BASE_URL: envConfig.FM_SPACES_BASE_URL,
  APP_DIR: '',
  STATIC_FILES_DIR: envConfig.STATIC_FILES_DIR,
  ASSET_FILES_DIR: envConfig.ASSET_FILES_DIR,
  // User and community details
  USER_ID: '',
  CUST_ID: '',
  PUSH_SUB: '',
  ALL_UNITS: [],
  UNITS: [],
  UNIT_ID_LIST: '',
  USER_HAS_MORE_UNITS: false,
  PRIVATE_UNITS: [],
  PRIVATE_UNIT_ID_LIST: '',
  USER_HAS_MORE_PRIVATE_UNITS: false,
  COMM_ID: '',
  LAST_COMM_ID: '',
  COMM_NAME: '',
  MOBILE_NO: '',
  CUST_NAME: '',
  EMAIL_ID: '',
  ROLE_NAME: '',
  IS_FM: false,
  IS_OTHER_USER: false,
  AVATAR_URL: '',
  IS_ADMIN: false,
  IS_USER_ACTIVE: false,
  IS_USER_LINKED: false,
  IS_USER_EMPOWERED: false,
  HIDE_CONTACT: false,
  // Localization
  COMM_COUNTRY_CODE: 'IN',
  IS_TAX_APP: true,
  CURRENCY: '₹ ',
  TAX_EXEMPTION_LIMIT: 7500,
  YEARLY_TAX_EXEMPTION_LIMIT: 90000,
  TAX_RATE: 9,
  SUPPORTED_COUNTRIES: [// default country
  {
    country_code: 'IN',
    country: 'India',
    product_url: 'https://uniservice.in',
    hero_img_sm: 'hero_sm.png',
    hero_img_big: 'hero.png',
    support_email: 'postman@uniservice.in',
    currency_symbol: '₹ '
  }],
  // FM service provider
  FM_VENDOR_ID: '',
  FM_VENDOR_NAME: '',
  IS_BB_VENDOR: false,
  ATTENDANCE_SHIFT_THRESHOLD: 1.5,
  IS_BACKOFFICE_COMM: false,
  // Security
  SECURITY_POST: '',
  IS_COVID_CHECK_ENABLED: true,
  SMS_FOR_EASYPASS: false,
  COMM_CONFIG: ''
};

/***/ }),

/***/ 386:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Attendance": [
		408,
		6
	],
	"./Attendance.vue": [
		408,
		6
	],
	"./BackOfficeSup": [
		409,
		9
	],
	"./BackOfficeSup.vue": [
		409,
		9
	],
	"./CameraAndFilePicker": [
		400,
		24
	],
	"./CameraAndFilePicker.vue": [
		400,
		24
	],
	"./Complaints": [
		410,
		3
	],
	"./Complaints.vue": [
		410,
		3
	],
	"./Compliance": [
		411,
		14
	],
	"./Compliance.vue": [
		411,
		14
	],
	"./Compset": [
		155
	],
	"./Compset.vue": [
		155
	],
	"./DailyReport": [
		156
	],
	"./DailyReport.vue": [
		156
	],
	"./Dailyupdate": [
		412,
		0
	],
	"./Dailyupdate.vue": [
		412,
		0
	],
	"./Dashboard": [
		413,
		29
	],
	"./Dashboard.vue": [
		413,
		29
	],
	"./Employee": [
		414,
		8
	],
	"./Employee.vue": [
		414,
		8
	],
	"./Facconfig": [
		415,
		11
	],
	"./Facconfig.vue": [
		415,
		11
	],
	"./Facdash": [
		416,
		1
	],
	"./Facdash.vue": [
		416,
		1
	],
	"./IncidentReports": [
		417,
		23
	],
	"./IncidentReports.vue": [
		417,
		23
	],
	"./Incidents": [
		418,
		7
	],
	"./Incidents.vue": [
		418,
		7
	],
	"./Inventory": [
		419,
		13
	],
	"./Inventory.vue": [
		419,
		13
	],
	"./JoinComm": [
		157
	],
	"./JoinComm.vue": [
		157
	],
	"./Login": [
		158
	],
	"./Login.vue": [
		158
	],
	"./Notifylogs": [
		420,
		21
	],
	"./Notifylogs.vue": [
		420,
		21
	],
	"./PpmPlanner": [
		421,
		2
	],
	"./PpmPlanner.vue": [
		421,
		2
	],
	"./Profile": [
		422,
		28
	],
	"./Profile.vue": [
		422,
		28
	],
	"./Repository": [
		423,
		22
	],
	"./Repository.vue": [
		423,
		22
	],
	"./Residents": [
		424,
		20
	],
	"./Residents.vue": [
		424,
		20
	],
	"./Roles": [
		425,
		19
	],
	"./Roles.vue": [
		425,
		19
	],
	"./Settings": [
		426,
		27
	],
	"./Settings.vue": [
		426,
		27
	],
	"./SlaScoreCard": [
		427,
		12
	],
	"./SlaScoreCard.vue": [
		427,
		12
	],
	"./Staff": [
		428,
		10
	],
	"./Staff.vue": [
		428,
		10
	],
	"./Support": [
		429,
		26
	],
	"./Support.vue": [
		429,
		26
	],
	"./Task": [
		430,
		4
	],
	"./Task.vue": [
		430,
		4
	],
	"./Unit": [
		431,
		18
	],
	"./Unit.vue": [
		431,
		18
	],
	"./Users": [
		432,
		17
	],
	"./Users.vue": [
		432,
		17
	],
	"./VDownloadAs": [
		389,
		25
	],
	"./VDownloadAs.vue": [
		389,
		25
	],
	"./Vendor": [
		433,
		16
	],
	"./Vendor.vue": [
		433,
		16
	],
	"./VendorSupplierBO": [
		434,
		15
	],
	"./VendorSupplierBO.vue": [
		434,
		15
	],
	"./Visitors": [
		435,
		5
	],
	"./Visitors.vue": [
		435,
		5
	],
	"./WeeklyReport": [
		159
	],
	"./WeeklyReport.vue": [
		159
	],
	"./Welcome": [
		160
	],
	"./Welcome.vue": [
		160
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 386;

/***/ }),

/***/ 387:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_flag_icon__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify_dist_vuetify_css__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify_dist_vuetify_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetify_dist_vuetify_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_gtag__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_gtag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_gtag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_OnlineListner__ = __webpack_require__(454);











/* intialize Vue and Vuetify */

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a, {
  theme: {
    primary: '#00726E', //  '#48658B',
    secondary: ' #00303F', //  '#3F73B6',
    accent: '#E26557',
    error: '#EB5757',
    warning: '#FBCE2F',
    info: '#2D9CDB',
    success: '#27AE60'
  }
});
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_2_axios___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_vue_flag_icon__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.config.productionTip = false;

// connecting to google analytics
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_vue_gtag___default.a, {
  config: { id: 'UA-167477938-1' }
}, __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */]);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_7__App___default.a);
  }
});

/***/ }),

/***/ 452:
/***/ (function(module, exports) {

/* Development Environment Configuration */

module.exports = {
  ENV_NAME: 'development',
  APP_TEST_MODE: true, // Set to true to disable SMS, emails, etc. in development
  API_URL: 'https://staging.uniservice.in/api',
  ADMIN_CORNER_URL: ' https://staging.admin.integrafms.com/admin',
  FM_SPACES_BASE_URL: 'https://gointegra-fm-space.blr1.digitaloceanspaces.com/',
  STATIC_FILES_DIR: 'https://gointegra-fm-space.blr1.digitaloceanspaces.com/',
  ASSET_FILES_DIR: '/src/asset/'
};

/***/ }),

/***/ 453:
/***/ (function(module, exports) {

/* Production Environment Configuration */

module.exports = {
  ENV_NAME: 'production',
  APP_TEST_MODE: false, // MUST be false in production to enable all features
  API_URL: 'https://app.integrafms.com/api',
  ADMIN_CORNER_URL: 'https://admin.integrafms.com/admin',
  FM_SPACES_BASE_URL: 'https://gointegra-fm-space.blr1.digitaloceanspaces.com/',
  STATIC_FILES_DIR: 'https://gointegra-fm-space.blr1.digitaloceanspaces.com/',
  ASSET_FILES_DIR: '/src/asset/'
};

/***/ }),

/***/ 454:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Connectivity */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_socket_io_client__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_socket_io_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_socket_io_client__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_app_cfg__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg__);



// Use the same API URL as the rest of the app (without /api path if present)
var socketUrl = __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL.replace(/\/api\/?$/, '');

console.log('🚀 [OnlineListner] Script executed at top level.');

/**
 * Connectivity Status Enum
 */
var Connectivity = {
  ONLINE: 'online',
  SERVER_OFFLINE: 'serverOffline',
  CLIENT_OFFLINE: 'clientOffline'
};

window.Connectivity = Connectivity;

var socket = null;
var lastStatus = null;

try {
  socket = __WEBPACK_IMPORTED_MODULE_0_socket_io_client___default()(socketUrl, {
    path: '/socket.io',
    transports: ['websocket', 'polling'],
    autoConnect: true
  });
} catch (err) {
  console.error('❌ [OnlineListner] Socket error:', err);
}

/**
 * Global function to get current connectivity status
 */
window.onlineListener = function () {
  if (!window.navigator.onLine) {
    return Connectivity.CLIENT_OFFLINE;
  }
  if (!socket || !socket.connected) {
    return Connectivity.SERVER_OFFLINE;
  }
  return Connectivity.ONLINE;
};

/**
 * Dispatch a CustomEvent 'onlineListener' on the window only if status changed
 */
var dispatchConnectivityEvent = function dispatchConnectivityEvent() {
  var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  try {
    var status = window.onlineListener();

    // Only dispatch if status has changed OR if forced
    if (!force && status === lastStatus) {
      return;
    }

    lastStatus = status;
    var event = new CustomEvent('onlineListener', {
      detail: status,
      bubbles: true,
      cancelable: true
    });

    window.dispatchEvent(event);
    console.log('\uD83D\uDCE2 [OnlineListner] Status Changed & Dispatched: ' + status);
  } catch (err) {
    console.error('❌ [OnlineListner] Dispatch error:', err);
  }
};

if (socket) {
  socket.on('connect', function () {
    console.log('✅ [OnlineListner] Connected Event');
    dispatchConnectivityEvent();
  });

  socket.on('disconnect', function () {
    console.log('❌ [OnlineListner] Disconnected Event');
    dispatchConnectivityEvent();
  });

  socket.on('connect_error', function (error) {
    console.error('❌ [OnlineListner] Socket Error:', error.message);
    dispatchConnectivityEvent();
  });
}

/**
 * Browser Network Listeners
 */
window.addEventListener('online', function () {
  console.log('🌐 [OnlineListner] Browser Online');
  if (socket && !socket.connected) {
    socket.connect();
  }
  dispatchConnectivityEvent();
});

window.addEventListener('offline', function () {
  console.log('🔌 [OnlineListner] Browser Offline');
  dispatchConnectivityEvent();
});

// Periodic check for status changes (silent unless changed)
setInterval(function () {
  dispatchConnectivityEvent();
}, 3000);

// Initial dispatch (forced)
setTimeout(function () {
  dispatchConnectivityEvent(true);
}, 1500);

// Helper for manual trigger
window.testOnline = function () {
  console.log('🧪 [Manual Test] Forcing dispatchConnectivityEvent...');
  dispatchConnectivityEvent(true);
};

/* unused harmony default export */ var _unused_webpack_default_export = (socket);

/***/ }),

/***/ 455:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'flag',
    props: {
        iso: { type: String, default: null },
        title: { type: String, default: null },
        squared: { type: Boolean, default: true }
    },
    computed: {
        flagIconClass: function flagIconClass() {
            return (!!this.squared ? 'flag-icon-squared ' : '') + 'flag-icon-' + this.iso.toLowerCase();
        }
    }
});

/***/ }),

/***/ 456:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_app_cfg__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__config_app_cfg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_handy__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_handy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__utils_handy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_auth__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      dialog: false,
      drawer: null,
      items: [],
      selectedItems: [],
      loggedAlready: null,
      curBot: null,
      bottomMenuItemsRes: ['My Unit', 'Community', 'Help Desk'],
      bottomMenuReqOrder: ['Management', 'Help Desk', 'Community', 'Facility', 'My Unit'],
      config: __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a,
      commList: [],
      curComm: {},
      choosenComm: '',
      dlgPush: false
    };
  },
  created: function created() {
    var _this = this;

    // get current dir of app
    var curPath = __webpack_require__(395);
    __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.APP_DIR = curPath.dirname(__webpack_require__.c[__webpack_require__.s].filename) + '/../';
    // check network connectivity
    this.axios.get(__WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.API_URL + '/getHandshakeFromServer/').then(function (response) {
      // get supported countries
      _this.axios.get(__WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.API_URL + '/getSupportedCountries/').then(function (response) {
        __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.SUPPORTED_COUNTRIES = response.data;
      });

      // check for new community signup
      if (_this.$router.currentRoute.path.startsWith('/create')) {
        _this.$router.push('/welcome/create');
        // check for cache clearing requested by user
      } else if (_this.$router.currentRoute.path.startsWith('/clear-cache')) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_auth__["a" /* clearCache */])();
        alert('Application cache cleared successfully, please login again');
      } else {
        // existing user
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_auth__["b" /* isLoggedIn */])().then(function (response) {
          // set API key in header for further calls
          _this.axios.defaults.headers.common = { 'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.API_KEY
            // load user details
          };_this.axios.get(__WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.API_URL + '/getUserByID/' + __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.USER_ID).then(function (response) {
            if (response.data.length > 0) {
              // common to an user
              __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.CUST_ID = response.data[0].cust_id;
              __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.CUST_NAME = response.data[0].cust_name;
              __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.EMAIL_ID = response.data[0].contact_email;
              __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.AVATAR_URL = response.data[0].avatar_url;

              // load list of communities associated to this user
              _this.axios.get(__WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.API_URL + '/getCommByUserId/' + __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.USER_ID).then(function (response) {
                var idx = 0;
                _this.commList = response.data;
                if (response.data.length > 1) {
                  // user has more than one community/unit, load last used or first linked on by default
                  __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.LAST_COMM_ID = Number(localStorage.getItem('LAST_COMM_ID'));
                  if (__WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.LAST_COMM_ID && _this.commList.findIndex(function (rec) {
                    return rec.comm_id === __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.LAST_COMM_ID && (rec.rel_status_list && rec.rel_status_list.includes('Linked') && rec.is_active || rec.is_other_user && rec.rel_status_if_other_user === 'Linked' && rec.is_active);
                  }) >= 0) {
                    idx = _this.commList.findIndex(function (rec) {
                      return rec.comm_id === __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.LAST_COMM_ID;
                    });
                  } else {
                    idx = response.data.findIndex(function (rec) {
                      return rec.rel_status_list && rec.rel_status_list.includes('Linked') && rec.is_active || rec.is_other_user && rec.rel_status_if_other_user === 'Linked' && rec.is_active;
                    });
                    if (idx < 0) {
                      idx = response.data.findIndex(function (rec) {
                        return rec.rel_status_list && rec.rel_status_list.includes('Delinked') || !rec.is_active || rec.is_other_user && (rec.rel_status_if_other_user === 'Delinked' || !rec.is_active);
                      });
                    }
                  }
                  if (idx < 0) {
                    idx = 0;
                  }
                }
                // load community and menu items as per the role
                _this.loadComm(_this.commList[idx]);
              });
            } else {
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_auth__["c" /* logout */])();
            }
          }).catch(function (err) {
            alert(err.response.data);
            return;
          });
        }).catch(function (err) {
          // show welcome page
          console.log(err);
          _this.$router.push('/');
        });
      }
    }).catch(function (err) {
      console.log(err);
      alert('Unable to connect to server, please check your internet connection');
    });
  },

  methods: {
    logout: function logout() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_auth__["c" /* logout */])();
    },
    loadMenu: function loadMenu() {
      var _this2 = this;

      var emptyMenu = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      // load menu items from db
      // admin overrides other roles
      var userRole = __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.IS_ADMIN ? 'Administrator' : !emptyMenu ? __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.ROLE_NAME : 'Not Exist';
      this.axios.get(__WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.API_URL + '/getMenu/' + __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.USER_ID + '/' + userRole + '/' + __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.COMM_ID).then(function (response) {
        _this2.items = response.data; // all menus
        // create routes as well
        var curItem, curChild;
        var rtArray = [];
        var tmpComp;
        var tmpSelItems = [];
        for (var i = 0; i < _this2.items.length; i++) {
          curItem = _this2.items[i];
          if (curItem.url) {
            (function () {
              var rtCompNm = curItem.url.charAt(0).toUpperCase() + curItem.url.slice(1);
              tmpComp = function tmpComp() {
                return __webpack_require__(386)("./" + rtCompNm);
              };
              rtArray.push({
                name: rtCompNm,
                path: '/' + curItem.url,
                component: tmpComp,
                meta: { title: curItem.text }
              });
              rtArray.push({
                name: rtCompNm + ' ', // added a space just to get different name
                path: '/' + curItem.url + '/:action',
                component: tmpComp,
                meta: { title: curItem.text },
                props: true
              });
            })();
          }

          var _loop = function _loop() {
            curChild = curItem.children[j];
            var rtCompNm = curChild.url.charAt(0).toUpperCase() + curChild.url.slice(1);
            tmpComp = function tmpComp() {
              return __webpack_require__(386)("./" + rtCompNm);
            };
            rtArray.push({
              name: rtCompNm,
              path: '/' + curChild.url,
              component: tmpComp,
              meta: { title: curChild.text }
            });
            rtArray.push({
              name: rtCompNm + ' ',
              path: '/' + curChild.url + '/:action',
              component: tmpComp,
              meta: { title: curChild.text },
              props: true
            });
          };

          for (var j = 0; j < curItem.children.length; j++) {
            _loop();
          }
          // selected menus to display in the bottom
          if (__WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.IS_OTHER_USER) {
            // staffs
            // look for facility and add them
            if (curItem.text.includes('Facility')) {
              var tmpItem = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, curItem);
              tmpItem.text = 'Facility';
              tmpSelItems.push(tmpItem);
            } else if (!curItem.text.includes('My Unit') && _this2.bottomMenuItemsRes.indexOf(curItem.text) >= 0) {
              tmpSelItems.push(curItem);
            }
          } else {
            // resident
            if (_this2.bottomMenuItemsRes.indexOf(curItem.text) >= 0) {
              tmpSelItems.push(curItem);
            }
          }
        }

        _this2.$router.addRoutes(rtArray);

        if (__WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.IS_ADMIN) {
          // add management modules into bottom sheet
          var _curItem = { text: 'Management', icon: 'more_vert', children: [] };
          if (_this2.items.findIndex(function (rec) {
            return rec.text === 'Facility Management';
          }) >= 0 && !__WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.IS_OTHER_USER) {
            _curItem.children.push({ text: 'Facility Management', icon: 'engineering', url: 'facdash' });
          }
          if (_this2.items.findIndex(function (rec) {
            return rec.text === 'Accounts';
          }) >= 0) {
            _curItem.children.push({ text: 'Accounts', icon: 'money', url: 'invoicing' });
          }
          if (_this2.items.findIndex(function (rec) {
            return rec.text === 'Gate';
          }) >= 0) {
            _curItem.children.push({ text: 'Gate', icon: 'security', url: 'visitors' });
          }
          if (_this2.items.findIndex(function (rec) {
            return rec.text === 'Admin\'s Corner';
          }) >= 0) {
            _curItem.children.push({ text: 'Admin\'s Corner', icon: 'admin_panel_settings', url: 'users' });
          }
          tmpSelItems.push(_curItem);
        }
        // sort the items for bottom sheet
        _this2.selectedItems = [];
        if (tmpSelItems.length > 1) {
          var tmpIdx = 0;
          _this2.bottomMenuReqOrder.forEach(function (rec) {
            tmpIdx = tmpSelItems.findIndex(function (curItem) {
              return curItem.text === rec;
            });
            if (tmpIdx >= 0) {
              _this2.selectedItems.push(tmpSelItems[tmpIdx]);
            }
          });
        }

        // set flag to show menu
        _this2.loggedAlready = true;

        // and go to dashboard / payments page if call back received from PG
        if (_this2.$router.currentRoute.path.includes('/dashboard')) {
          /* helps to catch the event when user wants to change his community
          when he is associated to more than one community. Refresh the dashboard accordingly */
          _this2.$router.push('/dashboard/' + __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.COMM_ID);
        } else if (_this2.$router.currentRoute.path.includes('invpay/pgcallback')) {
          _this2.$router.push(_this2.$router.currentRoute.path);
        } else {
          if (__WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.ROLE_NAME.toLowerCase().includes('security')) {
            // helps security to directly go to visitors screen
            _this2.$router.push('/visitors/');
          } else {
            _this2.$router.push('/dashboard/');
          }

          // prompt for push subscription if needed as user might be visiting this app first time
          _this2.checkForPushSubsciption().then(function (sub) {
            if (sub) {
              _this2.updateSubscriptionOnServer(sub);
            } else {
              // show the app specific dialog for push subscription
              _this2.dlgPush = true;
            }
          }).catch(function (err) {
            console.log(err);
          });
        }
      }).catch(function (error) {
        alert(error.response.data);
        return;
      });
    },
    loadComm: function loadComm(curComm) {
      var _this3 = this;

      // remember last used community
      __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.LAST_COMM_ID = curComm.comm_id;
      localStorage.setItem('LAST_COMM_ID', __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.LAST_COMM_ID);

      // load community global config
      this.choosenComm = curComm.comm_name;
      __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.COMM_ID = curComm.comm_id;
      __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.COMM_NAME = curComm.comm_name;
      __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.COMM_COUNTRY_CODE = curComm.country_code;
      __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.CURRENCY = curComm.currency_symbol;
      __WEBPACK_IMPORTED_MODULE_6__utils_handy___default.a.COMM_COUNTRY_CODE = curComm.country_code;
      __WEBPACK_IMPORTED_MODULE_6__utils_handy___default.a.CURRENCY = curComm.currency_symbol;
      __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.IS_TAX_APP = curComm.is_tax_app;
      __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.IS_INV_CLASS = curComm.is_inv_class;
      __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.TAX_INV_CLASS = curComm.tax_inv_class;
      __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.NON_TAX_INV_CLASS = curComm.non_tax_inv_class;
      __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.TAX_INV_CLASS_CHAR = 'T';
      __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.NON_TAX_INV_CLASS_CHAR = 'N';
      __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.IS_COVID_CHECK_ENABLED = curComm.is_covid_check_enabled;
      __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.IS_BACKOFFICE_COMM = curComm.is_backoffice_comm;
      // notification settings
      __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.SMS_FOR_EASYPASS = curComm.sms_for_easypass;

      // users role in this community
      __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.IS_OTHER_USER = curComm.is_other_user === 1;
      __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.ROLE_NAME = curComm.role_name;
      __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.IS_MC_MEMBER = curComm.is_mc_member === 1;
      __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.IS_ADMIN = curComm.is_admin === 1;
      __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.IS_USER_ACTIVE = curComm.is_active === 1;
      __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.HIDE_CONTACT = curComm.hide_contact === 1;

      // users units
      __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.ALL_UNITS = [{}];
      __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.UNITS = [{}];
      __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.UNIT_ID_LIST = [];
      __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.USER_HAS_MORE_UNITS = false;
      __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.PRIVATE_UNITS = [];
      __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.PRIVATE_UNIT_ID_LIST = [];
      __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.USER_HAS_MORE_PRIVATE_UNITS = false;
      if (curComm.rel_status_list && !curComm.rel_status_list.includes('Linked')) {
        if (curComm.rel_status_list.includes('Pending Approval')) {
          alert('Your joining request is currently pending for approval, please come back later once it is approved');
        } else {
          alert('Sorry, you are currently delinked from this community, please contact your admin if you do not expect to see this message');
        }
        this.loadMenu(true);
        return;
      }
      if (!__WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.IS_OTHER_USER) {
        // users unit (one or more in this community)
        this.axios.get(__WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.API_URL + '/getUnitsByUserId/' + __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.USER_ID + '/' + __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.COMM_ID).then(function (response) {
          __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.ALL_UNITS = response.data;
          __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.UNITS = __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.ALL_UNITS.filter(function (rec) {
            return rec.rel_status === 'Linked';
          });
          // check user has more than one unit in this community
          __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.USER_HAS_MORE_UNITS = __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.UNITS.length > 1;
          if (__WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.UNITS.length) {
            __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.UNIT_ID_LIST = __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.UNITS.map(function (rec) {
              return rec.unit_id;
            });
          }

          // list of units which needs privacy (used mostly in security module)
          __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.UNITS.forEach(function (unit) {
            if (unit.is_rented) {
              if (unit.ownership.toLowerCase().includes('tenant')) {
                // rented units are private to tenants
                __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.PRIVATE_UNITS.push(unit);
              }
            } else {
              // not-rented, not private to anyone
              __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.PRIVATE_UNITS.push(unit);
            }
          });
          __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.PRIVATE_UNIT_ID_LIST = __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.PRIVATE_UNITS.map(function (rec) {
            return rec.unit_id;
          });
          __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.USER_HAS_MORE_PRIVATE_UNITS = __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.PRIVATE_UNIT_ID_LIST.length > 1;

          // check for atleast one linked unit
          __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.IS_USER_LINKED = __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.UNITS.length > 0;
          __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.IS_USER_EMPOWERED = __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.IS_ADMIN || __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.IS_FM || curComm.role_name === 'Helpdesk Executive';
          _this3.loadMenu();
        }).catch(function (error) {
          alert(error.response.data);
          return;
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.IS_FM = curComm.role_name.includes('Facility Manager');
        __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.UNITS[0].rel_status = curComm.rel_status_if_other_user;
        __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.UNITS[0].rej_reason = curComm.rej_reason_if_other_user;
        __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.UNITS[0].ownership = '';
        __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.ALL_UNITS = __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.UNITS;
        __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.UNIT_ID_LIST = [];
        __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.IS_USER_LINKED = curComm.rel_status_if_other_user === 'Linked';
        __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.IS_USER_EMPOWERED = __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.IS_ADMIN || __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.IS_FM || curComm.role_name === 'Helpdesk Executive';
        this.loadMenu();
      }

      // get community subscriptions and settings
      var qry = {
        params: {
          user_id: __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.USER_ID,
          comm_id: __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.COMM_ID
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.API_URL + '/getCommSubscriptions/', qry).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.COMM_CONFIG = response.data[0];
        console.log(__WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.COMM_CONFIG);
      });

      // get the vendor id if the vendor who manages this community uses Smartility BackBone
      this.axios.get(__WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.API_URL + '/getCommFMVendorWithBB/' + __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.USER_ID + '/' + __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.COMM_ID).then(function (response) {
        if (response.data.length) {
          __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.FM_VENDOR_ID = response.data[0].vendor_id;
          __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.FM_VENDOR_NAME = response.data[0].vendor_name;
          __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.IS_BB_VENDOR = true;
        } else {
          __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.FM_VENDOR_ID = 1; // default vendor is uniservice for fm module's config purpose
          __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.FM_VENDOR_NAME = '';
          __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.IS_BB_VENDOR = false;
        }
      });
    },

    // function to check for valid push subscription
    checkForPushSubsciption: function checkForPushSubsciption() {
      return navigator.serviceWorker.getRegistrations().then(function (regs) {
        if (regs.length) {
          return regs[0].pushManager.getSubscription();
        } else {
          throw Error('Service worker is not installed yet');
        }
      });
    },
    reqBrowserPromptForPush: function reqBrowserPromptForPush() {
      // hide the app specific custom dialog abd show the browser prompt
      this.dlgPush = false;
      this.updateSubscriptionOnServer();
    },
    updateSubscriptionOnServer: function updateSubscriptionOnServer() {
      var _this4 = this;

      var subs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!subs) {
        // get fresh subscription along with permission from user
        console.log('Getting fresh push subscription');
        this.askPermission().then(function (res) {
          try {
            var subscribeOptions = {
              userVisibleOnly: true,
              applicationServerKey: _this4.urlB64ToUint8Array('BM-8M9QH1g6T9RerpYi4rY8L3n_NG9oinXge1PahtYlrW4_fmlYZYUgem4_w6MLdZzRdxVTj9k5YFiyfKXUXHbw')
            };
            navigator.serviceWorker.getRegistrations().then(function () {
              var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(regs) {
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return regs[0].pushManager.subscribe(subscribeOptions);

                      case 2:
                        subs = _context.sent;

                        _this4.sendSubscription(subs, 'granted');

                      case 4:
                      case 'end':
                        return _context.stop();
                    }
                  }
                }, _callee, _this4);
              }));

              return function (_x3) {
                return _ref.apply(this, arguments);
              };
            }());
          } catch (e) {
            console.log('Error subscribing for push:', e);
            _this4.sendSubscription(subs, 'error');
          }
        }).catch(function (err) {
          // user either skipped or blocked notification.
          _this4.sendSubscription(subs, err.message);
        });
      } else {
        // associate with existing subscription
        console.log('Associating existing subscription to this user');
        this.sendSubscription(subs, 'granted');
      }
    },
    askPermission: function askPermission() {
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var permissionResult = Notification.requestPermission(function (result) {
          resolve(result);
        });
        if (permissionResult) {
          permissionResult.then(resolve, reject);
        }
      }).then(function (permissionResult) {
        if (permissionResult !== 'granted') {
          throw new Error(permissionResult);
        }
      });
    },
    sendSubscription: function sendSubscription(subs, subStatus) {
      if (subStatus === 'denied') {
        alert('It seems you had denied the permission earlier,\nIn Mobile: Go to settings->Apps->Integra app->Notification->Unblock\nIn Desktop: Go to browser\'s settings->Advanced->Privacy and security->Site settings->Notifications->Enable notifications for Integra App');
      }
      console.log('Sending subscription to server:' + subStatus);
      var req = {
        user_id: __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.USER_ID,
        push_channel: 'W',
        push_sub: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(subs),
        user_device_id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_auth__["d" /* getUserDevId */])(),
        sub_status: subStatus
      };
      __WEBPACK_IMPORTED_MODULE_8_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.API_URL + '/push-sub/', req).catch(function (err) {
        console.log('Error storing subscription:', err.response.data);
      });
    },
    urlB64ToUint8Array: function urlB64ToUint8Array(base64String) {
      var padding = '='.repeat((4 - base64String.length % 4) % 4);
      var base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');

      var rawData = atob(base64);
      var outputArray = new Uint8Array(rawData.length);

      for (var i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
      }
      return outputArray;
    },
    isExternalMenuItem: function isExternalMenuItem(item, parent) {
      // Matches either the "Admin's Corner" item itself (its own activator row, or the
      // single synthetic bottom-nav shortcut), or one of its children (Users, Roles &
      // Access, Notification Log) — those only carry their own text, so we also need
      // to know their parent group to recognize they belong to Admin's Corner.
      return item.text === 'Admin\'s Corner' || !!parent && parent.text === 'Admin\'s Corner';
    },
    handleMenuClick: function handleMenuClick(item, parent) {
      if (!this.isExternalMenuItem(item, parent)) {
        return;
      }
      var childWindow = window.open(__WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.ADMIN_CORNER_URL, '_blank');
      if (!childWindow) {
        return;
      }
      var targetOrigin = new URL(__WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.ADMIN_CORNER_URL).origin;
      var handleReactReady = function handleReactReady(event) {
        if (event.origin !== targetOrigin || !event.data || event.data.type !== 'REACT_READY') {
          return;
        }
        childWindow.postMessage({
          type: 'VUE_AUTH_PAYLOAD',
          payload: {
            token: __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.API_KEY,
            comm_id: __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.COMM_ID,
            user_id: __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.USER_ID
          }
        }, targetOrigin);
        window.removeEventListener('message', handleReactReady);
      };
      window.addEventListener('message', handleReactReady);
    },
    saveTrackScreenAccess: function saveTrackScreenAccess(curItem) {
      curItem.vendor_id = __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.FM_VENDOR_ID;
      curItem.user_id = __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.USER_ID;
      curItem.comm_id = __WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.COMM_ID;
      curItem.screen_id = curItem.screen_no;
      curItem.is_sv_user = false;
      this.axios.post(__WEBPACK_IMPORTED_MODULE_5__config_app_cfg___default.a.API_URL + '/trackScreenAccess/', curItem).then(function (response) {}).catch(function (err) {
        alert(err);
      });
    }
  }
});

/***/ }),

/***/ 457:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_app_cfg__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_handy__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_handy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__utils_handy__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      sbar: false,
      sbarCol: 'error',
      beingSaved: false,
      tab: 'tab-0',
      sbarMsg: '',
      lCompAdr: '',
      lCatList: '',
      lAction: '',
      lCompSla: '',
      lCompSlaEsc: '',
      handy: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a,
      rules: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.rules,
      noSlaFound: false,
      noSlaEscFound: false,
      tabitems: ['General', 'SLA'],
      catSet: [{ text: 'Service', value: 'comp_cat' }],
      catList: [],
      isHDPresent: false,
      isFMPresent: false
    };
  },
  created: function created() {
    this.loadCompSet();
    this.loadCatList();
  },
  mounted: function mounted() {
    this.lAction = 'view';
  },

  methods: {
    msg: function msg(m) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (type === 0) {
        this.sbarCol = 'error';
      } else if (type === 1) {
        this.sbarCol = 'success';
      } else {
        this.sbarCol = 'info';
      }
      this.sbar = true;
      this.sbarMsg = m;
    },
    refreshData: function refreshData() {
      if (this.tab === 'tab-0') {
        this.loadCompSet();
        this.loadCatList();
      } else {
        this.loadSlaHours();
        this.loadSlaEscLevels();
      }
    },
    loadCompSet: function loadCompSet() {
      var _this = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID
        }
        // is help desk available for community
      };this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/isHelpDeskAvailableForCommunity/', qry).then(function (response) {
        if (response.data[0].total) {
          _this.isHDPresent = true;
        } else {
          _this.isHDPresent = false;
        }
      });
      // is fm available for community
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/isFMAvailableForCommunity/', qry).then(function (response) {
        if (response.data[0].total) {
          _this.isFMPresent = true;
        } else {
          _this.isFMPresent = false;
        }
      });
      // complaint settings
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getCompSetByCommId/', qry).then(function (response) {
        _this.lCompAdr = response.data[0];
      }).catch(function (err) {
        _this.msg(err.response.data);
      });
    },
    saveCompSet: function saveCompSet() {
      var _this2 = this;

      if (this.lCompAdr.is_hd_enabled || this.lCompAdr.is_fm_enabled || this.lCompAdr.is_mc_enabled || this.lCompAdr.is_res_enabled) {
        this.axios.post(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/category/settings', this.lCompAdr).then(function (response) {
          // refresh the category address
          _this2.loadCompSet();
          _this2.$forceUpdate();
        }).catch(function (err) {
          _this2.msg(err.response.data);
        });
      } else {
        this.msg('Atleast one option needs to be enabled', 2);
        // refresh the category address
        this.loadCompSet();
      }
    },
    loadCatList: function loadCatList() {
      var _this3 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getCompCatListByCommId/', qry).then(function (response) {
        _this3.catList = response.data;
      }).catch(function (err) {
        _this3.msg(err.response.data);
      });
    },
    prepareCreate: function prepareCreate() {
      this.lCompCat = {
        comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
        comp_cat: ''
      };
      this.lAction = 'create';
    },
    prepareEdit: function prepareEdit(curCat) {
      this.lCompCat = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, curCat); // keep the original object safely before changes
      this.lAction = 'update';
    },
    cancelChanges: function cancelChanges() {
      if (this.action) {
        // in case come from different parent page, go there
        this.$router.go(-1);
      } else {
        this.lAction = 'view';
      }
    },
    saveChanges: function saveChanges() {
      var _this4 = this;

      if (!this.$refs.lForm.validate()) {
        return;
      }
      this.axios.post(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/category/' + this.lAction, this.lCompCat).then(function (response) {
        // refresh the Category list
        if (_this4.lAction === 'create') {
          _this4.lCompCat.comp_cat_id = response.data;
          _this4.catList.push(_this4.lCompCat);
        } else {
          var idx = _this4.catList.findIndex(function (rec) {
            return rec.comp_cat_id === _this4.lCompCat.comp_cat_id;
          });
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this4.catList[idx], _this4.lCompCat);
        }
        _this4.lAction = 'view';
        _this4.beingSaved = false;
      }).catch(function (err) {
        _this4.msg(err.response.data);
        _this4.beingSaved = false;
      });
    },
    deleteCat: function deleteCat(curCat) {
      var _this5 = this;

      if (!confirm('Sure, you want to delete the Category "' + curCat.comp_cat + '"?')) {
        return;
      }
      // up in db
      this.beingSaved = true;
      this.axios.post(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/category/delete', curCat).then(function (response) {
        // refresh the list
        var idx = _this5.catList.findIndex(function (rec) {
          return rec.comp_cat_id === _this5.lCompCat.comp_cat_id;
        });
        _this5.catList.splice(idx, 1);
        _this5.lAction = 'view';
        _this5.beingSaved = false;
      }).catch(function (err) {
        _this5.msg(err.response.data);
        _this5.beingSaved = false;
      });
    },
    loadSlaHours: function loadSlaHours() {
      var _this6 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getSlaHoursByCommId/', qry).then(function (response) {
        if (response.data.length === 0) {
          _this6.noSlaFound = true;
          _this6.lCompSla = {
            sla_critical: '',
            sla_major: '',
            sla_normal: '',
            comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID
          };
        } else {
          _this6.lCompSla = response.data[0];
          _this6.noSlaFound = false;
        }
      }).catch(function (err) {
        _this6.msg(err.response.data);
      });
    },
    saveChangesSla: function saveChangesSla() {
      var _this7 = this;

      var action = this.noSlaFound ? 'create-sla' : 'update-sla';
      this.axios.post(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/sla/' + action, this.lCompSla).then(function (response) {
        if (action === 'create-sla') {
          _this7.noSlaFound = false;
        }
        _this7.msg('Saved successfully', 1);
      }).catch(function (err) {
        _this7.msg(err.response.data);
      });
    },
    loadSlaEscLevels: function loadSlaEscLevels() {
      var _this8 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getSlaEscLevelsByCommId/', qry).then(function (response) {
        if (response.data.length === 0) {
          _this8.noSlaEscFound = true;
          _this8.lCompSlaEsc = {
            l1_phone_list: '',
            l1_sms_enabled: false,
            l1_email_list: '',
            l2_phone_list: '',
            l2_sms_enabled: false,
            l2_email_list: '',
            comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID
          };
        } else {
          _this8.lCompSlaEsc = response.data[0];
          _this8.noSlaEscFound = false;
        }
      }).catch(function (err) {
        _this8.msg(err.response.data);
      });
    },
    saveChangesSlaEsc: function saveChangesSlaEsc() {
      var _this9 = this;

      var action = this.noSlaEscFound ? 'create-sla-esc' : 'update-sla-esc';
      this.axios.post(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/sla/' + action, this.lCompSlaEsc).then(function (response) {
        if (action === 'create-sla-esc') {
          _this9.noSlaEscFound = false;
        }
        _this9.msg('Saved successfully', 1);
      }).catch(function (err) {
        _this9.msg(err.response.data);
      });
    }
  }
});

/***/ }),

/***/ 458:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_app_cfg__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_handy__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_handy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__utils_handy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_chartjs_plugin_datalabels__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_chartjs_plugin_datalabels___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_chartjs_plugin_datalabels__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var Chart = __webpack_require__(111);

var html2pdf = __webpack_require__(167);

var COLORS = ['227,108,9', '49,133,155', '95,73,122', '118,146,60', '149,55,52', '54,96,146', '23,54,93', '73,68,41'];

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['action'],
  data: function data() {
    return {
      // common
      sbar: false,
      sbarCol: 'error',
      sbarMsg: '',
      config: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a,
      handy: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a,
      lReport: {},
      // Attendance
      attHead: [],
      attList: [],
      // complaint
      compHead: [{ text: 'Category', value: 'comp_cat', class: 'font px-2 primary white--text text-xs-center', sortable: false }, { text: 'Previous Pending', value: 'prev_pend', class: 'font px-2 primary white--text text-xs-center', sortable: false }, { text: 'Today’s New', value: 'new_today', class: 'font px-2 primary white--text text-xs-center', sortable: false }, { text: 'Reopened Today', value: 'reop_today', class: 'font px-2 primary white--text text-xs-center', sortable: false }, { text: 'Closed Today', value: 'closed_today', class: 'font px-2 primary white--text text-xs-center', sortable: false }, { text: 'Closing Balance', value: 'closing_bal', class: 'font px-2 primary white--text text-xs-center', sortable: false }],
      compList: [],
      // water quality
      paramHead: [],
      paramList: [],
      // water sources
      domWatList: [],
      // custom Metrics
      lMet: {},
      metHead: [{ text: 'Metric Name', value: 'metric_nm', width: '300px', class: 'font primary white--text', sortable: false }, { text: 'Value', value: 'metric_val', width: '100px', class: 'font primary white--text', sortable: false }],
      metricList: [],
      // DG
      lGenset: {},
      gensetHead: [{ text: 'Genset', value: 'genset_nm', class: 'font primary white--text pl-2 pr-0', sortable: false }, { text: 'Units(KWH)', value: 'units_cons', class: 'font primary white--text px-0', sortable: false }, { text: 'Diesel Level (%)', value: 'level', class: 'font primary white--text px-0', sortable: false }, { text: 'Running Hours', value: 'run_hrs', class: 'font primary white--text px-0', sortable: false }],
      gensetList: [],
      dieselHead: [{ text: 'Metric', value: 'diesel_nm', class: 'font primary white--text', sortable: false }, { text: 'Quantity (ltr)', value: 'val', class: 'font primary white--text', sortable: false }],
      dieselList: [],
      lgen: {},
      // Hygiene
      hygList: [],
      hygCats: {},
      // incident
      incidentList: [],
      incidentTypes: {},
      // comm values
      nodata: false,
      // for chart
      tmpChart: [],
      // ppm planner
      ppmHeader: [{ text: 'Asset Tag', values: 'asset_tag', class: 'primary white--text py-0' }, { text: 'Category', values: 'asset_cat', class: 'primary white--text py-0' }, { text: 'Non Equipment', values: 'noneq_nm', class: 'primary white--text py-0' }, { text: 'Frequency', values: 'freq', class: 'primary white--text py-0' }, { text: 'Location', values: 'asset_location', class: 'primary white--text py-0' }, { text: 'PPM Activity Status', values: 'asset_status', class: 'primary white--text py-0' }],
      lPpmHeader: [],
      // photos
      lDailyUpdateAttach: {
        files: []
      },
      // Compliance
      complianceData: {
        active: 0,
        expiring: 0,
        expired: 0,
        total: 0
      },
      expiredComplianceList: []
    };
  },
  mounted: function mounted() {
    this.lReport.rep_date = __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDate(this.action);
    this.lReport.comm_name = __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_NAME;
    this.loadAttReport();
    this.loadRemark();
    this.loadComplianceData();
    this.loadCompReport();
    this.loadPowerConsPieChart();
    this.loadPowerGensetPieChart();
    this.loadWaterLevelChart();
    this.loadWaterConsChart();
    this.loadWaterSources();
    this.loadWaterQualChart();
    this.loadMetricCat();
    this.loadTaskReport();
    this.loadGenset();
    this.loadWasteChart();
    this.loadHygieneCat();
    this.loadIncidentClass();
    this.loadPpmPlanner();
    this.loadFacDailyUpdateAttachment();
  },

  methods: {
    msg: function msg(m) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (type === 0) {
        this.sbarCol = 'error';
      } else if (type === 1) {
        this.sbarCol = 'success';
      } else {
        this.sbarCol = 'info';
      }
      this.sbar = true;
      this.sbarMsg = m;
    },
    loadAttReport: function loadAttReport() {
      var _this = this;

      var qry = {
        params: {
          from_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.action),
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID
        }
      };
      this.lReport.attAve = 0;
      var attVal = {
        tot_staff: 0,
        tot_present: 0,
        tot_hd: 0,
        tot_ot: 0,
        tot_wo: 0,
        tot_holiday: 0,
        tot_standBy: 0
      };
      this.lReport.roleCat = {};
      this.lReport.attHeader = [];
      this.lReport.tot_staff = 0;
      this.lReport.tot_present = 0;
      this.lReport.tot_ot = 0;
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getAttendanceDailyRep/', qry).then(function (response) {
        // total attendance in percentage
        _this.lReport.roleCat = __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.unique(response.data.map(function (rec) {
          return rec.role_cat;
        }));
        response.data.forEach(function (rec) {
          attVal.tot_staff += rec.role_count;
          attVal.tot_present += rec.tot_present + Number(rec.tot_hd / 2);
          attVal.tot_ot += rec.tot_ot;
          attVal.tot_wo += rec.tot_wo;
          attVal.tot_holiday += rec.tot_holiday;
          attVal.tot_standBy += rec.tot_standBy;
        });
        _this.lReport.tot_staff = attVal.tot_staff;
        _this.lReport.tot_present = attVal.tot_present;
        _this.lReport.tot_ot = attVal.tot_ot;
        _this.lReport.roleCat.forEach(function (rec) {
          _this.attList.push({
            role_cat: rec,
            attendance: []
          });
          _this.lReport.attHeader.push({
            role_cat: rec,
            attHead: []
          });
        });
        for (var i = 0; i < response.data.length; i++) {
          for (var j = 0; j < _this.attList.length; j++) {
            if (response.data[i].role_cat === _this.attList[j].role_cat) {
              _this.attList[j].attendance.push({
                tot_present: response.data[i].tot_present + Number(response.data[i].tot_hd / 2) + (response.data[i].tot_ot ? ' + ' + Number(response.data[i].tot_ot + (response.data[i].tot_standBy || 0)) : response.data[i].tot_standBy ? ' + ' + response.data[i].tot_standBy : 0) + ' / ' + Number(response.data[i].role_count),
                tot_wo: response.data[i].tot_wo,
                tot_holiday: response.data[i].tot_holiday,
                tot_leave: response.data[i].tot_leave,
                tot_hd: response.data[i].tot_hd,
                tot_absent: response.data[i].tot_absent
              });
            }
          }
          for (var k = 0; k < _this.lReport.attHeader.length; k++) {
            if (response.data[i].role_cat === _this.lReport.attHeader[k].role_cat) {
              _this.lReport.attHeader[k].attHead.push({
                short_form: response.data[i].short_form
              });
            }
          }
        }
        _this.lReport.attAve = Math.round((attVal.tot_present + attVal.tot_ot + attVal.tot_standBy + attVal.tot_wo + attVal.tot_holiday) / attVal.tot_staff * 100);
        _this.$forceUpdate();
      }).catch(function (err) {
        _this.msg(err, true);
      });
    },
    loadRemark: function loadRemark() {
      var _this2 = this;

      var qry = {
        params: {
          from_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.action),
          to_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.action),
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getRemarksBasedOnCommId/', qry).then(function (response) {
        if (response.data.length > 0) {
          _this2.lReport.remark_attendance = response.data[0].remark_attendance;
          _this2.lReport.remark_water = response.data[0].remark_water;
          _this2.lReport.remark_power = response.data[0].remark_power;
          _this2.lReport.remark_sanity_checks = response.data[0].remark_sanity_checks;
          _this2.lReport.remark_custom_metrics = response.data[0].remark_custom_metrics;
          _this2.lReport.major_observ = response.data[0].major_observ;
        }
      }).catch(function (err) {
        _this2.msg(err, true);
      });
    },
    loadCompReport: function loadCompReport() {
      var _this3 = this;

      var qry = {
        params: {
          from_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.action),
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getComplianceDashboard/overall/data/', qry).then(function (response) {
        _this3.compList = response.data;
      }).catch(function (err) {
        _this3.msg(err, true);
      });
    },
    loadComplianceData: function loadComplianceData() {
      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getComplianceDashboard/overall/data', qry).then(function (response) {
        this.complianceData.active = response.data.summary.activeCount || 0;
        this.complianceData.expiring = response.data.summary.aboutToExpireCount || 0;
        this.complianceData.expired = response.data.summary.expiredCount || 0;
        this.complianceData.total = this.complianceData.active + this.complianceData.expiring + this.complianceData.expired;
        this.expiredComplianceList = response.data.data.expired || [];
      }.bind(this)).catch(function (err) {
        this.msg(err, 0);
      }.bind(this));
    },
    loadPowerConsPieChart: function loadPowerConsPieChart() {
      var _this4 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
          from_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.action),
          to_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.action)
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getPowerMeterDailyRep/', qry).then(function (response) {
        var resObj = response.data;
        var areaLbl = [];
        var unitConsVal = [];
        _this4.lReport.eb_unit = 0;
        // pie chart
        for (var i = 0; i < resObj.length; i++) {
          areaLbl[i] = resObj[i].area_covered;
          unitConsVal[i] = 0;
          if (!resObj[i].unit_cons) {
            resObj[i].unit_cons = 0;
          }
          unitConsVal[i] += Number(resObj[i].unit_cons.toFixed(2));
          _this4.lReport.eb_unit += Number(resObj[i].unit_cons.toFixed(2));
        }
        var totZero = 0;
        for (i = 0; i < unitConsVal.length; i++) {
          if (unitConsVal[i] === 0) {
            totZero++;
          }
        }
        if (totZero === unitConsVal.length) {
          _this4.nodata = true;
        } else {
          _this4.nodata = false;
        }
        // chart 1
        // clear the content if any
        if (_this4.nodata) {
          setTimeout(function () {
            document.getElementById('div_powercons').innerHTML = 'No data available, check location and area covered configuration';
          }, 500);
          _this4.$forceUpdate();
        } else {
          setTimeout(function () {
            document.getElementById('div_powercons').innerHTML = '<canvas id="chart_powercons"></canvas>';
            var canvas = document.getElementById('chart_powercons');
            var ctx = canvas.getContext('2d');
            ctx.canvas.height = areaLbl.length * 2.5;
            ctx.canvas.width = areaLbl.length * 7;
            _this4.tmpChart = new Chart(ctx, {
              type: 'pie',
              data: {
                labels: areaLbl,
                datasets: [{
                  backgroundColor: ['#e36c09', '#31859b', '#5f497a', '#76923c', '#953734', '#366092', '#17365d', '#494429', '#5f4170', '#4c646e'],
                  data: unitConsVal
                }]
              },
              options: {
                plugins: {
                  datalabels: {
                    formatter: function formatter(value) {
                      return value;
                    },
                    color: '#ffffff'
                  }
                },
                title: {
                  display: true,
                  text: 'Electricity Board (Units)'
                },
                legend: {
                  position: 'right'
                }
              }
            });
          }, 500);
          _this4.$forceUpdate();
        }
      }).catch(function (err) {
        _this4.msg(err, 0);
      });
    },
    loadPowerGensetPieChart: function loadPowerGensetPieChart() {
      var _this5 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
          from_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.action),
          to_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.action)
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getPowerGensetPieChartByCommId/', qry).then(function (response) {
        var resObj = response.data;
        var gensetLbl = [];
        var unitConsVal = [];
        _this5.lReport.dg_unit = 0;
        // pie chart
        for (var i = 0; i < resObj.length; i++) {
          gensetLbl[i] = resObj[i].genset_nm;
          var unitVal = resObj[i].value;
          unitConsVal[i] = 0;
          for (var d = 0; d < unitVal.length; d++) {
            if (!unitVal[d].units_cons) {
              unitVal[d].units_cons = 0;
            }
            unitConsVal[i] += Number(unitVal[d].units_cons);
            _this5.lReport.dg_unit += unitConsVal[i];
          }
        }
        // chart 1
        // clear the content if any
        if (response.data.length === 0) {
          setTimeout(function () {
            document.getElementById('div_powergenset').innerHTML = 'No data available for DG';
          }, 500);
          _this5.$forceUpdate();
        } else if (_this5.lReport.dg_unit === 0) {
          setTimeout(function () {
            document.getElementById('div_powergenset').innerHTML = 'DGs were not run today';
          }, 500);
          _this5.$forceUpdate();
        } else {
          setTimeout(function () {
            document.getElementById('div_powergenset').innerHTML = '<canvas id="chart_powergenset"></canvas>';
            var canvas = document.getElementById('chart_powergenset');
            var ctx = canvas.getContext('2d');
            ctx.canvas.height = gensetLbl.length * 1.7;
            ctx.canvas.width = gensetLbl.length * 4.5;
            _this5.tmpChart = new Chart(ctx, {
              type: 'pie',
              data: {
                labels: gensetLbl,
                datasets: [{
                  backgroundColor: ['#e36c09', '#31859b', '#5f497a', '#76923c', '#953734', '#366092', '#17365d', '#494429'],
                  data: unitConsVal
                }]
              },
              options: {
                plugins: {
                  datalabels: {
                    formatter: function formatter(value) {
                      return value;
                    },
                    color: '#ffffff'
                  }
                },
                title: {
                  display: true,
                  text: 'Genset (Units)'
                },
                legend: {
                  position: 'right'
                }
              }
            });
          }, 500);
          _this5.$forceUpdate();
        }
      }).catch(function (err) {
        _this5.msg(err, 0);
      });
    },
    loadWaterLevelChart: function loadWaterLevelChart() {
      var _this6 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
          from_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.action) + ' 00:00:00',
          to_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.action) + ' 23:59:59'
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getWaterLevelChartDetailsByCommId/', qry).then(function (response) {
        // retrive data from db and construct chart
        var resObj = response.data;
        var watTypeLbl = [];
        var levelVal = {};
        var gw = 0;
        var dtLbl = []; // for trend chart
        var waterLvlKl = {};
        var gd = 0;
        var idx = 0;
        for (var i = 0; i < resObj.length; i++) {
          watTypeLbl[gw] = resObj[i].storage_nm;
          levelVal[gw] = [];
          idx = gw++;
          var lvl = resObj[i].levels;
          for (var d = 0; d < lvl.length; d++) {
            if (lvl[d].water_level === '') {
              lvl[d].water_level = 0;
            }
            var didx = dtLbl.indexOf(__WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDate(lvl[d].c_date));
            if (didx < 0 && lvl[d].c_date) {
              dtLbl[gd] = __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDate(lvl[d].c_date);
              didx = gd++;
            }
            if (dtLbl[didx] === __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDate(_this6.action)) {
              if (lvl[d].water_level) {
                levelVal[idx][i] = lvl[d].water_level; // show specific data for the day in first graph in case of single date
              }
              if (lvl[d].water_level_kl) {
                waterLvlKl[i] = lvl[d].water_level_kl + ' KL';
              }
            }
          }
        }
        // chart 1
        // data set
        var value = [];
        for (i = 0; i < watTypeLbl.length; i++) {
          value.push(levelVal[i][i]);
        }
        var totZero = 0;
        for (i = 0; i < value.length; i++) {
          if (value[i] === 0) {
            totZero++;
          }
        }
        if (totZero === value.length) {
          _this6.nodata = true;
        } else {
          _this6.nodata = false;
        }
        if (_this6.nodata) {
          setTimeout(function () {
            document.getElementById('div_waterlevel').innerHTML = 'No data available';
          }, 500);
          _this6.$forceUpdate();
        } else {
          // clear the content if any
          document.getElementById('div_waterlevel').innerHTML = '<canvas id="chart_waterlevel"></canvas>';
          var canvas = document.getElementById('chart_waterlevel');
          canvas.height = watTypeLbl.length > 4 ? watTypeLbl.length * 18 : watTypeLbl.length * 42;
          var ctx = canvas.getContext('2d');
          _this6.tmpChart = new Chart(ctx, {
            type: 'horizontalBar',
            data: {
              labels: watTypeLbl,
              datasets: [{
                backgroundColor: 'rgba(' + COLORS[1] + ',0.7)',
                data: value,
                fill: true
              }]
            },
            options: {
              tooltips: { enabled: false },
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: false,
                position: 'bottom',
                labels: {
                  usePointStyle: true,
                  fontSize: 11
                }
              },
              scales: {
                xAxes: [{
                  ticks: {
                    beginAtZero: true,
                    min: 0
                  }
                }]
              },
              hover: {
                animationDuration: 0
              },
              plugins: {
                datalabels: {
                  formatter: function formatter(value) {
                    return value > 0 ? value + ' %' : '';
                  },
                  color: '#ffffff'
                }
              }
            }
          });
          _this6.$forceUpdate();
        }
      }).catch(function (err) {
        _this6.msg(err, 0);
      });
    },
    loadWaterConsChart: function loadWaterConsChart() {
      var _this7 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
          from_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.action) + ' 00:00:00',
          to_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.action) + ' 23:59:59',
          comingFrom: 'Report',
          vendor_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.FM_VENDOR_ID
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getWaterConsChartDetailsByCommId/', qry).then(function (response) {
        // retrive data from db and construct chart
        var resObj = response.data;
        var watTypeLbl = [];
        var recVal = {};
        var dtLbl = []; // for trend chart
        var didx = 0;
        var widx = 0;
        var modeLbl = ['Consumed (KL)'];
        recVal[0] = [];
        _this7.lReport.tot_water_cons = 0;
        for (var r = 0; r < resObj.length; r++) {
          var cons = resObj[r].cons;
          for (var d = 0; d < cons.length; d++) {
            didx = dtLbl.indexOf(__WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(cons[d].c_date));
            if (didx < 0 && cons[d].c_date) {
              didx = dtLbl.length;
              dtLbl[didx] = __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(cons[d].c_date);
            }
            widx = watTypeLbl.indexOf(resObj[r].storage_nm.substring(0, 10));
            if (widx < 0) {
              widx = watTypeLbl.length;
              watTypeLbl[widx] = resObj[r].storage_nm.substring(0, 10);
            }
            if (!recVal[0][widx]) {
              recVal[0][widx] = 0;
            }
            recVal[0][widx] += Number(cons[d].water_cons);
          }
        }
        // to do: when automated for mulitple timestamps on the same day
        // chart 1 (water receipt and cons)
        // data set
        var dsets = [];
        for (var i = 0; i < modeLbl.length; i++) {
          for (var j = 0; j < recVal[i].length; j++) {
            recVal[i][j] = recVal[i][j] > 0 ? recVal[i][j].toFixed(2) : '';
            _this7.lReport.tot_water_cons += Number(recVal[i][j]);
          }
          dsets[i] = {
            label: modeLbl[i],
            backgroundColor: 'rgba(' + COLORS[i] + ',0.7)',
            borderColor: 'rgba(' + COLORS[i] + ',1)',
            data: recVal[i],
            fill: true
          };
        }
        if (_this7.lReport.tot_water_cons) {
          _this7.nodata = false;
        } else {
          _this7.nodata = true;
        }
        if (_this7.nodata) {
          document.getElementById('div_watercons').innerHTML = 'No data available, check water consumption configuration';
        } else {
          // clear the content if any
          document.getElementById('div_watercons').innerHTML = '<canvas id="chart_watercons"></canvas>';
          var canvas = document.getElementById('chart_watercons');
          var ctx = canvas.getContext('2d');
          _this7.tmpChart = new Chart(ctx, {
            type: 'horizontalBar',
            data: {
              labels: watTypeLbl,
              datasets: dsets
            },
            options: {
              plugins: {
                datalabels: {
                  formatter: function formatter(value) {
                    return value || '';
                  },
                  color: '#fff'
                }
              },
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: false,
                position: 'bottom',
                labels: {
                  usePointStyle: true,
                  fontSize: 11
                }
              },
              scales: {
                xAxes: [{
                  ticks: {
                    beginAtZero: true
                  }
                }]
              }
            }
          });
        }
        _this7.$forceUpdate();
      }).catch(function (err) {
        _this7.msg(err, 0);
      });
    },
    loadWaterSources: function loadWaterSources() {
      var _this8 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
          c_date: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.action),
          from_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.action),
          to_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.action)
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getWaterSourcesByCommIdAndcDate/', qry).then(function (response) {
        if (response.data.length > 0) {
          _this8.domWatList = response.data;
        }
        _this8.$forceUpdate();
      }).catch(function (err) {
        _this8.msg(err, 0);
      });
    },
    loadWaterQualChart: function loadWaterQualChart() {
      var _this9 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
          from_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.action),
          to_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.action)
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getDailyWaterQualityByCommId/', qry).then(function (response) {
        // retrive data from db and construct chart
        var resObj = response.data;
        var paramLbl = [];
        var paramId = [];
        var paramUoM = [];
        var watTypeLbl = [];
        var qualVal = {};
        var stdValMin = [];
        var stdValMax = [];
        var widx = 0;
        var pidx = 0;
        var dtIdx = 1;
        for (var r = 0; r < resObj.length; r++) {
          pidx = paramId.indexOf(resObj[r].param_id);
          if (pidx < 0) {
            pidx = paramId.length;
            paramId[pidx] = resObj[r].param_id;
            paramLbl[pidx] = resObj[r].param_name;
            qualVal[pidx] = [];
          }
          widx = watTypeLbl.indexOf(resObj[r].water_type);
          if (widx < 0) {
            widx = watTypeLbl.length;
            watTypeLbl[widx] = resObj[r].water_type;
          }
          if (!qualVal[pidx][widx]) {
            qualVal[pidx][widx] = 0;
          }
          qualVal[pidx][widx] = Number(resObj[r].val);
          paramUoM[pidx] = resObj[r].uom;
          stdValMin[pidx] = Number(resObj[r].std_val_min);
          stdValMax[pidx] = Number(resObj[r].std_val_max);
        }
        // chart 1
        _this9.paramHead = [{ text: 'Water Type', value: 'water_qual', class: 'primary white--text text-xs-center py-0', sortable: false }];
        var minMax = '';
        for (var i = 0; i < paramLbl.length; i++) {
          if (stdValMin[i] && stdValMax[i]) {
            minMax = stdValMin[i] + ' to ' + stdValMax[i];
          } else if (stdValMin[i]) {
            minMax = 'min ' + stdValMin[i];
          } else {
            minMax = 'max ' + stdValMax[i];
          }
          // construct table headers dynamically
          _this9.paramHead.splice(dtIdx++, 0, {
            text: paramLbl[i] + '(' + paramUoM[i] + ') [' + minMax + ']', value: paramLbl[i], width: '160px', class: 'font pl-2 pr-0 py-0 text-xs-center white--text primary', sortable: false
          });
        }
        _this9.paramList = [];
        for (i = 0; i < watTypeLbl.length; i++) {
          if (stdValMin[i] && stdValMax[i]) {
            minMax = stdValMin[i] + ' to ' + stdValMax[i];
          } else if (stdValMin[i]) {
            minMax = 'min ' + stdValMin[i];
          } else {
            minMax = 'max ' + stdValMax[i];
          }
          _this9.paramList.push({
            water_qual: watTypeLbl[i] === 'SWIMMING POOL' ? 'S. POOL' : watTypeLbl[i],
            waterQualTypeValue: []
          });
        }
        // find ave
        for (i = 0; i < paramLbl.length; i++) {
          for (var j = 0; j < watTypeLbl.length; j++) {
            if (qualVal[i][j] && qualVal[i][j] !== '  ') {
              qualVal[i][j] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(qualVal[i][j]) || qualVal[i][j] > 50 ? qualVal[i][j].toFixed(0) : qualVal[i][j].toFixed(1);
            }
          }
        }

        // construct value table for each parameter
        for (j = 0; j < watTypeLbl.length; j++) {
          for (i = 0; i < paramLbl.length; i++) {
            _this9.paramList[j].waterQualTypeValue.push({
              val: qualVal[i][j] || '',
              stdValMin: stdValMin[i],
              stdValMax: stdValMax[i]
            });
          }
        }
      }).catch(function (err) {
        _this9.msg(err, 0);
      });
    },
    loadMetricCat: function loadMetricCat() {
      var _this10 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getMetricCatByCommId/', qry).then(function (response) {
        _this10.lMet = response.data.filter(function (rec) {
          return rec.metric_cat !== '';
        });
        _this10.loadMetric(__WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(_this10.action));
      }).catch(function (err) {
        _this10.msg(err, 0);
      });
    },
    loadMetric: function loadMetric(curDate) {
      var _this11 = this;

      var metCat = this.lMet.filter(function (rec) {
        return rec.metric_cat !== '';
      });
      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
          from_dt: curDate,
          to_dt: curDate,
          metric_cat: metCat.map(function (rec) {
            return rec.metric_cat;
          })
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getMetricByCommId/', qry).then(function (response) {
        _this11.metricList = response.data;
      }).catch(function (err) {
        _this11.msg(err, 0);
      });
    },
    loadTaskReport: function loadTaskReport() {
      var _this12 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
          from_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.action)
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getTaskReport/', qry).then(function (response) {
        var resObj = response.data;
        var statusLbl = [];
        var totTaskVal = [];
        // pie chart
        for (var i = 0; i < resObj.length; i++) {
          statusLbl[i] = resObj[i].task_status;
          if (!resObj[i].tot_task_status) {
            totTaskVal[i] = 0;
          } else {
            totTaskVal[i] = resObj[i].tot_task_status;
          }
        }
        var totZero = 0;
        for (i = 0; i < totTaskVal.length; i++) {
          if (totTaskVal[i] === 0) {
            totZero++;
          }
        }
        if (totZero === totTaskVal.length) {
          _this12.nodata = true;
        } else {
          _this12.nodata = false;
        }
        // chart 1
        // clear the content if any
        if (_this12.nodata) {
          setTimeout(function () {
            document.getElementById('div_task').innerHTML = 'No data available';
          }, 500);
          _this12.$forceUpdate();
        } else {
          setTimeout(function () {
            document.getElementById('div_task').innerHTML = '<canvas id="chart_task"></canvas>';
            var canvas = document.getElementById('chart_task');
            canvas.height = statusLbl.length * 23;
            canvas.width = statusLbl.length * 35;
            var ctx = canvas.getContext('2d');
            _this12.tmpChart = new Chart(ctx, {
              type: 'pie',
              data: {
                labels: statusLbl,
                datasets: [{
                  backgroundColor: ['#e36c09', '#31859b', '#5f497a', '#76923c', '#953734', '#366092', '#17365d', '#494429'],
                  data: totTaskVal
                }]
              },
              options: {
                plugins: {
                  datalabels: {
                    formatter: function formatter(value) {
                      return value || '';
                    },
                    color: '#ffffff'
                  }
                },
                title: {
                  display: false
                },
                legend: {
                  position: 'bottom'
                }
              }
            });
          }, 500);
          _this12.$forceUpdate();
        }
      }).catch(function (err) {
        _this12.msg(err, 0);
      });
    },
    loadGenset: function loadGenset() {
      var _this13 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
          c_date: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.action)
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getGensetByGensetId/', qry).then(function (response) {
        _this13.gensetList = response.data;
        _this13.lgen.totPurchasedStock = 0;
        _this13.lgen.totStock = 0;
        _this13.gensetList.forEach(function (rec) {
          _this13.lgen.totPurchasedStock += Number(rec.purchased);
          _this13.lgen.totStock += Number(rec.stock);
        });
        _this13.dieselList.push({
          diesel_nm: 'Diesel Purchased',
          val: _this13.lgen.totPurchasedStock || ''
        });
        _this13.dieselList.push({
          diesel_nm: 'Diesel Barrel Stock',
          val: _this13.lgen.totStock || ''
        });
      }).catch(function (err) {
        _this13.msg(err, 0);
      });
    },
    loadHygieneCat: function loadHygieneCat() {
      var _this14 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getSanCheckCatByCommId/', qry).then(function (response) {
        _this14.hygCats = response.data;
        _this14.loadHygiene();
      }).catch(function (err) {
        _this14.msg(err, true);
      });
    },
    loadHygiene: function loadHygiene() {
      var _this15 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
          from_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.action),
          to_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.action)
        }
      };
      this.hygList = [];
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getSanCheckByCommIdAndcDate/', qry).then(function (response) {
        _this15.hygList = response.data;
      }).catch(function (err) {
        _this15.msg(err, 0);
      });
    },
    loadIncidentClass: function loadIncidentClass() {
      var _this16 = this;

      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getIncidentClass/').then(function (response) {
        _this16.incidentTypes = __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.unique(response.data.map(function (rec) {
          return rec.incident_type;
        })).sort();
        _this16.loadIncidents();
      }).catch(function (err) {
        _this16.msg(err, true);
      });
    },
    loadIncidents: function loadIncidents() {
      var _this17 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
          from_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.action) + ' 00:00:00',
          to_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.action) + ' 23:59:59'
        }
      };
      this.incidentList = [];
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getIncidentListDailyRep/', qry).then(function (response) {
        if (response.data.length > 0) {
          _this17.incidentList = response.data;
        } else {
          _this17.incidentTypes.forEach(function (rec) {
            _this17.incidentList.push({
              incident_type: rec,
              incident_class: 'NIL'
            });
          });
        }
      }).catch(function (err) {
        _this17.msg(err, 0);
      });
    },
    loadPpmPlanner: function loadPpmPlanner() {
      var _this18 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
          from_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.action)
        }
      };
      this.lPpmHeader = [];
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getPpmPlannerListDailyRep/', qry).then(function (response) {
        _this18.lPpmHeader = response.data;
      }).catch(function (err) {
        _this18.msg(err, 0);
      });
    },
    loadFacDailyUpdateAttachment: function loadFacDailyUpdateAttachment() {
      var _this19 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
          from_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.action),
          to_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.action)
        }
      };
      this.lDailyUpdateAttach.files = [];
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getAttachmentByCDate/', qry).then(function (response) {
        _this19.lDailyUpdateAttach.files = response.data;
        _this19.$forceUpdate();
      }).catch(function (err) {
        _this19.msg(err.response.data, 0);
        _this19.lDailyUpdateAttach.files = [];
      });
    },
    downoadAsPdf: function downoadAsPdf() {
      // pdf options
      var opt = {
        margin: 14,
        filename: this.lReport.comm_name + '_Report_' + __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDate(this.action) + '.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { orientation: 'landscape' },
        pagebreak: { before: '#pageBreak' }
      };

      var canvas = document.getElementById('pdf_report');
      html2pdf(canvas, opt);
    },
    loadWasteChart: function loadWasteChart() {
      var _this20 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
          from_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.action),
          to_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.action)
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getWasteByCommIdAndcDate/', qry).then(function (response) {
        _this20.lWaste = response.data.filter(function (rec) {
          return __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(rec.c_date) === __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(_this20.fromDate);
        });
        var resObj = response.data;
        var wasteTypeLbl = [];
        var recVal = {};
        var dtLbl = []; // for trend chart
        var recAvgVal = {};
        var didx = 0;
        var widx = 0;

        recVal[0] = [];
        for (var r = 0; r < resObj.length; r++) {
          didx = dtLbl.indexOf(__WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(resObj[r].c_date));

          if (didx < 0 && resObj[r].c_date) {
            didx = dtLbl.length;
            dtLbl[didx] = __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(resObj[r].c_date);
          }

          widx = wasteTypeLbl.indexOf(resObj[r].waste_type);
          if (widx < 0) {
            widx = wasteTypeLbl.length;
            wasteTypeLbl[widx] = resObj[r].waste_type;
            recVal[widx] = [];
            recAvgVal[widx] = [];
          }
          if (_this20.aDay) {
            // show specefic data for the day in first graph in case of single date
            if (dtLbl[didx] === __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(_this20.fromDate)) {
              recVal[widx][0] = resObj[r].kgs;
            }
          } else {
            if (recVal[widx][0] === undefined) {
              recVal[widx][0] = 0;
            }
            recVal[widx][0] += Number(resObj[r].kgs);
          }
          // for trend
          if (recAvgVal[widx][didx] === undefined) {
            recAvgVal[widx][didx] = 0;
          }
          recAvgVal[widx][didx] += resObj[r].kgs;
        } // for every rec
        // chart 1
        // data set
        var dsets = [];
        var lColor = ['0,255,0', '0,0,255', '255,0,0'];
        for (var i = 0; i < wasteTypeLbl.length; i++) {
          dsets[i] = {
            label: wasteTypeLbl[i] + ' (kg)',
            backgroundColor: 'rgba(' + lColor[i] + ',0.4)',
            borderColor: 'rgba(' + lColor[i] + ',1)',
            data: recVal[i],
            fill: true
          };
        }
        // clear the content if any
        document.getElementById('div_waste').innerHTML = '<canvas id="chart_waste"></canvas>';
        var canvas = document.getElementById('chart_waste');
        var ctx = canvas.getContext('2d');
        _this20.tmpChart = new Chart(ctx, {
          type: 'horizontalBar',
          data: {
            labels: ['Wastage (kg)'],
            datasets: dsets
          },
          options: {
            plugins: {
              datalabels: {
                formatter: function formatter(value) {
                  return value + ' kg';
                },
                color: '#ffffff'
              }
            },
            responsive: true,
            maintainAspectRatio: false,
            legend: {
              display: true,
              position: 'bottom',
              labels: {
                usePointStyle: true,
                fontSize: 11
              }
            },
            scales: {
              xAxes: [{
                ticks: {
                  beginAtZero: true,
                  min: 0
                }
              }]
            },
            hover: {
              animationDuration: 0
            }
          }
        });
      });
    }
  }
});

/***/ }),

/***/ 459:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_app_cfg__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_auth__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_handy__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_handy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__utils_handy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_tel_input_vuetify__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_tel_input_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_tel_input_vuetify__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'vue-tel-input-vuetify': __WEBPACK_IMPORTED_MODULE_3_vue_tel_input_vuetify__["VueTelInputVuetify"]
  },
  data: function data() {
    return {
      config: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a,
      showDlg: true,
      curStep: 0,
      commNm: this.comm,
      commId: '',
      commAdr: '',
      commCity: '',
      commPIN: '',
      commState: '',
      commCountry: this.country,
      commCountryCode: this.countrycode,
      isNewComm: this.comm === '',
      sbar: false,
      sbarCol: 'error',
      sbarMsg: '',
      butCap: 'Continue',
      rules: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.rules,
      beingSaved: false,
      // step 1
      mobile: null,
      phone_country: null,
      isValidNumber: false,
      isOTPSent: false,
      otp: '',
      custId: '',
      userId: '',
      userHistory: [],
      isHavingHistory: false,
      cantChangeUnit: false,
      showTerms: false,
      canResend: false,
      secToWait: 0,
      timer: null,
      // step 2
      name: '',
      gender: '',
      email: '',
      mcOrOthers: 'resident',
      role: '',
      hideContact: false,
      isAdmin: true,
      roles: [],
      resRolesList: [],
      mcRolesList: [],
      staffRolesList: [],
      othersRolesList: [],
      // step 3
      blockId: '',
      blockList: [],
      blockNm: '',
      unitId: '',
      unitList: [],
      unitNo: '',
      ownership: '',
      isVerResident: false,
      isDuplicateUnit: false,
      showSimComm: false,
      justFocusIn: false,
      similarCommList: [],
      commNameHead: [{ text: 'Existing Community', value: 'comm_name', class: 'text-xs-center' }],
      // step 4
      regStatus: false
    };
  },

  props: ['comm', 'country', 'countrycode'],
  methods: {
    msg: function msg(m) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (type === 0) {
        this.sbarCol = 'error';
      } else if (type === 1) {
        this.sbarCol = 'success';
      } else {
        this.sbarCol = 'info';
      }
      this.sbar = true;
      this.sbarMsg = m;
    },
    closeDlg: function closeDlg() {
      this.showDlg = false;
      this.$emit('closed');
      // re-route to home page if successfully signed up
      if (this.curStep === 4) {
        this.$router.go('/');
      }
    },
    prevStep: function prevStep() {
      this.curStep--;
      this.butCap = 'Continue';
    },
    nextStep: function nextStep() {
      var _this = this;

      // validate current form and move on
      switch (this.curStep) {
        case 1:
          {
            if (!this.isValidNumber) {
              this.msg('Invalid mobile number');
              return;
            }
            // validate form
            if (this.$refs.form1.validate()) {
              // validate OTP
              this.axios.post(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.API_URL + '/otp/verify', { contact_phone: this.mobile, purpose: 'joining', otp: this.otp }).then(function (response) {
                _this.findUserHistory();
                _this.curStep++;
              }).catch(function (err) {
                _this.msg(err.response.data);
                return;
              });
            }
            break;
          }
        case 2:
          {
            if (this.$refs.form2.validate()) {
              this.butCap = 'Submit';
              this.curStep++;
            } else {
              return;
            }
            break;
          }
        case 3:
          {
            if (this.$refs.form3.validate() && !this.isDuplicateUnit || this.mcOrOthers === 'staff' || this.mcOrOthers === 'other-user') {
              // block and unit validation
              if (!this.isNewComm && this.mcOrOthers !== 'staff' && this.mcOrOthers !== 'other-user' && (!this.blockId || !this.unitId)) {
                this.msg('Choose block and unit from existing list');
                return;
              }
              // derive the role
              var relStatusIfOthers = null;

              if (this.mcOrOthers === 'staff' || this.mcOrOthers === 'other-user') {
                relStatusIfOthers = this.isAdmin ? 'Linked' : 'Pending Approval';
                this.isVerResident = false;
              } else if (this.mcOrOthers === 'resident') {
                this.role = this.ownership;
              }

              // create account
              var user = {
                'cust_name': this.name,
                'cust_id': this.custId,
                'comm_name': this.commNm,
                'comm_id': this.commId,
                'address': this.commAdr,
                'city': this.commCity,
                'pin_code': this.commPIN,
                'state': this.commState,
                'country': this.commCountry,
                'country_code': this.commCountryCode,
                'contact_phone': this.mobile,
                'phone_country': this.phone_country,
                'contact_email': this.email,
                'is_mc_member': this.mcOrOthers === 'mc-member',
                'is_other_user': this.mcOrOthers === 'staff' || this.mcOrOthers === 'other-user',
                'is_admin': this.isAdmin,
                'role_name': this.role,
                'role_id': this.roles.find(function (rec) {
                  return rec.role_name === _this.role;
                }).role_id,
                'rel_status_if_other_user': relStatusIfOthers,
                'gender': this.gender,
                'hide_contact': this.hideContact,
                'block_id': this.blockId,
                'block_nm': this.blockNm,
                'unit_id': this.unitId,
                'unit_no': this.unitNo,
                'ownership': this.ownership,
                'rel_status': !this.isAdmin && !this.isVerResident ? 'Pending Approval' : 'Linked',
                'reg_mode': 'WEB',
                'user_id': this.userId,
                'is_ver_resident': this.isVerResident,
                'is_self_service': true,
                'user_device_id': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_auth__["d" /* getUserDevId */])()
              };
              this.beingSaved = true;
              this.axios.post(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.API_URL + '/resident/create', user).then(function (response) {
                _this.regStatus = true;
                // keep logged in
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_auth__["e" /* login */])(response.data.user_id, _this.mobile, response.data.api_key);

                // delete the temporary joinee record
                _this.axios.post(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.API_URL + '/otp/delete-joinee', { contact_phone: _this.mobile });

                _this.curStep++;
                _this.beingSaved = false;
              }).catch(function (err) {
                _this.msg(err.response.data);
                _this.beingSaved = false;
              });
            } else {
              return;
            }
            break;
          }
      }
    },
    sendOTP: function sendOTP() {
      var _this2 = this;

      this.mobile = this.mobile.replace(/ /g, '');
      if (!this.isValidNumber) {
        this.msg('Invalid mobile number');
        return;
      }
      this.mobile = this.mobile.substring(0, 15);
      // send otp
      this.axios.post(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.API_URL + '/otp/send', { contact_phone: this.mobile, purpose: 'joining', country_code: this.commCountryCode }).then(function (response) {
        _this2.msg('An OTP is sent to your mobile. Please check and enter here', 2);
        // enable resend after few sec
        _this2.isOTPSent = true;
        _this2.canResend = false;
        _this2.secToWait = 30;
        if (_this2.timer) {
          clearInterval(_this2.timer);
        }
        _this2.timer = setInterval(function () {
          _this2.secToWait--;
          if (!_this2.secToWait) {
            clearInterval(_this2.timer);
            _this2.canResend = true;
          }
        }, 1000);
      }).catch(function (err) {
        _this2.msg(err.response.data);
      });
    },
    findUserHistory: function findUserHistory() {
      var _this3 = this;

      this.mobile = this.mobile.replace(/ /g, '');
      // validate for fresh user
      this.custId = '';
      this.userId = '';
      this.name = '';
      this.gender = '';
      this.email = '';
      this.userId = '';
      this.isHavingHistory = false;
      var qry = {
        params: {
          contact_phone: this.mobile
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.API_URL + '/getUserHistoryByPhone/', qry).then(function (response) {
        if (response.data.length > 0) {
          _this3.userHistory = response.data;
          if (_this3.userHistory.findIndex(function (rec) {
            return rec.unit_id;
          }) >= 0 || _this3.userHistory.findIndex(function (rec) {
            return rec.is_other_user;
          }) >= 0) {
            // re-use the customer details exist in uniapp
            _this3.custId = response.data[0].cust_id;
            _this3.name = response.data[0].cust_name;
            _this3.gender = response.data[0].gender;
            _this3.email = response.data[0].contact_email;

            var uIdx = _this3.userHistory.findIndex(function (rec) {
              return rec.user_id;
            });
            if (uIdx >= 0) {
              _this3.userId = response.data[uIdx].user_id;
              _this3.isHavingHistory = true;
            } else {
              // resident record uploaded by MC and user just validating it
              _this3.blockId = response.data[0].block_id;
              _this3.blockNm = response.data[0].block_nm;
              _this3.unitId = response.data[0].unit_id;
              _this3.unitNo = response.data[0].unit_no;
              _this3.ownership = response.data[0].ownership;
              _this3.cantChangeUnit = true;
              _this3.isVerResident = true;
            }
          } else {
            // customer already exist in backbone might be an on call customer. Just use customer id, do not expose other details, let customer enter it
            _this3.custId = response.data[0].cust_id;
          }
        } else {
          _this3.userHistory = [];
        }
      });
    },
    loadBlocks: function loadBlocks() {
      var _this4 = this;

      var qry = {
        params: {
          comm_id: this.commId
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.API_URL + '/getBlocksByCommId/', qry).then(function (response) {
        _this4.blocks = response.data;
        _this4.blockList = _this4.blocks.map(function (rec) {
          return rec.block_nm;
        });
        if (_this4.blockId) {
          _this4.loadUnits();
        } else {
          _this4.unitList = [];
        }
      }).catch(function (err) {
        _this4.blocks = [];
        _this4.blockList = [];
        _this4.msg(err.response.data);
      });
    },
    loadUnits: function loadUnits() {
      var _this5 = this;

      var qry = {
        params: {
          block_id: this.blockId
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.API_URL + '/getUnitsByBlockId/', qry).then(function (response) {
        _this5.units = response.data;
        _this5.unitList = _this5.units.map(function (rec) {
          return rec.unit_no;
        });
      }).catch(function (err) {
        _this5.unitList = [];
        _this5.msg(err.response.data);
      });
    },
    loadRoles: function loadRoles() {
      var _this6 = this;

      var qry = {
        params: {
          comm_id: this.commId
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.API_URL + '/getRolesByCommId/', qry).then(function (response) {
        _this6.roles = response.data;
        _this6.resRolesList = _this6.roles.filter(function (rec) {
          return rec.role_type === 'Resident';
        }).map(function (rec) {
          return rec.role_name;
        });
        _this6.mcRolesList = _this6.roles.filter(function (rec) {
          return rec.role_type === 'RWA' && rec.role_name !== 'Administrator';
        }).map(function (rec) {
          return rec.role_name;
        });
        _this6.staffRolesList = _this6.roles.filter(function (rec) {
          return rec.role_type === 'Staff';
        }).map(function (rec) {
          return rec.role_name;
        });
        _this6.othersRolesList = _this6.roles.filter(function (rec) {
          return rec.role_type === 'Others';
        }).map(function (rec) {
          return rec.role_name;
        });
      }).catch(function (err) {
        _this6.roles = [];
        _this6.resRolesList = [];
        _this6.mcRolesList = [];
        _this6.staffRolesList = [];
        _this6.othersRolesList = [];
        _this6.msg(err.response.data);
      });
    },
    findBlockId: function findBlockId() {
      var _this7 = this;

      if (this.blocks && this.blockNm) {
        var idx = this.blocks.findIndex(function (rec) {
          return rec.block_nm === _this7.blockNm;
        });
        if (idx >= 0) {
          this.blockId = this.blocks[idx].block_id;
          this.loadUnits();
        } else {
          this.blockId = '';
          this.unitList = [];
        }
      }
    },
    findUnitId: function findUnitId() {
      var _this8 = this;

      this.isDuplicateUnit = false;
      this.isVerResident = false;
      if (this.units && this.unitNo) {
        var idx = this.units.findIndex(function (rec) {
          return rec.unit_no === _this8.unitNo;
        });
        if (idx >= 0) {
          this.unitId = this.units[idx].unit_id;

          // validate if the user already exist for this unit
          if (this.userHistory) {
            var existUser = this.userHistory.find(function (rec) {
              return rec.comm_id === _this8.commId && rec.unit_id === _this8.unitId;
            });
            if (existUser) {
              if (existUser.user_id) {
                this.msg('You are already associated to this unit. Please login instead of joining again');
                this.isDuplicateUnit = true;
              } else {
                // user already associated to this unit may be by MC, but user just signing up in app
                this.isVerResident = true;
              }
            }
          }
        } else {
          this.unitId = '';
        }
      }
    },
    chooseComm: function chooseComm(curComm) {
      this.commNm = curComm.comm_name;
      this.loadComm();
      this.isNewComm = false;
      this.showSimComm = false;
    },
    loadComm: function loadComm() {
      var _this9 = this;

      if (this.commNm) {
        var qry = {
          params: {
            comm_name: this.commNm
          }
          // find comm id
        };this.axios.get(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.API_URL + '/getCommByName/', qry).then(function (response) {
          if (response.data.length) {
            _this9.commId = response.data[0].comm_id;
            // user retain same address as community by default
            _this9.commAdr = response.data[0].address;
            _this9.commCity = response.data[0].city;
            _this9.commPIN = response.data[0].pin_code;
            _this9.commState = response.data[0].state;
            _this9.commCountry = response.data[0].country;
            // find no. of users & set currently registered user as admin if he is the first 3 users
            _this9.axios.get(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.API_URL + '/getUserCountByCommId/' + _this9.commId).then(function (response) {
              if (response.data[0].total_user < 3) {
                _this9.isAdmin = true;
              } else {
                _this9.isAdmin = false;
              }
            });
            // load available roles
            _this9.loadRoles();
            // load available blocks
            _this9.loadBlocks();
          }
        });
      } else {
        // load default roles
        this.commId = 0;
        this.loadRoles();
      }
    },
    checkDupComm: function checkDupComm() {
      var _this10 = this;

      // check for communities with similar names
      if (this.commNm) {
        var qry = {
          params: {
            comm_name: this.commNm
          }
          // find comm id
        };this.similarCommList = [];
        this.axios.get(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.API_URL + '/getSimilarCommByName/', qry).then(function (response) {
          if (response.data.length > 0) {
            _this10.similarCommList = response.data;
            _this10.showSimComm = true;
          }
        }).catch(function (err) {
          _this10.msg(err.response.data);
        });
      }
    },
    ignoreBackspace: function ignoreBackspace(e) {
      if (e.key === 'Backspace') {
        var start = this.mobile.length - 1;
        this.mobile = this.mobile.substring(0, start);
        e.preventDefault();
      }
    },
    keepCursor: function keepCursor() {
      this.$refs.refMob.cursorPosition = this.mobile.length;
    },
    validateMob: function validateMob(_ref) {
      var number = _ref.number,
          valid = _ref.valid,
          country = _ref.country;

      this.isValidNumber = valid;
      if (valid) {
        this.mobile = number.e164;
        this.phone_country = country.name && country.name.includes('(') ? country.name.substring(0, country.name.indexOf('(') - 1) : country.name;
      }
    }
  },
  mounted: function mounted() {
    this.loadComm();
  }
});

/***/ }),

/***/ 460:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_app_cfg__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_auth__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_handy__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_handy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__utils_handy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_tel_input_vuetify__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_tel_input_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_tel_input_vuetify__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'vue-tel-input-vuetify': __WEBPACK_IMPORTED_MODULE_3_vue_tel_input_vuetify__["VueTelInputVuetify"]
  },
  props: ['countrycode'],
  data: function data() {
    return {
      showDlg: true,
      sbar: false,
      sbarMsg: '',
      sbarCol: 'error',
      beingSaved: false,
      userId: '',
      mobile: '',
      otp: '',
      isValidNumber: false,
      isOTPSent: false,
      reqOTPToMobile: false,
      OTPRes: {},
      userExist: false,
      canSendOTP: false,
      rules: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.rules,
      canResend: false,
      secToWait: 0,
      timer: null,
      countryCode: this.countrycode
    };
  },

  methods: {
    msg: function msg(m) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (type === 0) {
        this.sbarCol = 'error';
      } else if (type === 1) {
        this.sbarCol = 'success';
      } else {
        this.sbarCol = 'info';
      }
      this.sbar = true;
      this.sbarMsg = m;
    },
    closeDlg: function closeDlg() {
      this.showDlg = false;
      this.$emit('closed');
    },
    loginToApp: function loginToApp() {
      var _this = this;

      if (!this.isValidNumber) {
        this.msg('Invalid mobile number');
        return;
      }
      if (!this.isOTPSent) {
        this.msg('Click on SEND OTP to receive the OTP');
        return;
      }
      // validate current form and move on
      if (this.$refs.lForm.validate() && this.userExist) {
        this.beingSaved = true;
        // validate OTP
        var req = {
          contact_phone: this.mobile,
          purpose: 'login',
          otp: this.otp,
          user_device_id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_auth__["d" /* getUserDevId */])()
        };
        this.axios.post(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.API_URL + '/otp/verify', req).then(function (response) {
          // log in
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_auth__["e" /* login */])(_this.userId, _this.mobile, response.data.api_key);
          // re-route to home page
          _this.$router.go('/');
        }).catch(function (err) {
          _this.msg(err.response.data);
          _this.beingSaved = false;
          return;
        });
      } else {
        if (this.mobile && !this.userExist) {
          this.msg('User not exist with this mobile number. ' + 'Please join your community before trying to login');
        }
      }
    },
    sendOTP: function sendOTP() {
      var _this2 = this;

      // validate existance of user
      this.mobile = this.mobile.replace(/ /g, '');
      var qry = {
        params: {
          contact_phone: this.mobile
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.API_URL + '/getUserByPhone/', qry).then(function (response) {
        if (response.data.length === 0) {
          _this2.userExist = false;
          _this2.msg('User not exist with this mobile number. ' + 'Please join your community before trying to login');
          return;
        } else {
          _this2.userId = response.data[0].user_id;
          _this2.countryCode = response.data[0].country_code || _this2.countryCode;
          _this2.userExist = true;
          _this2.canSendOTP = false;
          // send otp
          _this2.axios.post(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.API_URL + '/otp/send', { contact_phone: _this2.mobile, purpose: 'login', country_code: _this2.countryCode, req_otp_to_mobile: _this2.reqOTPToMobile }).then(function (response) {
            // this.msg('An OTP is sent to your mobile & e-mail. Please check and enter here', 2)
            _this2.OTPRes = response.data;
            // mask email
            var maskedEmail = _this2.OTPRes.contact_email.split('');
            for (var i = 3; i < _this2.OTPRes.contact_email.indexOf('@'); i += 2) {
              maskedEmail[i] = '*';
            }
            _this2.OTPRes.contact_email = maskedEmail.join('');
            _this2.isOTPSent = true;
            // enable resend after few sec
            _this2.canResend = false;
            _this2.secToWait = 30;
            if (_this2.timer) {
              clearInterval(_this2.timer);
            }
            _this2.timer = setInterval(function () {
              _this2.secToWait--;
              if (!_this2.secToWait) {
                clearInterval(_this2.timer);
                _this2.canResend = true;
              }
            }, 1000);
          }).catch(function (err) {
            _this2.msg(err.response.data);
          });
        }
      });
    },
    ignoreBackspace: function ignoreBackspace(e) {
      if (e.key === 'Backspace') {
        var start = this.mobile.length - 1;
        this.mobile = this.mobile.substring(0, start);
        e.preventDefault();
      }
    },
    keepCursor: function keepCursor() {
      this.$refs.refMob.cursorPosition = this.mobile.length;
    },
    validateMob: function validateMob(_ref) {
      var number = _ref.number,
          valid = _ref.valid,
          country = _ref.country;

      this.isValidNumber = valid;
      if (valid) {
        this.mobile = number.e164;
      }
    }
  }
});

/***/ }),

/***/ 461:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_app_cfg__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_handy__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_handy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__utils_handy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_chartjs_plugin_datalabels__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_chartjs_plugin_datalabels___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_chartjs_plugin_datalabels__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var Chart = __webpack_require__(111);

var html2pdf = __webpack_require__(167);

var COLORS = ['227,108,9', '49,133,155', '95,73,122', '118,146,60', '149,55,52', '54,96,146', '23,54,93', '73,68,41'];

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['action'],
  data: function data() {
    return {
      // common
      sbar: false,
      sbarCol: 'error',
      sbarMsg: '',
      config: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a,
      handy: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a,
      lReport: {},
      // Attendance
      attHead: [],
      attList: [],
      // complaint
      compHead: [{ text: 'Category', value: 'comp_cat', class: 'font px-2 primary white--text text-xs-center', sortable: false }, { text: 'Previous Pending', value: 'prev_pend', class: 'font px-2 primary white--text text-xs-center', sortable: false }, { text: 'Today’s New', value: 'new_today', class: 'font px-2 primary white--text text-xs-center', sortable: false }, { text: 'Reopened Today', value: 'reop_today', class: 'font px-2 primary white--text text-xs-center', sortable: false }, { text: 'Closed Today', value: 'closed_today', class: 'font px-2 primary white--text text-xs-center', sortable: false }, { text: 'Closing Balance', value: 'closing_bal', class: 'font px-2 primary white--text text-xs-center', sortable: false }],
      compList: [],
      // water quality
      paramHead: [],
      paramList: [],
      // water sources
      domWatList: [],
      // custom Metrics
      lMet: {},
      metHead: [{ text: 'Metric Name', value: 'metric_nm', width: '300px', class: 'font primary white--text', sortable: false }, { text: 'Value', value: 'metric_val', width: '100px', class: 'font primary white--text', sortable: false }],
      metricList: [],
      // DG
      lGenset: {},
      gensetHead: [{ text: 'Genset', value: 'genset_nm', class: 'font primary white--text pl-2 pr-0', sortable: false }, { text: 'Units(KWH)', value: 'units_cons', class: 'font primary white--text px-0', sortable: false }, { text: 'Diesel Level (%)', value: 'level', class: 'font primary white--text px-0', sortable: false }, { text: 'Running Hours', value: 'run_hrs', class: 'font primary white--text px-0', sortable: false }],
      gensetList: [],
      dieselHead: [{ text: 'Metric', value: 'diesel_nm', class: 'font primary white--text', sortable: false }, { text: 'Quantity (ltr)', value: 'val', class: 'font primary white--text', sortable: false }],
      dieselList: [],
      lgen: {},
      // Hygiene
      hygList: [],
      sanList: [],
      lSan: {},
      hygCats: {},
      sanHeads: [{ text: '', value: 'check_value' }, { text: 'Category', value: 'check_cat' }, { text: 'Description', value: 'check_desc' }, { text: 'Remark', value: 'remark' }],
      // incident
      incidentList: [],
      incidentTypes: {},
      // comm values
      nodata: false,
      // for chart
      tmpChart: [],
      // ppm planner
      ppmHeader: [{ text: 'Asset Tag', values: 'asset_tag', class: 'primary white--text py-0' }, { text: 'Category', values: 'asset_cat', class: 'primary white--text py-0' }, { text: 'Non Equipment', values: 'noneq_nm', class: 'primary white--text py-0' }, { text: 'Frequency', values: 'freq', class: 'primary white--text py-0' }, { text: 'Location', values: 'asset_location', class: 'primary white--text py-0' }, { text: 'PPM Activity Status', values: 'asset_status', class: 'primary white--text py-0' }],
      lPpmHeader: [],
      // photos
      lDailyUpdateAttach: {
        files: []
      },
      from_dt: null,
      to_dt: null,
      rep_to_date: null,
      repo_to_date: null,
      repHeadSm: [{ text: 'Role [Headcount]', value: 'staff_role', class: 'font primary white--text pl-2 pr-0', sortable: false }, { text: 'Present', value: 'tot_present', class: 'font primary white--text pl-2 pr-0', sortable: false }, { text: 'Weekoff', value: 'tot_wo', class: 'font primary white--text pl-2 pr-0', sortable: false }, { text: 'Holiday', value: 'tot_holiday', class: 'font primary white--text pl-2 pr-0', sortable: false }, { text: 'Standby/OT', value: 'tot_ot', class: 'font primary white--text pl-2 pr-0', sortable: false }, { text: 'Leave', value: 'tot_leave', class: 'font primary white--text pl-2 pr-0', sortable: false }, { text: 'Absent', value: 'tot_absent', class: 'font primary white--text pl-2 pr-0', sortable: false }, { text: 'Pending', value: 'tot_pend', class: 'font primary white--text pl-2 pr-0', sortable: false }],
      repHead: [{ text: 'Role', value: 'staff_role' }, { text: 'Present', value: 'tot_present', class: 'pa-0' }, { text: 'Pending', value: 'tot_pend', class: 'red--text pa-0' }],
      attReport: []
    };
  },
  mounted: function mounted() {
    this.loadReportDate();
    this.lReport.comm_name = __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_NAME;
    // this.loadAttReport()
    this.loadRemark();
    // this.loadCompReport()
    this.loadPowerConsPieChart();
    this.loadPowerGensetPieChart();
    // this.loadWaterLevelChart()
    this.loadWaterConsChart();
    this.loadWaterSources();
    this.loadWaterQualChart();
    this.loadMetricCat();
    // this.loadTaskReport()
    this.loadGenset();
    this.loadWasteChart();
    this.loadHygieneCat();
    // this.loadHygiene()
    this.loadIncidentClass();
    this.loadPpmPlanner();
    this.loadFacDailyUpdateAttachment();
    // this.loadIncidentWeekly()
    this.loadSanityChecksWeekly();
    this.showAttendanceSummary();
  },

  methods: {
    msg: function msg(m) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (type === 0) {
        this.sbarCol = 'error';
      } else if (type === 1) {
        this.sbarCol = 'success';
      } else {
        this.sbarCol = 'info';
      }
      this.sbar = true;
      this.sbarMsg = m;
    },
    loadReportDate: function loadReportDate() {
      var curDate = new Date(this.action);
      this.lReport.rep_date = __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDate(this.action);
      this.rep_to_date = new Date(curDate.setDate(curDate.getDate() + 6));
      this.repo_to_date = __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDate(this.rep_to_date);
      this.rep_to_date = __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.rep_to_date);
    },

    // loadAttReport () {
    //   var qry = {
    //     params: {
    //       from_dt: handy.formatDBDate(this.action),
    //       to_dt: handy.formatDBDate(this.rep_to_date),
    //       comm_id: config.COMM_ID,
    //       is_billable: 1
    //     }
    //   }
    //   this.lReport.attAve = 0
    //   var attVal = {
    //     tot_staff: 0,
    //     tot_present: 0,
    //     tot_hd: 0,
    //     tot_ot: 0,
    //     tot_wo: 0,
    //     tot_holiday: 0,
    //     tot_standBy: 0
    //   }
    //   this.lReport.roleCat = {}
    //   this.lReport.attHeader = []
    //   this.lReport.tot_staff = 0
    //   this.lReport.tot_present = 0
    //   this.lReport.tot_ot = 0
    //   this.axios.get(config.API_URL + '/getAttendanceWeeklyRep/', qry)
    //   .then(response => {
    //     // total attendance in percentage
    //     this.lReport.roleCat = handy.unique(response.data.map(rec => rec.role_cat))
    //     response.data.forEach(rec => {
    //       attVal.tot_staff += rec.role_count + Number(rec.role_count * 6)
    //       attVal.tot_present += rec.tot_present + Number(rec.tot_hd / 2)
    //       attVal.tot_ot += rec.tot_ot
    //       attVal.tot_wo += rec.tot_wo
    //       attVal.tot_holiday += rec.tot_holiday
    //       attVal.tot_standBy += rec.tot_standBy
    //     })
    //     this.lReport.tot_staff = attVal.tot_staff
    //     this.lReport.tot_present = attVal.tot_present
    //     this.lReport.tot_ot = attVal.tot_ot
    //     this.lReport.roleCat.forEach(rec => {
    //       this.attList.push({
    //         role_cat: rec,
    //         attendance: []
    //       })
    //       this.lReport.attHeader.push({
    //         role_cat: rec,
    //         attHead: []
    //       })
    //     })
    //     for (var i = 0; i < response.data.length; i++) {
    //       for (var j = 0; j < this.attList.length; j++) {
    //         if (response.data[i].role_cat === this.attList[j].role_cat) {
    //           this.attList[j].attendance.push({
    //             tot_present: response.data[i].tot_present + Number(response.data[i].tot_hd / 2) + (response.data[i].tot_ot ? ' + ' + Number(response.data[i].tot_ot + (response.data[i].tot_standBy || 0)) : response.data[i].tot_standBy ? ' + ' + response.data[i].tot_standBy : 0) + ' / ' + Number(response.data[i].role_count),
    //             tot_wo: response.data[i].tot_wo,
    //             tot_holiday: response.data[i].tot_holiday,
    //             tot_leave: response.data[i].tot_leave,
    //             tot_hd: response.data[i].tot_hd,
    //             tot_absent: response.data[i].tot_absent
    //           })
    //         }
    //       }
    //       for (var k = 0; k < this.lReport.attHeader.length; k++) {
    //         if (response.data[i].role_cat === this.lReport.attHeader[k].role_cat) {
    //           this.lReport.attHeader[k].attHead.push({
    //             short_form: response.data[i].short_form
    //           })
    //         }
    //       }
    //     }
    //     this.lReport.attAve = Math.round((attVal.tot_present + attVal.tot_ot + attVal.tot_standBy + attVal.tot_wo + attVal.tot_holiday) / attVal.tot_staff * 100)
    //     this.$forceUpdate()
    //   })
    //   .catch(err => {
    //     this.msg(err, true)
    //   })
    // },
    loadRemark: function loadRemark() {
      var _this = this;

      var qry = {
        params: {
          from_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.action),
          to_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.rep_to_date),
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getWeeklyRemarksBasedOnCommId/', qry).then(function (response) {
        if (response.data.length > 0) {
          _this.lReport.remark_attendance = response.data[0].remark_attendance;
          _this.lReport.remark_water = response.data[0].remark_water;
          _this.lReport.remark_power = response.data[0].remark_power;
          _this.lReport.remark_sanity_checks = response.data[0].remark_sanity_checks;
          _this.lReport.remark_custom_metrics = response.data[0].remark_custom_metrics;
          _this.lReport.major_observ = response.data[0].major_observ;
        }
      }).catch(function (err) {
        _this.msg(err, true);
      });
    },

    // loadCompReport () {
    //   var qry = {
    //     params: {
    //       from_dt: handy.formatDBDate(this.action),
    //       comm_id: config.COMM_ID
    //     }
    //   }
    //   this.axios.get(config.API_URL + '/getComplaintWeeklyRep/', qry)
    //   .then(response => {
    //     this.compList = response.data
    //   })
    //   .catch(err => {
    //     this.msg(err, true)
    //   })
    // },
    loadPowerConsPieChart: function loadPowerConsPieChart() {
      var _this2 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
          from_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.action),
          to_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.rep_to_date)
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getPowerMeterWeeklyRep/', qry).then(function (response) {
        var resObj = response.data;
        var areaLbl = [];
        var unitConsVal = [];
        _this2.lReport.eb_unit = 0;
        // pie chart
        for (var i = 0; i < resObj.length; i++) {
          areaLbl[i] = resObj[i].area_covered;
          unitConsVal[i] = 0;
          if (!resObj[i].unit_cons) {
            resObj[i].unit_cons = 0;
          }
          unitConsVal[i] += Number(resObj[i].unit_cons.toFixed(2));
          _this2.lReport.eb_unit += Number(resObj[i].unit_cons.toFixed(2));
        }
        var totZero = 0;
        for (i = 0; i < unitConsVal.length; i++) {
          if (unitConsVal[i] === 0) {
            totZero++;
          }
        }
        if (totZero === unitConsVal.length) {
          _this2.nodata = true;
        } else {
          _this2.nodata = false;
        }
        // chart 1
        // clear the content if any
        if (_this2.nodata) {
          setTimeout(function () {
            document.getElementById('div_powercons').innerHTML = 'No data available, check location and area covered configuration';
          }, 500);
          _this2.$forceUpdate();
        } else {
          setTimeout(function () {
            document.getElementById('div_powercons').innerHTML = '<canvas id="chart_powercons"></canvas>';
            var canvas = document.getElementById('chart_powercons');
            var ctx = canvas.getContext('2d');
            ctx.canvas.height = areaLbl.length * 2.5;
            ctx.canvas.width = areaLbl.length * 7;
            _this2.tmpChart = new Chart(ctx, {
              type: 'pie',
              data: {
                labels: areaLbl,
                datasets: [{
                  backgroundColor: ['#e36c09', '#31859b', '#5f497a', '#76923c', '#953734', '#366092', '#17365d', '#494429', '#5f4170', '#4c646e'],
                  data: unitConsVal
                }]
              },
              options: {
                plugins: {
                  datalabels: {
                    formatter: function formatter(value) {
                      return value;
                    },
                    color: '#ffffff'
                  }
                },
                title: {
                  display: true,
                  text: 'Electricity Board (Units)'
                },
                legend: {
                  position: 'right'
                }
              }
            });
          }, 500);
          _this2.$forceUpdate();
        }
      }).catch(function (err) {
        _this2.msg(err, 0);
      });
    },
    loadPowerGensetPieChart: function loadPowerGensetPieChart() {
      var _this3 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
          from_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.action),
          to_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.rep_to_date)
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getWeeklyPowerGensetPieChartByCommId/', qry).then(function (response) {
        var resObj = response.data;
        var gensetLbl = [];
        var unitConsVal = [];
        _this3.lReport.dg_unit = 0;
        // pie chart
        for (var i = 0; i < resObj.length; i++) {
          gensetLbl[i] = resObj[i].genset_nm;
          var unitVal = resObj[i].value;
          unitConsVal[i] = 0;
          for (var d = 0; d < unitVal.length; d++) {
            if (!unitVal[d].units_cons) {
              unitVal[d].units_cons = 0;
            }
            unitConsVal[i] += Number(unitVal[d].units_cons);
            _this3.lReport.dg_unit += unitConsVal[i];
          }
        }
        // chart 1
        // clear the content if any
        if (response.data.length === 0) {
          setTimeout(function () {
            document.getElementById('div_powergenset').innerHTML = 'No data available for DG';
          }, 500);
          _this3.$forceUpdate();
        } else if (_this3.lReport.dg_unit === 0) {
          setTimeout(function () {
            document.getElementById('div_powergenset').innerHTML = 'DGs were not run today';
          }, 500);
          _this3.$forceUpdate();
        } else {
          setTimeout(function () {
            document.getElementById('div_powergenset').innerHTML = '<canvas id="chart_powergenset"></canvas>';
            var canvas = document.getElementById('chart_powergenset');
            var ctx = canvas.getContext('2d');
            ctx.canvas.height = gensetLbl.length * 1.7;
            ctx.canvas.width = gensetLbl.length * 4.5;
            _this3.tmpChart = new Chart(ctx, {
              type: 'pie',
              data: {
                labels: gensetLbl,
                datasets: [{
                  backgroundColor: ['#e36c09', '#31859b', '#5f497a', '#76923c', '#953734', '#366092', '#17365d', '#494429'],
                  data: unitConsVal
                }]
              },
              options: {
                plugins: {
                  datalabels: {
                    formatter: function formatter(value) {
                      return value;
                    },
                    color: '#ffffff'
                  }
                },
                title: {
                  display: true,
                  text: 'Genset (Units)'
                },
                legend: {
                  position: 'right'
                }
              }
            });
          }, 500);
          _this3.$forceUpdate();
        }
      }).catch(function (err) {
        _this3.msg(err, 0);
      });
    },

    // loadWaterLevelChart () {
    //   var qry = {
    //     params: {
    //       comm_id: config.COMM_ID,
    //       from_dt: handy.formatDBDate(this.action) + ' 00:00:00',
    //       to_dt: handy.formatDBDate(this.rep_to_date) + ' 23:59:59'
    //     }
    //   }
    //   this.axios.get(config.API_URL + '/getWeeklyWaterLevelChartDetailsByCommId/', qry)
    //   .then(response => {
    //     // retrive data from db and construct chart
    //     var resObj = response.data
    //     var watTypeLbl = []
    //     var levelVal = {}
    //     var gw = 0
    //     var dtLbl = [] // for trend chart
    //     var waterLvlKl = {}
    //     var gd = 0
    //     var idx = 0
    //     for (var i = 0; i < resObj.length; i++) {
    //       watTypeLbl[gw] = resObj[i].storage_nm
    //       levelVal[gw] = []
    //       idx = gw++
    //       var lvl = resObj[i].levels
    //       for (var d = 0; d < lvl.length; d++) {
    //         if (lvl[d].water_level === '') {
    //           lvl[d].water_level = 0
    //         }
    //         var didx = dtLbl.indexOf(handy.formatDate(lvl[d].c_date))
    //         if (didx < 0 && lvl[d].c_date) {
    //           dtLbl[gd] = handy.formatDate(lvl[d].c_date)
    //           didx = gd++
    //         }
    //         if (dtLbl[didx] === handy.formatDate(this.action)) {
    //           if (lvl[d].water_level) {
    //             levelVal[idx][i] = lvl[d].water_level // show specific data for the day in first graph in case of single date
    //           }
    //           if (lvl[d].water_level_kl) {
    //             waterLvlKl[i] = lvl[d].water_level_kl + ' KL'
    //           }
    //         }
    //       }
    //     }
    //     // chart 1
    //     // data set
    //     var value = []
    //     for (i = 0; i < watTypeLbl.length; i++) {
    //       value.push(levelVal[i][i])
    //     }
    //     var totZero = 0
    //     for (i = 0; i < value.length; i++) {
    //       if (value[i] === 0) {
    //         totZero++
    //       }
    //     }
    //     if (totZero === value.length) {
    //       this.nodata = true
    //     } else {
    //       this.nodata = false
    //     }
    //     if (this.nodata) {
    //       setTimeout(() => {
    //         document.getElementById('div_waterlevel').innerHTML = 'No data available'
    //       }, 500)
    //       this.$forceUpdate()
    //     } else {
    //       // clear the content if any
    //       document.getElementById('div_waterlevel').innerHTML = '<canvas id="chart_waterlevel"></canvas>'
    //       var canvas = document.getElementById('chart_waterlevel')
    //       canvas.height = watTypeLbl.length > 4 ? watTypeLbl.length * 18 : watTypeLbl.length * 42
    //       var ctx = canvas.getContext('2d')
    //       this.tmpChart = new Chart(ctx, {
    //         type: 'horizontalBar',
    //         data: {
    //           labels: watTypeLbl,
    //           datasets: [{
    //             backgroundColor: 'rgba(' + COLORS[1] + ',0.7)',
    //             data: value,
    //             fill: true
    //           }]
    //         },
    //         options: {
    //           tooltips: {enabled: false},
    //           responsive: true,
    //           maintainAspectRatio: false,
    //           legend: {
    //             display: false,
    //             position: 'bottom',
    //             labels: {
    //               usePointStyle: true,
    //               fontSize: 11
    //             }
    //           },
    //           scales: {
    //             xAxes: [{
    //               ticks: {
    //                 beginAtZero: true,
    //                 min: 0
    //               }
    //             }]
    //           },
    //           hover: {
    //             animationDuration: 0
    //           },
    //           plugins: {
    //             datalabels: {
    //               formatter: function (value) {
    //                 return value > 0 ? value + ' %' : ''
    //               },
    //               color: '#ffffff'
    //             }
    //           }
    //         }
    //       })
    //       this.$forceUpdate()
    //     }
    //   })
    //   .catch(err => {
    //     this.msg(err, 0)
    //   })
    // },
    loadWaterConsChart: function loadWaterConsChart() {
      var _this4 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
          from_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.action) + ' 00:00:00',
          to_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.rep_to_date) + ' 23:59:59',
          comingFrom: 'Report',
          vendor_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.FM_VENDOR_ID
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getWeeklyWaterConsChartDetailsByCommId/', qry).then(function (response) {
        // retrive data from db and construct chart
        var resObj = response.data;
        var watTypeLbl = [];
        var recVal = {};
        var dtLbl = []; // for trend chart
        var didx = 0;
        var widx = 0;
        var modeLbl = ['Consumed (KL)'];
        recVal[0] = [];
        _this4.lReport.tot_water_cons = 0;
        for (var r = 0; r < resObj.length; r++) {
          var cons = resObj[r].cons;
          for (var d = 0; d < cons.length; d++) {
            didx = dtLbl.indexOf(__WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(cons[d].c_date));
            if (didx < 0 && cons[d].c_date) {
              didx = dtLbl.length;
              dtLbl[didx] = __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(cons[d].c_date);
            }
            widx = watTypeLbl.indexOf(resObj[r].storage_nm.substring(0, 10));
            if (widx < 0) {
              widx = watTypeLbl.length;
              watTypeLbl[widx] = resObj[r].storage_nm.substring(0, 10);
            }
            if (!recVal[0][widx]) {
              recVal[0][widx] = 0;
            }
            recVal[0][widx] += Number(cons[d].water_cons);
          }
        }
        // to do: when automated for mulitple timestamps on the same day
        // chart 1 (water receipt and cons)
        // data set
        var dsets = [];
        for (var i = 0; i < modeLbl.length; i++) {
          for (var j = 0; j < recVal[i].length; j++) {
            recVal[i][j] = recVal[i][j] > 0 ? recVal[i][j].toFixed(0) : '';
            _this4.lReport.tot_water_cons += Number(recVal[i][j]);
          }
          dsets[i] = {
            label: modeLbl[i],
            backgroundColor: 'rgba(' + COLORS[i] + ',0.7)',
            borderColor: 'rgba(' + COLORS[i] + ',1)',
            data: recVal[i],
            fill: true
          };
        }
        if (_this4.lReport.tot_water_cons) {
          _this4.nodata = false;
        } else {
          _this4.nodata = true;
        }
        if (_this4.nodata) {
          document.getElementById('div_watercons').innerHTML = 'No data available, check water consumption configuration';
        } else {
          // clear the content if any
          document.getElementById('div_watercons').innerHTML = '<canvas id="chart_watercons"></canvas>';
          var canvas = document.getElementById('chart_watercons');
          var ctx = canvas.getContext('2d');
          _this4.tmpChart = new Chart(ctx, {
            type: 'horizontalBar',
            data: {
              labels: watTypeLbl,
              datasets: dsets
            },
            options: {
              plugins: {
                datalabels: {
                  formatter: function formatter(value) {
                    return value || '';
                  },
                  color: '#fff'
                }
              },
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: false,
                position: 'bottom',
                labels: {
                  usePointStyle: true,
                  fontSize: 11
                }
              },
              scales: {
                xAxes: [{
                  ticks: {
                    beginAtZero: true
                  }
                }]
              }
            }
          });
        }
        _this4.$forceUpdate();
      }).catch(function (err) {
        _this4.msg(err, 0);
      });
    },
    loadWaterSources: function loadWaterSources() {
      var _this5 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
          c_date: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.action),
          from_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.action),
          to_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.rep_to_date)
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getWeeklyWaterSourcesByCommIdAndcDate/', qry).then(function (response) {
        if (response.data.length > 0) {
          _this5.domWatList = response.data;
        }
        _this5.$forceUpdate();
      }).catch(function (err) {
        _this5.msg(err, 0);
      });
    },
    loadWaterQualChart: function loadWaterQualChart() {
      var _this6 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
          from_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.action),
          to_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.rep_to_date)
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getWeeklyWaterQualityByCommId/', qry).then(function (response) {
        // retrive data from db and construct chart
        var resObj = response.data;
        var paramLbl = [];
        var paramId = [];
        var paramUoM = [];
        var watTypeLbl = [];
        var qualVal = {};
        var stdValMin = [];
        var stdValMax = [];
        var widx = 0;
        var pidx = 0;
        var dtIdx = 1;
        for (var r = 0; r < resObj.length; r++) {
          pidx = paramId.indexOf(resObj[r].param_id);
          if (pidx < 0) {
            pidx = paramId.length;
            paramId[pidx] = resObj[r].param_id;
            paramLbl[pidx] = resObj[r].param_name;
            qualVal[pidx] = [];
          }
          widx = watTypeLbl.indexOf(resObj[r].water_type);
          if (widx < 0) {
            widx = watTypeLbl.length;
            watTypeLbl[widx] = resObj[r].water_type;
          }
          if (!qualVal[pidx][widx]) {
            qualVal[pidx][widx] = 0;
          }
          qualVal[pidx][widx] = Number(resObj[r].val);
          paramUoM[pidx] = resObj[r].uom;
          stdValMin[pidx] = Number(resObj[r].std_val_min);
          stdValMax[pidx] = Number(resObj[r].std_val_max);
        }
        // chart 1
        _this6.paramHead = [{ text: 'Water Type', value: 'water_qual', class: 'primary white--text text-xs-center py-0', sortable: false }];
        var minMax = '';
        for (var i = 0; i < paramLbl.length; i++) {
          if (stdValMin[i] && stdValMax[i]) {
            minMax = stdValMin[i] + ' to ' + stdValMax[i];
          } else if (stdValMin[i]) {
            minMax = 'min ' + stdValMin[i];
          } else {
            minMax = 'max ' + stdValMax[i];
          }
          // construct table headers dynamically
          _this6.paramHead.splice(dtIdx++, 0, {
            text: paramLbl[i] + '(' + paramUoM[i] + ') [' + minMax + ']', value: paramLbl[i], width: '160px', class: 'font pl-2 pr-0 py-0 text-xs-center white--text primary', sortable: false
          });
        }
        _this6.paramList = [];
        for (i = 0; i < watTypeLbl.length; i++) {
          if (stdValMin[i] && stdValMax[i]) {
            minMax = stdValMin[i] + ' to ' + stdValMax[i];
          } else if (stdValMin[i]) {
            minMax = 'min ' + stdValMin[i];
          } else {
            minMax = 'max ' + stdValMax[i];
          }
          _this6.paramList.push({
            water_qual: watTypeLbl[i] === 'SWIMMING POOL' ? 'S. POOL' : watTypeLbl[i],
            waterQualTypeValue: []
          });
        }
        // find ave
        for (i = 0; i < paramLbl.length; i++) {
          for (var j = 0; j < watTypeLbl.length; j++) {
            if (qualVal[i][j] && qualVal[i][j] !== '  ') {
              qualVal[i][j] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(qualVal[i][j]) || qualVal[i][j] > 50 ? qualVal[i][j].toFixed(0) : qualVal[i][j].toFixed(1);
            }
          }
        }

        // construct value table for each parameter
        for (j = 0; j < watTypeLbl.length; j++) {
          for (i = 0; i < paramLbl.length; i++) {
            _this6.paramList[j].waterQualTypeValue.push({
              val: qualVal[i][j] || '',
              stdValMin: stdValMin[i],
              stdValMax: stdValMax[i]
            });
          }
        }
      }).catch(function (err) {
        _this6.msg(err, 0);
      });
    },
    loadMetricCat: function loadMetricCat() {
      var _this7 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getWeeklyMetricCatByCommId/', qry).then(function (response) {
        _this7.lMet = response.data.filter(function (rec) {
          return rec.metric_cat !== '';
        });
        _this7.loadMetric(__WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(_this7.action));
      }).catch(function (err) {
        _this7.msg(err, 0);
      });
    },
    loadMetric: function loadMetric(curDate) {
      var _this8 = this;

      var metCat = this.lMet.filter(function (rec) {
        return rec.metric_cat !== '';
      });
      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
          from_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.action),
          to_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.rep_to_date),
          metric_cat: metCat.map(function (rec) {
            return rec.metric_cat;
          })
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getWeeklyMetricByCommId/', qry).then(function (response) {
        _this8.metricList = response.data;
      }).catch(function (err) {
        _this8.msg(err, 0);
      });
    },
    loadTaskReport: function loadTaskReport() {
      var _this9 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
          from_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.action),
          to_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.repo_to_date)
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getWeeklyTaskReport/', qry).then(function (response) {
        var resObj = response.data;
        var statusLbl = [];
        var totTaskVal = [];
        // pie chart
        for (var i = 0; i < resObj.length; i++) {
          statusLbl[i] = resObj[i].task_status;
          if (!resObj[i].tot_task_status) {
            totTaskVal[i] = 0;
          } else {
            totTaskVal[i] = resObj[i].tot_task_status;
          }
        }
        var totZero = 0;
        for (i = 0; i < totTaskVal.length; i++) {
          if (totTaskVal[i] === 0) {
            totZero++;
          }
        }
        if (totZero === totTaskVal.length) {
          _this9.nodata = true;
        } else {
          _this9.nodata = false;
        }
        // chart 1
        // clear the content if any
        if (_this9.nodata) {
          setTimeout(function () {
            document.getElementById('div_task').innerHTML = 'No data available';
          }, 500);
          _this9.$forceUpdate();
        } else {
          setTimeout(function () {
            document.getElementById('div_task').innerHTML = '<canvas id="chart_task"></canvas>';
            var canvas = document.getElementById('chart_task');
            canvas.height = statusLbl.length * 23;
            canvas.width = statusLbl.length * 35;
            var ctx = canvas.getContext('2d');
            _this9.tmpChart = new Chart(ctx, {
              type: 'pie',
              data: {
                labels: statusLbl,
                datasets: [{
                  backgroundColor: ['#e36c09', '#31859b', '#5f497a', '#76923c', '#953734', '#366092', '#17365d', '#494429'],
                  data: totTaskVal
                }]
              },
              options: {
                plugins: {
                  datalabels: {
                    formatter: function formatter(value) {
                      return value || '';
                    },
                    color: '#ffffff'
                  }
                },
                title: {
                  display: false
                },
                legend: {
                  position: 'bottom'
                }
              }
            });
          }, 500);
          _this9.$forceUpdate();
        }
      }).catch(function (err) {
        _this9.msg(err, 0);
      });
    },
    loadGenset: function loadGenset() {
      var _this10 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
          from_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.action),
          to_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.rep_to_date)
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getWeeklyGensetByGensetId/', qry).then(function (response) {
        _this10.gensetList = response.data;
        _this10.lgen.totPurchasedStock = 0;
        _this10.lgen.totStock = 0;
        _this10.lgen.units_cons = 0;
        _this10.lgen.run_hrs = 0;
        _this10.lgen.kwh_kva = 0;
        _this10.lgen.level = 0;
        _this10.gensetList.forEach(function (rec) {
          _this10.lgen.totPurchasedStock += Number(rec.purchased);
          _this10.lgen.totStock += Number(rec.stock);
          _this10.lgen.units_cons += Number(rec.units_cons);
          _this10.lgen.run_hrs += Number(rec.run_hrs);
          _this10.lgen.level += Number(rec.level);
        });
        _this10.dieselList.push({
          diesel_nm: 'Diesel Purchased',
          val: _this10.lgen.totPurchasedStock || ''
        });
        _this10.dieselList.push({
          diesel_nm: 'Diesel Barrel Stock',
          val: _this10.lgen.totStock || ''
        });
        _this10.dieselList.push({
          diesel_nm: 'Units(KWH)',
          val: _this10.lgen.units_cons || ''
        });
        _this10.dieselList.push({
          diesel_nm: 'Running Hours',
          val: _this10.lgen.run_hrs || ''
        });
      }).catch(function (err) {
        _this10.msg(err, 0);
      });
    },
    loadHygieneCat: function loadHygieneCat() {
      var _this11 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getWeeklySanCheckCatByCommId/', qry).then(function (response) {
        _this11.hygCats = response.data;
        _this11.loadHygiene();
      }).catch(function (err) {
        _this11.msg(err, true);
      });
    },
    loadHygiene: function loadHygiene() {
      var _this12 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
          from_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.action),
          to_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.rep_to_date)
        }
      };
      this.hygList = [];
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getSanCheckByCommIdAndcDate/', qry).then(function (response) {
        _this12.hygList = response.data;
      }).catch(function (err) {
        _this12.msg(err, 0);
      });
    },
    loadIncidentClass: function loadIncidentClass() {
      var _this13 = this;

      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getIncidentClass/').then(function (response) {
        _this13.incidentTypes = __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.unique(response.data.map(function (rec) {
          return rec.incident_type;
        })).sort();
        _this13.loadIncidents();
      }).catch(function (err) {
        _this13.msg(err, true);
      });
    },
    loadIncidents: function loadIncidents() {
      var _this14 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
          from_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.action) + ' 00:00:00',
          to_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.rep_to_date) + ' 23:59:59'
        }
      };
      this.incidentList = [];
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getIncidentListWeeklyRep/', qry).then(function (response) {
        if (response.data.length > 0) {
          _this14.incidentList = response.data;
        } else {
          _this14.incidentTypes.forEach(function (rec) {
            _this14.incidentList.push({
              incident_type: rec,
              incident_class: 'NIL'
            });
          });
        }
      }).catch(function (err) {
        _this14.msg(err, 0);
      });
    },
    loadPpmPlanner: function loadPpmPlanner() {
      var _this15 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
          from_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.action),
          to_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.rep_to_date)
        }
      };
      this.lPpmHeader = [];
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getPpmPlannerListDailyRep/', qry).then(function (response) {
        _this15.lPpmHeader = response.data;
      }).catch(function (err) {
        _this15.msg(err, 0);
      });
    },
    loadFacDailyUpdateAttachment: function loadFacDailyUpdateAttachment() {
      var _this16 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
          from_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.action),
          to_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.rep_to_date)
        }
      };
      this.lDailyUpdateAttach.files = [];
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getAttachmentByCDateWeekly/', qry).then(function (response) {
        _this16.lDailyUpdateAttach.files = response.data;
        _this16.$forceUpdate();
      }).catch(function (err) {
        _this16.msg(err.response.data, 0);
        _this16.lDailyUpdateAttach.files = [];
      });
    },
    downoadAsPdf: function downoadAsPdf() {
      // pdf options
      var opt = {
        margin: 14,
        filename: this.lReport.comm_name + '_Report_' + __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDate(this.action) + '_to_' + __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.rep_to_date) + '.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { orientation: 'landscape' },
        pagebreak: { before: '#pageBreak' }
      };

      var canvas = document.getElementById('pdf_report');
      html2pdf(canvas, opt);
    },
    loadWasteChart: function loadWasteChart() {
      var _this17 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
          from_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.action),
          to_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.rep_to_date)
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getWasteByCommIdAndcDate/', qry).then(function (response) {
        _this17.lWaste = response.data.filter(function (rec) {
          return __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(rec.c_date) === __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(_this17.fromDate);
        });
        var resObj = response.data;
        var wasteTypeLbl = [];
        var recVal = {};
        var dtLbl = []; // for trend chart
        var recAvgVal = {};
        var didx = 0;
        var widx = 0;

        recVal[0] = [];
        for (var r = 0; r < resObj.length; r++) {
          didx = dtLbl.indexOf(__WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(resObj[r].c_date));

          if (didx < 0 && resObj[r].c_date) {
            didx = dtLbl.length;
            dtLbl[didx] = __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(resObj[r].c_date);
          }

          widx = wasteTypeLbl.indexOf(resObj[r].waste_type);
          if (widx < 0) {
            widx = wasteTypeLbl.length;
            wasteTypeLbl[widx] = resObj[r].waste_type;
            recVal[widx] = [];
            recAvgVal[widx] = [];
          }
          if (_this17.aDay) {
            // show specefic data for the day in first graph in case of single date
            if (dtLbl[didx] === __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(_this17.fromDate)) {
              recVal[widx][0] = resObj[r].kgs;
            }
          } else {
            if (recVal[widx][0] === undefined) {
              recVal[widx][0] = 0;
            }
            recVal[widx][0] += Number(resObj[r].kgs);
          }
          // for trend
          if (recAvgVal[widx][didx] === undefined) {
            recAvgVal[widx][didx] = 0;
          }
          recAvgVal[widx][didx] += resObj[r].kgs;
        } // for every rec
        // chart 1
        // data set
        var dsets = [];
        var lColor = ['0,255,0', '0,0,255', '255,0,0'];
        for (var i = 0; i < wasteTypeLbl.length; i++) {
          dsets[i] = {
            label: wasteTypeLbl[i] + ' (kg)',
            backgroundColor: 'rgba(' + lColor[i] + ',0.4)',
            borderColor: 'rgba(' + lColor[i] + ',1)',
            data: recVal[i],
            fill: true
          };
        }
        // clear the content if any
        document.getElementById('div_waste').innerHTML = '<canvas id="chart_waste"></canvas>';
        var canvas = document.getElementById('chart_waste');
        var ctx = canvas.getContext('2d');
        _this17.tmpChart = new Chart(ctx, {
          type: 'horizontalBar',
          data: {
            labels: ['Wastage (kg)'],
            datasets: dsets
          },
          options: {
            plugins: {
              datalabels: {
                formatter: function formatter(value) {
                  return value + ' kg';
                },
                color: '#ffffff'
              }
            },
            responsive: true,
            maintainAspectRatio: false,
            legend: {
              display: true,
              position: 'bottom',
              labels: {
                usePointStyle: true,
                fontSize: 11
              }
            },
            scales: {
              xAxes: [{
                ticks: {
                  beginAtZero: true,
                  min: 0
                }
              }]
            },
            hover: {
              animationDuration: 0
            }
          }
        });
      });
    },
    loadSanityChecksWeekly: function loadSanityChecksWeekly() {
      var _this18 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
          from_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.action),
          to_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.rep_to_date)
        }
      };
      this.sanList = [];
      this.lSan = {};
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getSanCheckByCommIdAndcDate/', qry).then(function (response) {
        _this18.sanList = response.data;
        _this18.lSan = __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.unique(_this18.sanList.map(function (rec) {
          return __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDate(rec.c_date);
        }));
      }).catch(function (err) {
        _this18.msg(err, 0);
      });
    },
    loadIncidentWeekly: function loadIncidentWeekly() {
      var _this19 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
          from_dt: this.from_dt,
          to_dt: this.to_dt
        }
      };
      this.lIncident = [];
      this.lInc = {};
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getIncidentListDailyRep/', qry).then(function (response) {
        _this19.lIncident = response.data;
        _this19.lInc = __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.unique(_this19.lIncident.map(function (rec) {
          return __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDate(rec.created_on);
        }));
        _this19.showIncident = true;
      }).catch(function (err) {
        _this19.msg(err, 0);
      });
    },
    showAttendanceSummary: function showAttendanceSummary() {
      var _this20 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
          from_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.action),
          to_dt: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(this.rep_to_date),
          group_by: 'role',
          is_billable: 1
        }
      };
      this.attReport = [];
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getAttendanceRep/', qry).then(function (response) {
        _this20.attReport = response.data;
        // calculate few fields
        _this20.attReport.forEach(function (rec) {
          rec.staff_role = rec.staff_role + ' [' + rec.role_count + ']';
          rec.tot_present = rec.tot_present + rec.tot_hd / 2;
          rec.tot_absent = rec.tot_absent + rec.tot_hd / 2;
        });
        // this.showSummary = true
      }).catch(function (err) {
        _this20.msg(err.response.data, 0);
      });
    }
  }
});

/***/ }),

/***/ 462:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_app_cfg__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_JoinComm__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_JoinComm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_JoinComm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Login__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Login__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['action'],
  data: function data() {
    return {
      gradient: 'to top, rgba(50,50,50, .7), rgba(0,0,0, .7)',
      loading: false,
      comms: [],
      items: [],
      selComm: '',
      search: '',
      joining: false,
      loging: false,
      sbar: false,
      sbarMsg: '',
      sbarCol: 'error',
      config: __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a,
      commCountryCode: '',
      website_url: 'https://uniservice.in',
      commLocConfig: { country_code: 'IN', country: 'India' }
    };
  },
  watch: {
    search: function search(val) {
      if (!val) {
        this.selComm = '';
      } else {
        val && val !== this.select && this.querySelections(val);
      }
    }
  },
  methods: {
    msg: function msg(m) {
      var isError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      this.sbarCol = isError ? 'error' : 'success';
      this.sbar = true;
      this.sbarMsg = m;
    },
    querySelections: function querySelections(v) {
      var _this = this;

      this.loading = true;
      setTimeout(function () {
        _this.items = _this.comms.filter(function (e) {
          return (e || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1;
        });
        _this.loading = false;
      }, 500);
    },
    joinComm: function joinComm() {
      if (this.selComm) {
        this.joining = true;
      } else {
        this.msg('Choose a community to join', true);
      }
    },
    login: function login() {
      this.loging = true;
    },
    changeCountry: function changeCountry(countryCode) {
      this.commCountryCode = countryCode;
      this.commLocConfig = __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.SUPPORTED_COUNTRIES.find(function (rec) {
        return rec.country_code === countryCode;
      });
      localStorage.setItem('WELCOME_COUNTRY_CODE', countryCode);
      this.loadCommList();
      this.$forceUpdate();
    },
    loadCommList: function loadCommList() {
      var _this2 = this;

      var qry = { params: { country_code: this.commCountryCode } };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.API_URL + '/getAvailableCommunity/', qry).then(function (response) {
        _this2.comms = response.data.map(function (rec) {
          return rec.comm_name;
        });
        _this2.querySelections('');
      }).catch(function (err) {
        alert(err.response.data);
      });
    },
    prepareOnboard: function prepareOnboard() {
      this.selComm = '';
      this.joining = true;
    }
  },
  created: function created() {
    var _this3 = this;

    this.commCountryCode = localStorage.getItem('WELCOME_COUNTRY_CODE');
    if (!this.commCountryCode) {
      this.axios.get('https://ip2c.org/s').then(function (response) {
        if (response) {
          var resAry = response.data.split(';');
          _this3.commCountryCode = resAry[1];
          if (__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.SUPPORTED_COUNTRIES.findIndex(function (rec) {
            return rec.country_code === _this3.commCountryCode;
          }) < 0) {
            _this3.commCountryCode = 'IN';
          }
          _this3.changeCountry(_this3.commCountryCode);
        }
      }).catch(function (err) {
        console.log(err);
        _this3.changeCountry('IN');
      });
    } else {
      this.changeCountry(this.commCountryCode);
    }

    if (this.action === 'create') {
      this.prepareOnboard();
    }
  },

  components: {
    'join-comm': __WEBPACK_IMPORTED_MODULE_1__components_JoinComm___default.a,
    login: __WEBPACK_IMPORTED_MODULE_2__components_Login___default.a
  }
});

/***/ }),

/***/ 56:
/***/ (function(module, exports) {

// require('dotenv').config()

/* handy object & functions */
var rules = {
  required: function required(val) {
    return val !== '' || 'Required';
  },
  mobile: function mobile(val) {
    var pattern = /^[0-9]+$/;
    return pattern.test(val) || val === '' || 'Invalid mobile number';
  },
  email: function email(val) {
    return (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(val) || 'E-mail address must be valid'
    );
  },
  minimum: function minimum(val) {
    return val.length >= 5 || 'Min 5 characters';
  }
};

var customToolbar = [['bold', 'italic', 'underline'], [{ 'header': ['1', '2'] }], [{ 'list': 'ordered' }]];

// format the date to DB date
function formatDBDate(dt) {
  var d = new Date(dt);
  var month = '' + (d.getMonth() + 1);
  var day = '' + d.getDate();
  var year = d.getFullYear();

  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;
  return [year, month, day].join('-');
}

// format to desired date to display
function formatDate(dt) {
  var d = new Date(dt);
  var month = '' + (d.getMonth() + 1);
  var day = '' + d.getDate();
  var year = d.getFullYear();

  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;

  return [day, month, year].join('-');
}

// format to desired long date to display
function formatLongDate(dt) {
  var d = new Date(dt);
  var month = d.getMonth();
  var day = '' + d.getDate();
  var year = d.getFullYear();
  if (day.length < 2) day = '0' + day;
  return [day, getMonthName(month), year].join(' ');
}

// get month name
function getMonthName(m) {
  var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return monthNames[m];
}

// format to desired date to display
function formatDateTime(dt) {
  var str = '';
  var today = new Date();
  var d = new Date(dt);
  // check for short forms
  var diff = today - d;
  var min = diff / 60000;
  var hr = min / 60;
  if (hr < 1) {
    str = Math.round(min) + ' min';
  } else if (hr < 12) {
    str = Math.round(hr) + ' hr';
  } else {
    // long time
    str = d.toDateString();
    // strip year if the current year
    if (today.getFullYear() === d.getFullYear()) {
      str = str.substring(0, str.indexOf(today.getFullYear()));
    }
    // with am/pm
    var hours = d.getHours();
    var minutes = d.getMinutes();
    var ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours !== 0 ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    str += ' ' + hours + ':' + minutes + ' ' + ampm;
  }
  return str;
}

// get time from date
function getTime12Hrs(dt) {
  var d = new Date(dt);
  var hours = d.getHours();
  var minutes = d.getMinutes();
  var ampm = hours >= 12 ? 'pm' : 'am';
  hours = hours % 12;
  hours = hours !== 0 ? hours : 12; // the hour '0' should be '12'
  hours = hours < 10 ? '0' + hours : hours;
  minutes = minutes < 10 ? '0' + minutes : minutes;
  return hours + ':' + minutes + ' ' + ampm;
}

// get time from date
function getTime(dt) {
  var d = new Date(dt);
  d = ('00' + d.getHours()).slice(-2) + ':' + ('00' + d.getMinutes()).slice(-2);
  return d;
}

// get hh:mm from date
function getLongTime(dt) {
  var d = new Date(dt);
  d = ('00' + d.getHours()).slice(-2) + ':' + ('00' + d.getMinutes()).slice(-2);
  return d;
}

// format to desired time to display
function formatTime(t) {
  var str = '';
  var hours = t.substring(0, 2);
  var minutes = t.substring(3, 5);
  var ampm = hours >= 12 ? 'pm' : 'am';
  hours = hours % 12;
  hours = hours !== 0 ? hours : 12; // the hour '0' should be '12'
  str = hours + ':' + minutes + '' + ampm;
  return str;
}

// format to desired time to store in DB
function formatDBTime(t) {
  var str = '';
  var hours = t.substring(0, 2);
  var minutes = t.substring(3, 5);
  str = hours + ':' + minutes;
  return str;
}

function dateDiffInDays(a, b) {
  var _MS_PER_DAY = 1000 * 60 * 60 * 24;
  // Discard the time and time-zone information.
  return Math.ceil((b - a) / _MS_PER_DAY) + 1;
}

function dateDiffInMins(a, b) {
  var _MS_PER_MIN = 1000 * 60;
  return Math.round((b - a) / _MS_PER_MIN);
}

function getDatesBetween(startDate, stopDate) {
  var dateArray = [];
  var currentDate = startDate;
  while (currentDate <= stopDate) {
    dateArray.push(new Date(currentDate));
    currentDate = addDays(currentDate, 1);
  }
  return dateArray;
}

function addDays(dt, days) {
  var date = new Date(dt);
  date.setDate(date.getDate() + days);
  return date;
}

// first letter capital
function startWithUpper(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

// function & style to display html content comes out of vue2-editor (to fix spacing issues)
function getEditorStyle() {
  return '<style>p {margin-top:0; margin-bottom:0} ol {margin-left:40px}</style>';
}

function fixHtmlSpacing(str) {
  return str.replace(/<p><br><\/p>/g, '<br>');
}

function unique(list) {
  return list.filter(function (x, i, a) {
    return a.indexOf(x) === i;
  });
}

function diff(a, b) {
  return a.filter(function (i) {
    return b.indexOf(i) < 0;
  });
}

// function to format currency based on the config
function formatCur(amt) {
  var pfix = '';
  var sfix = '';
  amt = amt || 0;
  if (amt < 0) {
    amt = Math.abs(amt);
    pfix = '(';
    sfix = ')';
  }
  return pfix + this.CURRENCY + amt.toLocaleString('en-' + this.COMM_COUNTRY_CODE, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }) + sfix;
}

function formatCurPDF(amt) {
  var pfix = this.COMM_COUNTRY_CODE === 'IN' ? 'INR ' : this.CURRENCY;
  amt = amt || 0;
  return pfix + amt.toLocaleString('en-' + this.COMM_COUNTRY_CODE, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}

function formatDBDateTime(dt) {
  var date = new Date(dt);
  date = date.getFullYear() + '-' + ('00' + (date.getMonth() + 1)).slice(-2) + '-' + ('00' + date.getDate()).slice(-2) + ' ' + ('00' + date.getHours()).slice(-2) + ':' + ('00' + date.getMinutes()).slice(-2) + ':' + ('00' + date.getSeconds()).slice(-2);
  return date;
}

function formatDisplayDateTime(dt) {
  var date = new Date(dt);
  var str = ('00' + date.getDate()).slice(-2) + '-' + ('00' + (date.getMonth() + 1)).slice(-2) + '-' + date.getFullYear() + ' ';
  var hours = ('00' + date.getHours()).slice(-2);
  var minutes = ('00' + date.getMinutes()).slice(-2);
  var ampm = hours >= 12 ? 'pm' : 'am';
  hours = hours % 12;
  hours = hours !== 0 ? hours : 12; // the hour '0' should be '12'
  str = str + hours + ':' + minutes + '' + ampm;

  return str;
}

function html2text(str) {
  return str.replace(/<[^>]*>?/gm, ' ');
}

function getWeekOfTheYear(dt) {
  var date = new Date(dt);
  var oneJan = new Date(date.getFullYear(), 0, 1);
  // calculating number of days
  // in given year before given date
  var numberOfDays = Math.floor((date - oneJan) / (24 * 60 * 60 * 1000));
  // adding 1 since date.getDay()
  // returns value starting from 0
  var getDay = date.getDay() === 1 || date.getDay() === 2 ? 5 : date.getDay();
  return ((getDay + 1 + numberOfDays) / 7).toFixed(0);
}

function getDateOfWeek(w, y) {
  var date = new Date(y, 0, 1 + (w - 1) * 7);
  var day = date.getDay();
  var weekStart = date;
  if (day <= 4) {
    weekStart.setDate(date.getDate() - day + 1);
  } else {
    weekStart.setDate(date.getDate() + 8 - day);
  }
  return formatDBDate(weekStart);
}

function getLastDayoftheMonth(y, m) {
  return new Date(y, m + 1, 0).getDate();
}

function getWeekNumber70(d) {
  // Copy date so don't modify original
  d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  // Set to nearest Thursday: current date + 4 - current day number
  // Make Sunday's day number 7
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
  // Get first day of year
  var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  // Calculate full weeks to nearest Thursday
  var weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
  // Return array of year and week number
  return weekNo;
}

function getWeekNumberOfYear70(d) {
  // Copy date so don't modify original
  d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  // Set to nearest Thursday: current date + 4 - current day number
  // Make Sunday's day number 7
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
  // Get first day of year
  // var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1))
  // Calculate full weeks to nearest Thursday
  // var weekNo = Math.ceil((((d - yearStart) / 86400000) + 1) / 7)
  // Return array of year and week number
  return d.getUTCFullYear();
}
function loadImg(path) {
  var isShared = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  try {
    return 'https://gointegra-fm-space.blr1.digitaloceanspaces.com/' + path;
    // return isShared ? ('https://gointegra-fm-space.blr1.digitaloceanspaces.com/' + path) : ('./assets/' + path)
    // return isShared ? ('assets/common/' + path) : ('./assets/' + path)
  } catch (e) {
    return 'assets/unknown.png';
  }
}

module.exports = {
  // global configs used with in handy js
  CURRENCY: '₹ ',
  COMM_COUNTRY_CODE: 'IN',
  // handy functions
  rules: rules,
  customToolbar: customToolbar,
  formatDate: formatDate,
  formatLongDate: formatLongDate,
  formatDateTime: formatDateTime,
  formatDBDate: formatDBDate,
  getMonthName: getMonthName,
  getTime: getTime,
  getLongTime: getLongTime,
  formatTime: formatTime,
  formatDBTime: formatDBTime,
  dateDiffInDays: dateDiffInDays,
  dateDiffInMins: dateDiffInMins,
  getDatesBetween: getDatesBetween,
  startWithUpper: startWithUpper,
  getEditorStyle: getEditorStyle,
  fixHtmlSpacing: fixHtmlSpacing,
  unique: unique,
  diff: diff,
  formatCur: formatCur,
  formatCurPDF: formatCurPDF,
  formatDBDateTime: formatDBDateTime,
  formatDisplayDateTime: formatDisplayDateTime,
  getTime12Hrs: getTime12Hrs,
  html2text: html2text,
  getWeekOfTheYear: getWeekOfTheYear,
  getWeekNumber70: getWeekNumber70,
  getWeekNumberOfYear70: getWeekNumberOfYear70,
  getDateOfWeek: getDateOfWeek,
  getLastDayoftheMonth: getLastDayoftheMonth,
  loadImg: loadImg
};

/***/ }),

/***/ 713:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 714:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 715:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 716:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 717:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 718:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 746:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 249,
	"./af.js": 249,
	"./ar": 257,
	"./ar-dz": 250,
	"./ar-dz.js": 250,
	"./ar-kw": 251,
	"./ar-kw.js": 251,
	"./ar-ly": 252,
	"./ar-ly.js": 252,
	"./ar-ma": 253,
	"./ar-ma.js": 253,
	"./ar-ps": 254,
	"./ar-ps.js": 254,
	"./ar-sa": 255,
	"./ar-sa.js": 255,
	"./ar-tn": 256,
	"./ar-tn.js": 256,
	"./ar.js": 257,
	"./az": 258,
	"./az.js": 258,
	"./be": 259,
	"./be.js": 259,
	"./bg": 260,
	"./bg.js": 260,
	"./bm": 261,
	"./bm.js": 261,
	"./bn": 263,
	"./bn-bd": 262,
	"./bn-bd.js": 262,
	"./bn.js": 263,
	"./bo": 264,
	"./bo.js": 264,
	"./br": 265,
	"./br.js": 265,
	"./bs": 266,
	"./bs.js": 266,
	"./ca": 267,
	"./ca.js": 267,
	"./cs": 268,
	"./cs.js": 268,
	"./cv": 269,
	"./cv.js": 269,
	"./cy": 270,
	"./cy.js": 270,
	"./da": 271,
	"./da.js": 271,
	"./de": 274,
	"./de-at": 272,
	"./de-at.js": 272,
	"./de-ch": 273,
	"./de-ch.js": 273,
	"./de.js": 274,
	"./dv": 275,
	"./dv.js": 275,
	"./el": 276,
	"./el.js": 276,
	"./en-au": 277,
	"./en-au.js": 277,
	"./en-ca": 278,
	"./en-ca.js": 278,
	"./en-gb": 279,
	"./en-gb.js": 279,
	"./en-ie": 280,
	"./en-ie.js": 280,
	"./en-il": 281,
	"./en-il.js": 281,
	"./en-in": 282,
	"./en-in.js": 282,
	"./en-nz": 283,
	"./en-nz.js": 283,
	"./en-sg": 284,
	"./en-sg.js": 284,
	"./eo": 285,
	"./eo.js": 285,
	"./es": 289,
	"./es-do": 286,
	"./es-do.js": 286,
	"./es-mx": 287,
	"./es-mx.js": 287,
	"./es-us": 288,
	"./es-us.js": 288,
	"./es.js": 289,
	"./et": 290,
	"./et.js": 290,
	"./eu": 291,
	"./eu.js": 291,
	"./fa": 292,
	"./fa.js": 292,
	"./fi": 293,
	"./fi.js": 293,
	"./fil": 294,
	"./fil.js": 294,
	"./fo": 295,
	"./fo.js": 295,
	"./fr": 298,
	"./fr-ca": 296,
	"./fr-ca.js": 296,
	"./fr-ch": 297,
	"./fr-ch.js": 297,
	"./fr.js": 298,
	"./fy": 299,
	"./fy.js": 299,
	"./ga": 300,
	"./ga.js": 300,
	"./gd": 301,
	"./gd.js": 301,
	"./gl": 302,
	"./gl.js": 302,
	"./gom-deva": 303,
	"./gom-deva.js": 303,
	"./gom-latn": 304,
	"./gom-latn.js": 304,
	"./gu": 305,
	"./gu.js": 305,
	"./he": 306,
	"./he.js": 306,
	"./hi": 307,
	"./hi.js": 307,
	"./hr": 308,
	"./hr.js": 308,
	"./hu": 309,
	"./hu.js": 309,
	"./hy-am": 310,
	"./hy-am.js": 310,
	"./id": 311,
	"./id.js": 311,
	"./is": 312,
	"./is.js": 312,
	"./it": 314,
	"./it-ch": 313,
	"./it-ch.js": 313,
	"./it.js": 314,
	"./ja": 315,
	"./ja.js": 315,
	"./jv": 316,
	"./jv.js": 316,
	"./ka": 317,
	"./ka.js": 317,
	"./kk": 318,
	"./kk.js": 318,
	"./km": 319,
	"./km.js": 319,
	"./kn": 320,
	"./kn.js": 320,
	"./ko": 321,
	"./ko.js": 321,
	"./ku": 323,
	"./ku-kmr": 322,
	"./ku-kmr.js": 322,
	"./ku.js": 323,
	"./ky": 324,
	"./ky.js": 324,
	"./lb": 325,
	"./lb.js": 325,
	"./lo": 326,
	"./lo.js": 326,
	"./lt": 327,
	"./lt.js": 327,
	"./lv": 328,
	"./lv.js": 328,
	"./me": 329,
	"./me.js": 329,
	"./mi": 330,
	"./mi.js": 330,
	"./mk": 331,
	"./mk.js": 331,
	"./ml": 332,
	"./ml.js": 332,
	"./mn": 333,
	"./mn.js": 333,
	"./mr": 334,
	"./mr.js": 334,
	"./ms": 336,
	"./ms-my": 335,
	"./ms-my.js": 335,
	"./ms.js": 336,
	"./mt": 337,
	"./mt.js": 337,
	"./my": 338,
	"./my.js": 338,
	"./nb": 339,
	"./nb.js": 339,
	"./ne": 340,
	"./ne.js": 340,
	"./nl": 342,
	"./nl-be": 341,
	"./nl-be.js": 341,
	"./nl.js": 342,
	"./nn": 343,
	"./nn.js": 343,
	"./oc-lnc": 344,
	"./oc-lnc.js": 344,
	"./pa-in": 345,
	"./pa-in.js": 345,
	"./pl": 346,
	"./pl.js": 346,
	"./pt": 348,
	"./pt-br": 347,
	"./pt-br.js": 347,
	"./pt.js": 348,
	"./ro": 349,
	"./ro.js": 349,
	"./ru": 350,
	"./ru.js": 350,
	"./sd": 351,
	"./sd.js": 351,
	"./se": 352,
	"./se.js": 352,
	"./si": 353,
	"./si.js": 353,
	"./sk": 354,
	"./sk.js": 354,
	"./sl": 355,
	"./sl.js": 355,
	"./sq": 356,
	"./sq.js": 356,
	"./sr": 358,
	"./sr-cyrl": 357,
	"./sr-cyrl.js": 357,
	"./sr.js": 358,
	"./ss": 359,
	"./ss.js": 359,
	"./sv": 360,
	"./sv.js": 360,
	"./sw": 361,
	"./sw.js": 361,
	"./ta": 362,
	"./ta.js": 362,
	"./te": 363,
	"./te.js": 363,
	"./tet": 364,
	"./tet.js": 364,
	"./tg": 365,
	"./tg.js": 365,
	"./th": 366,
	"./th.js": 366,
	"./tk": 367,
	"./tk.js": 367,
	"./tl-ph": 368,
	"./tl-ph.js": 368,
	"./tlh": 369,
	"./tlh.js": 369,
	"./tr": 370,
	"./tr.js": 370,
	"./tzl": 371,
	"./tzl.js": 371,
	"./tzm": 373,
	"./tzm-latn": 372,
	"./tzm-latn.js": 372,
	"./tzm.js": 373,
	"./ug-cn": 374,
	"./ug-cn.js": 374,
	"./uk": 375,
	"./uk.js": 375,
	"./ur": 376,
	"./ur.js": 376,
	"./uz": 378,
	"./uz-latn": 377,
	"./uz-latn.js": 377,
	"./uz.js": 378,
	"./vi": 379,
	"./vi.js": 379,
	"./x-pseudo": 380,
	"./x-pseudo.js": 380,
	"./yo": 381,
	"./yo.js": 381,
	"./zh-cn": 382,
	"./zh-cn.js": 382,
	"./zh-hk": 383,
	"./zh-hk.js": 383,
	"./zh-mo": 384,
	"./zh-mo.js": 384,
	"./zh-tw": 385,
	"./zh-tw.js": 385
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 746;

/***/ }),

/***/ 756:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(718)
}
var Component = __webpack_require__(35)(
  /* script */
  __webpack_require__(456),
  /* template */
  __webpack_require__(765),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 757:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(715)
}
var Component = __webpack_require__(35)(
  /* script */
  __webpack_require__(455),
  /* template */
  __webpack_require__(758),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 758:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.iso) ? _c('span', {
    staticClass: "flag-icon",
    class: _vm.flagIconClass,
    attrs: {
      "title": _vm.title || _vm.iso
    }
  }) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 759:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-tabs', {
    attrs: {
      "flat": "",
      "color": "primary",
      "dark": "",
      "grow": "",
      "height": "40",
      "fixed-tabs": ""
    },
    on: {
      "change": function($event) {
        return _vm.refreshData()
      }
    },
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, _vm._l((_vm.tabitems), function(tabitem, n) {
    return _c('v-tab', {
      key: n,
      attrs: {
        "href": ("#tab-" + n)
      }
    }, [_vm._v("\n          " + _vm._s(tabitem) + "\n        ")])
  }), 1), _vm._v(" "), _c('v-tabs-items', {
    on: {
      "change": function($event) {
        return _vm.refreshData()
      }
    },
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_vm._l((_vm.tabitems), function(tabitem, n) {
    return _c('v-tab-item', {
      key: n,
      attrs: {
        "value": ("tab-" + n)
      }
    }, [(tabitem === 'General') ? _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [(_vm.lCompAdr) ? _c('v-card', {
      staticClass: "pa-0",
      attrs: {
        "flat": ""
      }
    }, [_c('v-card-title', {
      staticClass: "primary--text subheader pb-0"
    }, [_vm._v("Complaints can be addressed to")]), _vm._v(" "), _c('v-card-text', {
      staticClass: "pt-0"
    }, [(_vm.isHDPresent) ? _c('v-checkbox', {
      attrs: {
        "hide-details": "",
        "label": "Helpdesk Executive"
      },
      on: {
        "change": _vm.saveCompSet
      },
      model: {
        value: (_vm.lCompAdr.is_hd_enabled),
        callback: function($$v) {
          _vm.$set(_vm.lCompAdr, "is_hd_enabled", $$v)
        },
        expression: "lCompAdr.is_hd_enabled"
      }
    }) : _vm._e(), _vm._v(" "), (_vm.isFMPresent) ? _c('v-checkbox', {
      attrs: {
        "hide-details": "",
        "label": "FM"
      },
      on: {
        "change": _vm.saveCompSet
      },
      model: {
        value: (_vm.lCompAdr.is_fm_enabled),
        callback: function($$v) {
          _vm.$set(_vm.lCompAdr, "is_fm_enabled", $$v)
        },
        expression: "lCompAdr.is_fm_enabled"
      }
    }) : _vm._e(), _vm._v(" "), _c('v-checkbox', {
      attrs: {
        "hide-details": "",
        "label": "Mgmt Committee"
      },
      on: {
        "change": _vm.saveCompSet
      },
      model: {
        value: (_vm.lCompAdr.is_mc_enabled),
        callback: function($$v) {
          _vm.$set(_vm.lCompAdr, "is_mc_enabled", $$v)
        },
        expression: "lCompAdr.is_mc_enabled"
      }
    })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.lAction === 'view') ? _c('v-card', {
      attrs: {
        "flat": ""
      }
    }, [_c('v-card-title', {
      staticClass: "primary--text subheader pb-0"
    }, [_vm._v("Services / Complaint categories")]), _vm._v(" "), _c('v-card-text', [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm9": "",
        "md6": ""
      }
    }, [_c('v-btn', {
      staticStyle: {
        "float": "right"
      },
      attrs: {
        "color": "accent mb-0",
        "flat": ""
      },
      on: {
        "click": _vm.prepareCreate
      }
    }, [_vm._v("Add New")]), _vm._v(" "), _c('v-data-table', {
      staticClass: "elevation-3",
      attrs: {
        "headers": _vm.catSet,
        "items": _vm.catList,
        "hide-actions": "",
        "disable-initial-sort": ""
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('tr', {
            on: {
              "click": function($event) {
                return _vm.prepareEdit(props.item)
              }
            }
          }, [_c('td', [_vm._v(_vm._s(props.item.comp_cat))])])]
        }
      }], null, true)
    })], 1)], 1)], 1) : _vm._e()], 1)], 1) : _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm9": "",
        "md6": ""
      }
    }, [_c('v-form', {
      on: {
        "submit": function($event) {
          $event.preventDefault();
          return _vm.saveChangesSla.apply(null, arguments)
        }
      }
    }, [_c('v-card', {
      attrs: {
        "flat": ""
      }
    }, [_c('v-card-title', {
      staticClass: "primary--text subheader"
    }, [_vm._v("\n                    SLA\n                  ")]), _vm._v(" "), _c('v-card-text', {
      staticClass: "pt-0"
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticClass: "mt-1",
      attrs: {
        "xs2": ""
      }
    }, [_c('span', [_vm._v("Critical")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs1": ""
      }
    }, [_c('v-text-field', {
      staticClass: "mt-0 pt-0",
      attrs: {
        "hide-details": ""
      },
      model: {
        value: (_vm.lCompSla.sla_critical),
        callback: function($$v) {
          _vm.$set(_vm.lCompSla, "sla_critical", $$v)
        },
        expression: "lCompSla.sla_critical"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      staticClass: "mt-1",
      attrs: {
        "xs2": ""
      }
    }, [_vm._v("\n                        Hours\n                      ")])], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticClass: "mt-1",
      attrs: {
        "xs2": ""
      }
    }, [_c('span', [_vm._v("Major")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs1": ""
      }
    }, [_c('v-text-field', {
      staticClass: "mt-0 pt-0",
      attrs: {
        "hide-details": ""
      },
      model: {
        value: (_vm.lCompSla.sla_major),
        callback: function($$v) {
          _vm.$set(_vm.lCompSla, "sla_major", $$v)
        },
        expression: "lCompSla.sla_major"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      staticClass: "mt-1",
      attrs: {
        "xs2": ""
      }
    }, [_vm._v("\n                        Hours\n                      ")])], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticClass: "mt-1",
      attrs: {
        "xs2": ""
      }
    }, [_c('span', [_vm._v("Normal")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs1": ""
      }
    }, [_c('v-text-field', {
      staticClass: "mt-0 pt-0",
      attrs: {
        "hide-details": ""
      },
      model: {
        value: (_vm.lCompSla.sla_normal),
        callback: function($$v) {
          _vm.$set(_vm.lCompSla, "sla_normal", $$v)
        },
        expression: "lCompSla.sla_normal"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      staticClass: "mt-1",
      attrs: {
        "xs2": ""
      }
    }, [_vm._v("\n                        Hours\n                      ")])], 1)], 1), _vm._v(" "), _c('v-card-actions', {
      staticClass: "pt-0"
    }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
      attrs: {
        "type": "submit",
        "color": "accent"
      }
    }, [_vm._v("save")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm9": "",
        "md6": ""
      }
    }, [_c('span', {
      staticClass: "primary--text subheader"
    }, [_vm._v("SLA Escalation")]), _vm._v(" "), _c('v-form', {
      on: {
        "submit": function($event) {
          $event.preventDefault();
          return _vm.saveChangesSlaEsc.apply(null, arguments)
        }
      }
    }, [_c('v-card', {
      attrs: {
        "flat": ""
      }
    }, [_c('v-card-title', {
      staticClass: "title pb-0"
    }, [_vm._v("\n                    Level 1\n                  ")]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-text-field', {
      attrs: {
        "label": "Email list (comma seperated)",
        "hide-details": "",
        "maxlength": "200"
      },
      model: {
        value: (_vm.lCompSlaEsc.l1_email_list),
        callback: function($$v) {
          _vm.$set(_vm.lCompSlaEsc, "l1_email_list", $$v)
        },
        expression: "lCompSlaEsc.l1_email_list"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      staticClass: "mt-3 pb-0",
      attrs: {
        "xs7": "",
        "sm5": ""
      }
    }, [_c('v-switch', {
      attrs: {
        "label": "Notify via SMS",
        "hide-details": ""
      },
      model: {
        value: (_vm.lCompSlaEsc.l1_sms_enabled),
        callback: function($$v) {
          _vm.$set(_vm.lCompSlaEsc, "l1_sms_enabled", $$v)
        },
        expression: "lCompSlaEsc.l1_sms_enabled"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm7": ""
      }
    }, [_c('v-text-field', {
      attrs: {
        "disabled": !_vm.lCompSlaEsc.l1_sms_enabled,
        "label": "Phone number list",
        "hint": "Eg:- 9741012345,0014266471234",
        "persistent-hint": "",
        "maxlength": "200"
      },
      model: {
        value: (_vm.lCompSlaEsc.l1_phone_list),
        callback: function($$v) {
          _vm.$set(_vm.lCompSlaEsc, "l1_phone_list", $$v)
        },
        expression: "lCompSlaEsc.l1_phone_list"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('v-card-title', {
      staticClass: "title pb-0 mt-2"
    }, [_vm._v("\n                Level 2\n              ")]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-text-field', {
      attrs: {
        "label": "Email list (comma seperated)",
        "hide-details": "",
        "maxlength": "200"
      },
      model: {
        value: (_vm.lCompSlaEsc.l2_email_list),
        callback: function($$v) {
          _vm.$set(_vm.lCompSlaEsc, "l2_email_list", $$v)
        },
        expression: "lCompSlaEsc.l2_email_list"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      staticClass: "mt-3 pb-0",
      attrs: {
        "xs7": "",
        "sm5": ""
      }
    }, [_c('v-switch', {
      attrs: {
        "label": "Notify via SMS",
        "hide-details": ""
      },
      model: {
        value: (_vm.lCompSlaEsc.l2_sms_enabled),
        callback: function($$v) {
          _vm.$set(_vm.lCompSlaEsc, "l2_sms_enabled", $$v)
        },
        expression: "lCompSlaEsc.l2_sms_enabled"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm7": ""
      }
    }, [_c('v-text-field', {
      attrs: {
        "disabled": !_vm.lCompSlaEsc.l2_sms_enabled,
        "label": "Phone number list",
        "hint": "Eg:- 9741012345,0014266471234",
        "persistent-hint": "",
        "maxlength": "200"
      },
      model: {
        value: (_vm.lCompSlaEsc.l2_phone_list),
        callback: function($$v) {
          _vm.$set(_vm.lCompSlaEsc, "l2_phone_list", $$v)
        },
        expression: "lCompSlaEsc.l2_phone_list"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
      staticClass: "pt-0"
    }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
      attrs: {
        "type": "submit",
        "color": "accent"
      }
    }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)
  }), _vm._v(" "), (_vm.lAction === 'create' || _vm.lAction === 'update') ? _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": "",
      "full-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-form', {
    ref: "lForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveChanges(_vm.lAction)
      }
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm9": "",
      "mx-auto": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title pb-0"
  }, [_vm._v("\n              " + _vm._s(_vm.handy.startWithUpper(_vm.lAction)) + " category\n            ")]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mt-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Category",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "25"
    },
    model: {
      value: (_vm.lCompCat.comp_cat),
      callback: function($$v) {
        _vm.$set(_vm.lCompCat, "comp_cat", $$v)
      },
      expression: "lCompCat.comp_cat"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.cancelChanges.apply(null, arguments)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.lAction === 'update') ? _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.deleteCat(_vm.lCompCat)
      }
    }
  }, [_vm._v("delete")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "type": "submit",
      "color": "accent",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.sbarCol,
      "timeout": 2000,
      "multi-line": ""
    },
    model: {
      value: (_vm.sbar),
      callback: function($$v) {
        _vm.sbar = $$v
      },
      expression: "sbar"
    }
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.sbarMsg))])])], 2)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 760:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('router-link', {
    staticStyle: {
      "text-decoration": "none",
      "color": "black"
    },
    attrs: {
      "to": {
        path: '/Facdash/'
      }
    }
  }, [_c('v-btn', {
    staticClass: "px-0 pb-0 pt-2 ml-0",
    attrs: {
      "small": "",
      "flat": ""
    }
  }, [_c('v-icon', [_vm._v("keyboard_backspace")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-btn', {
    staticClass: "accent",
    on: {
      "click": _vm.downoadAsPdf
    }
  }, [_vm._v("Download As Pdf")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "id": "pdf_report"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 title"
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-left pt-2"
  }, [_vm._v(_vm._s(_vm.lReport.comm_name) + " - FM Weekly Report (" + _vm._s(_vm.lReport.rep_date) + " - " + _vm._s(this.repo_to_date) + ")")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-right"
  }, [_c('img', {
    attrs: {
      "height": "100",
      "width": "250",
      "src": __webpack_require__(169)
    }
  })])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-divider', {
    staticStyle: {
      "border-top": "3px solid black"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center title py-1 warning--text"
  }, [_vm._v("Attendance Summary")])]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "border": "1px solid black"
    },
    attrs: {
      "pa-0": ""
    }
  }, [_c('v-card-text', {
    attrs: {
      "pa-0": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.$vuetify.breakpoint.smAndUp ? _vm.repHeadSm : _vm.repHead,
      "items": _vm.attReport,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_vm._v(_vm._s(props.item.staff_role))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.tot_present))]), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.tot_wo))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.tot_holiday))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.tot_ot))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.tot_leave))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.tot_absent))]) : _vm._e(), _vm._v(" "), _c('td', {
          staticClass: "red--text pa-0"
        }, [_vm._v(_vm._s(props.item.tot_pend))])])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center title py-2 warning--text"
  }, [_vm._v("Power Management")])]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "border": "1px solid black"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center py-2",
    staticStyle: {
      "font-size": "12px",
      "background-color": "#215868",
      "color": "#fff"
    }
  }, [_vm._v("CONSUMPTION")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center primary white--text py-4",
    staticStyle: {
      "font-size": "12px",
      "height": "78px"
    },
    attrs: {
      "xs4": ""
    }
  }, [_c('span', [_vm._v("EB")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center py-4",
    attrs: {
      "xs8": ""
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.lReport.eb_unit ? _vm.lReport.eb_unit.toFixed(0) : '0') + " units")])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center mt-0 primary white--text py-4",
    staticStyle: {
      "font-size": "12px",
      "height": "78px"
    },
    attrs: {
      "xs4": ""
    }
  }, [_c('span', [_vm._v("DG")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center py-4",
    attrs: {
      "xs8": ""
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.lReport.dg_unit ? _vm.lReport.dg_unit.toFixed(0) : '0') + " units")])])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": "",
      "sm10": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center py-2",
    staticStyle: {
      "font-size": "12px",
      "background-color": "#215868",
      "color": "#fff"
    }
  }, [_vm._v("DISTRIBUTION (UNITS)")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center",
    attrs: {
      "id": "div_powercons"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "chart_powercons"
    }
  })])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-4 py-0",
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center",
    attrs: {
      "id": "div_powergenset"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "chart_powergenset"
    }
  })])])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mt-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-0",
    staticStyle: {
      "border": "1px solid black"
    },
    attrs: {
      "xs8": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center py-2",
    staticStyle: {
      "font-size": "12px",
      "background-color": "#215868",
      "color": "#fff"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('div', [_vm._v("DG SUMMARY")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.gensetHead), function(genset, i) {
    return _c('v-flex', {
      key: i,
      staticClass: "primary white--text text-xs-center py-2"
    }, [_c('span', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(genset.text))])])
  }), 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "hide-headers": "",
      "disable-initial-sort": "",
      "items": _vm.gensetList,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          staticClass: "text-xs-center"
        }, [_c('td', {
          staticClass: "pa-0",
          staticStyle: {
            "font-size": "12px",
            "width": "139px"
          }
        }, [_vm._v(_vm._s(props.item.genset_nm ? props.item.genset_nm : '-'))]), _vm._v(" "), _c('td', {
          staticClass: "pa-0",
          staticStyle: {
            "font-size": "12px",
            "width": "139px"
          }
        }, [_vm._v(_vm._s(props.item.units_cons ? props.item.units_cons : '-'))]), _vm._v(" "), _c('td', {
          staticClass: "pa-0",
          staticStyle: {
            "font-size": "12px",
            "width": "139px"
          }
        }, [_vm._v(_vm._s(props.item.level ? props.item.level + '%' : '-'))]), _vm._v(" "), _c('td', {
          staticClass: "pa-0",
          staticStyle: {
            "font-size": "12px",
            "width": "139px"
          }
        }, [_vm._v(_vm._s(props.item.run_hrs ? props.item.run_hrs : '-'))])])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    staticStyle: {
      "border-top": "1px solid black",
      "border-bottom": "1px solid black",
      "border-right": "1px solid black"
    },
    attrs: {
      "xs4": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center py-2",
    staticStyle: {
      "font-size": "12px",
      "background-color": "#215868",
      "color": "#fff"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('div', [_vm._v("DIESEL PURCHASE & STOCK")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.dieselHead), function(diesel, i) {
    return _c('v-flex', {
      key: i,
      staticClass: "primary white--text text-xs-center py-2",
      attrs: {
        "xs6": ""
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(diesel.text))])])
  }), 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "hide-headers": "",
      "disable-initial-sort": "",
      "items": _vm.dieselList,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          staticClass: "text-xs-center"
        }, [_c('td', {
          staticClass: "pa-0",
          staticStyle: {
            "font-size": "12px",
            "width": "173px"
          }
        }, [_vm._v(_vm._s(props.item.diesel_nm ? props.item.diesel_nm : '-'))]), _vm._v(" "), _c('td', {
          staticClass: "pa-0",
          staticStyle: {
            "font-size": "12px",
            "width": "173px"
          }
        }, [_vm._v(_vm._s(props.item.val ? props.item.val : '-'))])])]
      }
    }])
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.lReport.remark_power) ? _c('div', {
    staticClass: "caption pl-1"
  }, [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "font-weight": "bold"
    }
  }, [_vm._v("Remark:")]), _vm._v(" " + _vm._s(_vm.lReport.remark_power) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": "",
      "id": _vm.dieselList.length < 4 ? 'pageBreak' : ''
    }
  }, [_c('div', {
    staticClass: "text-xs-center title py-2 warning--text"
  }, [_vm._v("Water Management")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    staticStyle: {
      "border": "1px solid black"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "px-0",
    attrs: {
      "xs12": "",
      "sm5": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center py-2",
    staticStyle: {
      "font-size": "12px",
      "background-color": "#215868",
      "color": "#fff"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('span', [_vm._v("CONSUMPTION-Domestic (KL)")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs10": ""
    }
  }, [_c('div', {
    attrs: {
      "id": "div_watercons"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "chart_watercons"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "subheading pl-1"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Total water consumed: " + _vm._s(_vm.lReport.tot_water_cons > 0 ? _vm.lReport.tot_water_cons.toFixed(0) + ' KL' : '0 KL'))])])])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "px-0",
    attrs: {
      "xs12": "",
      "sm5": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center py-2",
    staticStyle: {
      "font-size": "12px",
      "background-color": "#215868",
      "color": "#fff"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('span', [_vm._v("CONSUMPTION-Treated (KL)")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs10": ""
    }
  }, [_c('div', {
    attrs: {
      "id": "div_watercons"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "chart_watercons"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "subheading pl-1"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Total water consumed: " + _vm._s(_vm.lReport.tot_water_cons > 0 ? _vm.lReport.tot_water_cons.toFixed(0) + ' KL' : '0 KL'))])])])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "px-0",
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center py-2",
    staticStyle: {
      "font-size": "12px",
      "background-color": "#215868",
      "color": "#fff"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('span', [_vm._v("SOURCES (KL)")])]), _vm._v(" "), _vm._l((_vm.domWatList), function(wat, i) {
    return _c('v-flex', {
      key: i,
      staticClass: "py-2 pl-2",
      attrs: {
        "xs12": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticClass: "text-xs-left",
      attrs: {
        "xs9": ""
      }
    }, [_c('div', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(wat.water_type))])]), _vm._v(" "), _c('v-flex', {
      staticClass: "text-xs-left title",
      attrs: {
        "xs3": ""
      }
    }, [_c('div', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(wat.water_receipt ? wat.water_receipt.toFixed(0) : 0))])])], 1)], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "subheading pl-1"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Total Water Source: " + _vm._s(_vm.lReport.tot_water_source > 0 ? _vm.lReport.tot_water_source.toFixed(0) + ' KL' : '0 KL'))])])], 2)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center mt-2 py-2",
    staticStyle: {
      "font-size": "12px",
      "background-color": "#215868",
      "color": "#fff"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('div', [_vm._v("WATER QUALITY & CONTROL")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    staticStyle: {
      "border": "1px solid black"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.paramHead), function(param, i) {
    return _c('v-flex', {
      key: i,
      staticClass: "primary white--text text-xs-center py-2"
    }, [_c('span', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(param.text))])])
  }), 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "hide-headers": "",
      "items": _vm.paramList,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          staticClass: "text-xs-center"
        }, [_c('td', {
          staticClass: "pa-0",
          staticStyle: {
            "font-size": "12px",
            "width": "174px"
          }
        }, [_vm._v(_vm._s(props.item.water_qual))]), _vm._v(" "), _vm._l((props.item.waterQualTypeValue), function(watQualVal, i) {
          return _c('td', {
            key: i,
            class: 'pa-0 ' + (watQualVal.val && (watQualVal.val < watQualVal.stdValMin || watQualVal.val > watQualVal.stdValMax) ? 'red white--text' : (watQualVal.val ? 'green lighten-3' : '')),
            staticStyle: {
              "font-size": "12px",
              "width": "174px"
            }
          }, [_vm._v("\n              " + _vm._s(watQualVal.val ? watQualVal.val : '-') + "\n            ")])
        })], 2)]
      }
    }])
  })], 1), _vm._v(" "), (_vm.lReport.remark_water) ? _c('div', {
    staticClass: "caption pl-1"
  }, [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "font-weight": "bold"
    }
  }, [_vm._v("Remark:")]), _vm._v(" " + _vm._s(_vm.lReport.remark_water) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center title py-2 warning--text"
  }, [_vm._v("Waste Management")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    staticStyle: {
      "border": "1px solid black"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center",
    attrs: {
      "id": "div_waste"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "chart_waste"
    }
  })])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": "",
      "id": "pageBreak"
    }
  }, [_c('div', {
    staticClass: "text-xs-center title py-2 warning--text"
  }, [_vm._v("Hygiene Management / Sanity Checks")]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "border": "1px solid black"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center py-2",
    staticStyle: {
      "font-size": "12px",
      "background-color": "#215868",
      "color": "#fff"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('span', [_vm._v("SANITY CHECKS")])])], 1)], 1), _vm._v(" "), _c('v-card-text', _vm._l((_vm.lSan), function(item, n) {
    return _c('v-flex', {
      key: n,
      class: n > 0 ? 'mt-2' : '',
      attrs: {
        "xs12": ""
      }
    }, [_c('div', {
      staticClass: "pa-2 primary white--text"
    }, [_vm._v(_vm._s(item))]), _vm._v(" "), _c('v-data-table', {
      staticClass: "elevation-1",
      attrs: {
        "headers": _vm.sanHeads,
        "items": _vm.sanList.filter(function (rec) { return _vm.handy.formatDate(rec.c_date) === item; }),
        "hide-actions": "",
        "disable-initial-sort": ""
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('tr', [_c('td', {
            staticClass: "text-xs-right",
            staticStyle: {
              "width": "50px"
            }
          }, [_c('v-checkbox', {
            staticClass: "pt-2",
            attrs: {
              "hide-details": "",
              "readonly": ""
            },
            model: {
              value: (props.item.check_value),
              callback: function($$v) {
                _vm.$set(props.item, "check_value", $$v)
              },
              expression: "props.item.check_value"
            }
          })], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.check_cat))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.check_desc))]), _vm._v(" "), _c('td', {
            staticStyle: {
              "width": "340px"
            }
          }, [_vm._v(_vm._s(props.item.remark ? props.item.remark : '-'))])])]
        }
      }], null, true)
    })], 1)
  }), 1)], 1), _vm._v(" "), (_vm.lReport.remark_sanity_checks) ? _c('div', {
    staticClass: "caption pl-1"
  }, [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "font-weight": "bold"
    }
  }, [_vm._v("Remark:")]), _vm._v(" " + _vm._s(_vm.lReport.remark_sanity_checks) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center title py-2 warning--text"
  }, [_vm._v("Safety & Security")])]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "border": "1px solid black"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center py-2",
    staticStyle: {
      "font-size": "12px",
      "background-color": "#215868",
      "color": "#fff"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('span', [_vm._v("INCIDENTS")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    staticStyle: {
      "border-top": "1px solid black"
    },
    attrs: {
      "xs12": ""
    }
  }, _vm._l((_vm.incidentTypes), function(incident, n) {
    return _c('v-flex', {
      key: n,
      staticClass: "pa-0",
      attrs: {
        "xs12": ""
      }
    }, [_c('div', {
      staticClass: "text-xs-left pa-2 primary white--text",
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(incident))]), _vm._v(" "), _c('v-flex', {
      staticClass: "pa-0",
      attrs: {
        "xs12": ""
      }
    }, [_c('v-data-table', {
      attrs: {
        "hide-headers": "",
        "items": _vm.incidentList.filter(function (rec) { return rec.incident_type === incident; }),
        "hide-actions": "",
        "disable-initial-sort": ""
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('tr', [_c('td', {
            staticStyle: {
              "font-size": "12px",
              "width": "315px"
            }
          }, [_vm._v(_vm._s(props.item.incident_class))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.incident_on ? (_vm.handy.formatDate(props.item.incident_on) + ' ' + _vm.handy.getTime12Hrs(props.item.incident_on) + (props.item.incident_end ? ' to ' + _vm.handy.formatDate(props.item.incident_end) + ' ' + _vm.handy.getTime12Hrs(props.item.incident_end) : '') + ' - ' + props.item.incident_desc) : ''))])])]
        }
      }], null, true)
    })], 1)], 1)
  }), 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center title py-2 warning--text"
  }, [_vm._v("52 Week PPM Planner")])]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "border": "1px solid black"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center py-2",
    staticStyle: {
      "font-size": "12px",
      "background-color": "#215868",
      "color": "#fff"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('span', [_vm._v("PPM PLANNER")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    staticStyle: {
      "border-top": "1px solid black"
    },
    attrs: {
      "xs12": ""
    }
  }, [(_vm.lPpmHeader.length > 0) ? _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.ppmHeader), function(ppm, i) {
    return _c('v-flex', {
      key: i,
      staticClass: "primary white--text text-xs-left pa-2"
    }, [_c('span', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(ppm.text))])])
  }), 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "hide-headers": "",
      "items": _vm.lPpmHeader,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          staticClass: "text-xs-left"
        }, [_c('td', {
          staticClass: "pa-2",
          staticStyle: {
            "font-size": "12px",
            "width": "162px"
          }
        }, [_vm._v(_vm._s(props.item.asset_tag ? props.item.asset_tag : '-'))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2",
          staticStyle: {
            "font-size": "12px",
            "width": "158px"
          }
        }, [_vm._v(_vm._s(props.item.asset_cat ? props.item.asset_cat : '-'))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2",
          staticStyle: {
            "font-size": "12px",
            "width": "191px"
          }
        }, [_vm._v(_vm._s(props.item.noneq_name ? props.item.noneq_name : '-'))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2",
          staticStyle: {
            "font-size": "12px",
            "width": "164px"
          }
        }, [_vm._v(_vm._s(props.item.freq))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2",
          staticStyle: {
            "font-size": "12px",
            "width": "156px"
          }
        }, [_vm._v(_vm._s(props.item.asset_location ? props.item.asset_location : '-'))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2",
          staticStyle: {
            "font-size": "12px"
          }
        }, [_vm._v(_vm._s(props.item.ppm_status))])])]
      }
    }], null, false, 3576252940)
  })], 1) : _c('v-flex', {
    staticClass: "pl-4",
    attrs: {
      "xs12": ""
    }
  }, [_vm._v("\n      NIL\n    ")])], 1)], 1)], 1), _vm._v(" "), (_vm.lReport.remark_custom_metrics) ? _c('div', {
    staticClass: "caption pl-1"
  }, [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "font-weight": "bold"
    }
  }, [_vm._v("Remark:")]), _vm._v(" " + _vm._s(_vm.lReport.remark_custom_metrics) + "\n")]) : _vm._e(), _vm._v(" "), (_vm.lReport.major_observ) ? _c('div', {
    staticClass: "caption pa-1"
  }, [_c('div', {
    staticClass: "text-xs-center title py-2 warning--text"
  }, [_vm._v("Major Observation")]), _vm._v(" "), _c('div', {
    staticClass: "pa-1",
    staticStyle: {
      "font-size": "12px",
      "border": "1px solid black"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.handy.getEditorStyle() + _vm.lReport.major_observ)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.lDailyUpdateAttach.files && _vm.lDailyUpdateAttach.files.length > 0) ? _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": "",
      "id": "pageBreak"
    }
  }, [_c('div', {
    staticStyle: {
      "color": "#ff7f2a",
      "font-size": "20px",
      "font-weight": "bold",
      "text-align": "center",
      "padding": "7px 0px"
    }
  }, [_vm._v("Photos")])]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [(_vm.lDailyUpdateAttach.files && _vm.lDailyUpdateAttach.files.length > 0) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.lDailyUpdateAttach.files), function(file, index) {
    return _c('v-flex', {
      key: index,
      staticClass: "pa-1 text-xs-center",
      attrs: {
        "xs12": "",
        "sm4": ""
      }
    }, [_c('v-card-media', {
      staticClass: "black--text caption",
      attrs: {
        "height": "210px",
        "src": file.file_url
      }
    }, [_c('div', {
      staticClass: "white--text",
      staticStyle: {
        "background-color": "rgba(125, 125, 125, 0.5)"
      }
    }, [_vm._v(_vm._s(_vm.handy.formatDBDateTime(file.attach_timestamp))), _c('br'), _vm._v("by " + _vm._s(file.user_name))]), _vm._v(" "), (file.notes) ? _c('div', {
      staticClass: "text-xs-center white--text",
      staticStyle: {
        "position": "absolute",
        "bottom": "0px",
        "width": "100%",
        "background-color": "rgba(0, 0, 255, 0.5)"
      }
    }, [_vm._v("\n          " + _vm._s(file.notes) + "\n        ")]) : _vm._e()])], 1)
  }), 1) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.sbarCol,
      "timeout": 2000,
      "multi-line": ""
    },
    model: {
      value: (_vm.sbar),
      callback: function($$v) {
        _vm.sbar = $$v
      },
      expression: "sbar"
    }
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.sbarMsg))])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 761:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "max-width": "600",
      "persistent": ""
    },
    model: {
      value: (_vm.showDlg),
      callback: function($$v) {
        _vm.showDlg = $$v
      },
      expression: "showDlg"
    }
  }, [_c('div', {
    staticClass: "primary white--text pa-3 title"
  }, [(_vm.isNewComm) ? _c('span', [_vm._v("New community creation")]) : _c('span', [_vm._v("Joining to " + _vm._s(_vm.commNm))])]), _vm._v(" "), _c('v-stepper', {
    model: {
      value: (_vm.curStep),
      callback: function($$v) {
        _vm.curStep = _vm._n($$v)
      },
      expression: "curStep"
    }
  }, [_c('v-stepper-header', [_c('v-stepper-step', {
    attrs: {
      "step": "1",
      "complete": _vm.curStep > 1
    }
  }, [_vm._v("Mobile validation")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "step": "2",
      "complete": _vm.curStep > 2
    }
  }, [_vm._v("Personal details")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "step": "3",
      "complete": _vm.curStep > 3
    }
  }, [_vm._v(_vm._s(_vm.isNewComm ? 'Community details' : 'Unit details'))]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "step": "4"
    }
  }, [_vm._v("Done")])], 1), _vm._v(" "), _c('v-stepper-items', [_c('v-stepper-content', {
    staticClass: "pl-0 pr-0",
    attrs: {
      "step": "1"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title pt-0"
  }, [_vm._v("Mobile validation")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "py-0"
  }, [_c('v-form', {
    ref: "form1"
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('vue-tel-input-vuetify', {
    ref: "refMob",
    attrs: {
      "label": "",
      "placeholder": "Enter a mobile number",
      "rules": [_vm.rules.required],
      "input-options": {
        showDialCode: true
      }
    },
    on: {
      "input": _vm.keepCursor,
      "validate": _vm.validateMob
    },
    nativeOn: {
      "keydown": function($event) {
        return _vm.ignoreBackspace.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.mobile),
      callback: function($$v) {
        _vm.mobile = $$v
      },
      expression: "mobile"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v("\n                          Enter your mobile number and press send OTP\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "text-xs-right"
  }, [(_vm.secToWait > 0) ? _c('span', {
    staticClass: "caption grey--text"
  }, [_vm._v("Wait " + _vm._s(_vm.secToWait) + " sec to retry")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-0 pa-0 accent--text",
    attrs: {
      "flat": "",
      "disabled": (!_vm.canResend && !_vm.isValidNumber) || _vm.secToWait > 0
    },
    on: {
      "click": _vm.sendOTP
    }
  }, [_vm._v("\n                          " + _vm._s((_vm.canResend ? 'Resend' : 'Send') + ' OTP') + "\n                        ")])], 1)], 1), _vm._v(" "), (_vm.isOTPSent) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pt-0",
    attrs: {
      "type": "number",
      "placeholder": "Enter OTP",
      "hide-details": ""
    },
    model: {
      value: (_vm.otp),
      callback: function($$v) {
        _vm.otp = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "otp"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isOTPSent) ? _c('v-flex', {
    staticClass: "mt-4",
    attrs: {
      "xs12": ""
    }
  }, [_vm._v("\n                      By clicking continue, you agree to our "), _c('a', {
    staticClass: "info--text",
    on: {
      "click": function($event) {
        _vm.showTerms = true
      }
    }
  }, [_vm._v("terms & conditions and privacy policy")])]) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    staticClass: "pl-0 pr-0 px-4",
    attrs: {
      "step": "2"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "scrollable": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title pt-0"
  }, [_vm._v("Personal details")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "py-0",
    staticStyle: {
      "max-height": "400px",
      "overflow-y": "auto"
    }
  }, [_c('v-form', {
    ref: "form2"
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.isHavingHistory) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    staticClass: "mt-0",
    attrs: {
      "color": "warning",
      "value": "true"
    }
  }, [_c('div', {
    staticClass: "mb-2",
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("\n                            You already have below accounts with us, continue if you wish to join another unit.\n                          ")]), _vm._v(" "), _vm._l((_vm.userHistory), function(unit, u) {
    return _c('div', {
      key: u,
      staticStyle: {
        "color": "#000000"
      }
    }, [(unit.unit_no) ? _c('span', [_vm._v("\n                              " + _vm._s(u + 1 + '. ' + unit.block_nm + ' ' + unit.unit_no + ' in ' + unit.comm_name) + "\n                            ")]) : (unit.comm_name) ? _c('span', [_vm._v("\n                              " + _vm._s(unit.role_name + ' in ' + unit.comm_name) + "\n                            ")]) : _vm._e()])
  })], 2)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-2",
    attrs: {
      "xs7": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pt-0",
    attrs: {
      "placeholder": "Your name",
      "rules": [_vm.rules.required],
      "maxlength": "50"
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-2",
    attrs: {
      "xs5": ""
    }
  }, [_c('v-select', {
    staticClass: "pt-0",
    attrs: {
      "items": ['Male', 'Female'],
      "placeholder": "Gender",
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.gender),
      callback: function($$v) {
        _vm.gender = $$v
      },
      expression: "gender"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pt-0",
    attrs: {
      "placeholder": "E-mail address",
      "rules": [_vm.rules.required, _vm.rules.email],
      "maxlength": "50"
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "email"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Hide contact info from others",
      "disabled": _vm.mcOrOthers !== 'resident',
      "hint": "Not possible if you are part of association or staff ;)",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.hideContact),
      callback: function($$v) {
        _vm.hideContact = $$v
      },
      expression: "hideContact"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "pa-0",
    attrs: {
      "hide-details": ""
    },
    model: {
      value: (_vm.mcOrOthers),
      callback: function($$v) {
        _vm.mcOrOthers = $$v
      },
      expression: "mcOrOthers"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Resident (owner/tenant)",
      "value": "resident"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": (_vm.commCountryCode === 'MY' ? 'JMB' : 'Association') + '/MC member',
      "value": "mc-member"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Staff",
      "value": "staff"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Others",
      "value": "other-user"
    }
  })], 1)], 1), _vm._v(" "), (_vm.mcOrOthers !== 'resident') ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    staticClass: "pa-0",
    attrs: {
      "placeholder": "Role",
      "items": _vm.mcOrOthers === 'mc-member' ? _vm.mcRolesList : (_vm.mcOrOthers === 'staff' ? _vm.staffRolesList : _vm.othersRolesList),
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.role),
      callback: function($$v) {
        _vm.role = $$v
      },
      expression: "role"
    }
  })], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    staticClass: "pl-0 pr-0",
    attrs: {
      "step": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [(_vm.isNewComm) ? _c('v-card-title', {
    staticClass: "title pt-0"
  }, [_vm._v("Community details")]) : _vm._e(), _vm._v(" "), _c('v-card-text', {
    staticClass: "py-0"
  }, [_c('v-form', {
    ref: "form3"
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [(!_vm.isNewComm) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "title accent white--text pa-2",
    attrs: {
      "disabled": ""
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "white",
      "large": ""
    }
  }, [_vm._v("location_city")]), _vm._v("\n                    " + _vm._s(_vm.commNm) + "\n                  ")], 1)], 1)], 1) : _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    ref: "refCommName",
    staticClass: "pt-0",
    attrs: {
      "placeholder": "Community name",
      "rules": [_vm.rules.required],
      "hint": "New community will be created with this name",
      "persistent-hint": "",
      "maxlength": "50"
    },
    on: {
      "blur": _vm.checkDupComm
    },
    model: {
      value: (_vm.commNm),
      callback: function($$v) {
        _vm.commNm = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "commNm"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pt-0",
    attrs: {
      "placeholder": "Address",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "50"
    },
    model: {
      value: (_vm.commAdr),
      callback: function($$v) {
        _vm.commAdr = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "commAdr"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pt-0",
    attrs: {
      "placeholder": "City",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "25"
    },
    model: {
      value: (_vm.commCity),
      callback: function($$v) {
        _vm.commCity = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "commCity"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pt-0",
    attrs: {
      "placeholder": "PIN",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "10"
    },
    model: {
      value: (_vm.commPIN),
      callback: function($$v) {
        _vm.commPIN = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "commPIN"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pt-0",
    attrs: {
      "placeholder": "State",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "25"
    },
    model: {
      value: (_vm.commState),
      callback: function($$v) {
        _vm.commState = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "commState"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    staticClass: "pt-0",
    attrs: {
      "items": _vm.config.SUPPORTED_COUNTRIES.map(function (rec) { return rec.country; }),
      "placeholder": "Country",
      "hide-details": "",
      "maxlength": "50"
    },
    model: {
      value: (_vm.commCountry),
      callback: function($$v) {
        _vm.commCountry = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "commCountry"
    }
  })], 1)], 1), _vm._v(" "), (_vm.mcOrOthers !== 'staff' && _vm.mcOrOthers !== 'other-user') ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "title pt-4 pb-2"
  }, [_vm._v("Unit details")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-combobox', {
    attrs: {
      "placeholder": "Block",
      "items": _vm.blockList,
      "rules": [_vm.rules.required],
      "maxlength": "25",
      "disabled": _vm.cantChangeUnit
    },
    on: {
      "input": function($event) {
        return _vm.findBlockId()
      }
    },
    model: {
      value: (_vm.blockNm),
      callback: function($$v) {
        _vm.blockNm = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "blockNm"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-combobox', {
    attrs: {
      "placeholder": "Unit no.",
      "rules": [_vm.rules.required],
      "items": _vm.unitList,
      "maxlength": "10",
      "disabled": _vm.cantChangeUnit
    },
    on: {
      "input": function($event) {
        return _vm.findUnitId()
      }
    },
    model: {
      value: (_vm.unitNo),
      callback: function($$v) {
        _vm.unitNo = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "unitNo"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    staticClass: "pt-0",
    attrs: {
      "items": _vm.resRolesList,
      "placeholder": "Ownership",
      "rules": [_vm.rules.required],
      "disabled": _vm.cantChangeUnit
    },
    model: {
      value: (_vm.ownership),
      callback: function($$v) {
        _vm.ownership = $$v
      },
      expression: "ownership"
    }
  })], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "4"
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center",
    attrs: {
      "flat": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": "",
      "color": "primary"
    }
  }, [_vm._v("auto_awesome")]), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_vm._v("Congrats!"), _c('br'), _vm._v("You are now part of"), _c('br')]), _vm._v(" "), _c('v-chip', {
    staticClass: "title accent white--text pa-2",
    attrs: {
      "disabled": ""
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "white",
      "large": ""
    }
  }, [_vm._v("location_city")]), _vm._v("\n      " + _vm._s(_vm.commNm) + "\n    ")], 1), _vm._v(" "), _c('v-alert', {
    staticClass: "mt-3 pa-1 text-xs-center",
    attrs: {
      "outline": "",
      "color": "info",
      "value": true
    }
  }, [(_vm.isVerResident && !_vm.isAdmin) ? _c('span', [_vm._v("Your resident identity verified successfully. You can start using the app right away!")]) : (!_vm.isAdmin) ? _c('span', [_vm._v("You will be notified as soon as your community admin accepts your request")]) : _c('span', [_vm._v("\n        IMPORTANT\n        "), _c('br'), _c('br'), _vm._v("\n        As your community is just beginning to grow up in Integra, you will be one of 3 admins until a committee takes it over.\n        "), _c('br'), _c('br'), _vm._v("\n        Till then, you will be notified to approve whenever other users wish to join your community.\n      ")])])], 1)], 1), _vm._v(" "), _c('v-container', {
    staticClass: "pa-0 primary"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [(_vm.curStep > 1 && _vm.curStep < 4) ? _c('v-btn', {
    staticClass: "text-xs-left white--text",
    attrs: {
      "flat": "",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.prevStep.apply(null, arguments)
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.curStep < 4) ? _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.closeDlg.apply(null, arguments)
      }
    }
  }, [_vm._v("Cancel")]) : _vm._e(), _vm._v(" "), (_vm.curStep == 4) ? _c('v-btn', {
    staticClass: "accent--text",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.closeDlg.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")]) : _vm._e(), _vm._v(" "), (_vm.curStep < 4) ? _c('v-btn', {
    staticClass: "text-xs-right",
    style: ({
      color: '#50c878'
    }),
    attrs: {
      "flat": "",
      "disabled": _vm.beingSaved
    },
    nativeOn: {
      "click": function($event) {
        return _vm.nextStep.apply(null, arguments)
      }
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.butCap))])]) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "400px",
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showSimComm),
      callback: function($$v) {
        _vm.showSimComm = $$v
      },
      expression: "showSimComm"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("\n      Wait!\n    ")]), _vm._v(" "), _c('v-card-text', [_c('span', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s(_vm.similarCommList.length > 1 ? 'Communities' : 'Community') + " with similar name already found."), _c('br'), _c('br'), _vm._v("Please tap on your community listed below or tap on OVERRIDE to proceed with the name you entered.")]), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.commNameHead,
      "items": _vm.similarCommList,
      "disable-initial-sort": "",
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              return _vm.chooseComm(props.item)
            }
          }
        }, [_c('td', {
          staticClass: "text-xs-center"
        }, [_c('span', {
          staticClass: "title info--text"
        }, [_vm._v(_vm._s(props.item.comm_name))])])])]
      }
    }])
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showSimComm = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showSimComm = false
      }
    }
  }, [_vm._v("Overide & Use I Entered")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "600px",
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showTerms),
      callback: function($$v) {
        _vm.showTerms = $$v
      },
      expression: "showTerms"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "scrollable": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("\n      Terms & Conditions and Privacy Policy\n      "), _c('v-btn', {
    staticStyle: {
      "position": "absolute",
      "top": "7px",
      "right": "7px"
    },
    attrs: {
      "small": "",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showTerms = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('div', {
    staticClass: "subheader py-2 primary--text"
  }, [_vm._v("\n        WHAT INFORMATION WE COLLECT\n      ")]), _vm._v(" "), _c('ul', {
    staticClass: "ml-3"
  }, [_c('li', [_vm._v("\n          Details about your society like name, address, number of blocks, flats and facilities.\n        ")]), _vm._v(" "), _c('li', [_vm._v("\n          Personal information like name and contact details of management committee and residents.\n        ")]), _vm._v(" "), _c('li', [_vm._v("\n          Personal information like name and contact number of visitors as a security measure of your society.\n        ")]), _vm._v(" "), _c('li', [_vm._v("\n          Any other information which users share on their sole discretion while creating Invites/EasyPasses, posting notices, posts, comments, replies and complaints, etc.\n        ")]), _vm._v(" "), _c('li', [_vm._v("\n          Invoice and payment details of maintenance & amenity booking charges. We do NOT store users' bank or card details.\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "subheader py-2 primary--text"
  }, [_vm._v("\n        WHAT DO WE USE YOUR INFORMATION FOR\n      ")]), _vm._v(" "), _c('ul', {
    staticClass: "ml-3"
  }, [_c('li', [_vm._v("\n          We (“Integra”) do NOT sell, rent or share any information collected above to any of our partners and/or third party, without your explicit approval.\n        ")]), _vm._v(" "), _c('li', [_vm._v("\n          All information is protected with most care using stringent access control and encryption technologies both at transit and storage.\n        ")]), _vm._v(" "), _c('li', [_vm._v("\n          The information we collect will be used only to provide you better and uninterrupted service by monitoring the usage & performance of the application, identify the gaps and improve our quality of service. Also by our support personal to review and respond to your tickets if any.\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "subheader py-2 primary--text"
  }, [_vm._v("\n        YOUR RIGHT ON YOUR DATA\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0"
  }, [_vm._v("\n        You can have all your personal information deleted from our systems if you are no longer associated to your society, with an intimation/permission of respective resident welfare association. Please contact us at postman@uniservice.in whenever you want to do so.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "subheader py-2 primary--text"
  }, [_vm._v("\n        YOUR CONSENT\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0"
  }, [_vm._v("\n        By using our application, you consent to this privacy policy and terms & conditions.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "subheader py-2 primary--text"
  }, [_vm._v("\n        NOTIFICATION OF CHANGES\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        Any change made to these terms will be notified via E-mail and/or while logging in to application.\n      ")])])], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.sbarCol,
      "timeout": 4000,
      "multi-line": ""
    },
    model: {
      value: (_vm.sbar),
      callback: function($$v) {
        _vm.sbar = $$v
      },
      expression: "sbar"
    }
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.sbarMsg))])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 762:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "max-width": "400",
      "persistent": ""
    },
    model: {
      value: (_vm.showDlg),
      callback: function($$v) {
        _vm.showDlg = $$v
      },
      expression: "showDlg"
    }
  }, [_c('v-form', {
    ref: "lForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.loginToApp.apply(null, arguments)
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("Login")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "py-0"
  }, [_c('v-container', {
    staticClass: "pa-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('vue-tel-input-vuetify', {
    ref: "refMob",
    attrs: {
      "label": "",
      "placeholder": "Enter a mobile number",
      "rules": [_vm.rules.required],
      "input-options": {
        showDialCode: true
      }
    },
    on: {
      "input": _vm.keepCursor,
      "validate": _vm.validateMob
    },
    nativeOn: {
      "keydown": function($event) {
        return _vm.ignoreBackspace.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.mobile),
      callback: function($$v) {
        _vm.mobile = $$v
      },
      expression: "mobile"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v("\n                    Enter your mobile number and press send OTP\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "text-xs-right"
  }, [_c('span', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.canResend) ? _c('v-flex', {
    attrs: {
      "xs1": ""
    },
    on: {
      "click": function($event) {
        _vm.isOTPSent = false
      }
    }
  }, [_c('v-checkbox', {
    staticClass: "mt-2",
    model: {
      value: (_vm.reqOTPToMobile),
      callback: function($$v) {
        _vm.reqOTPToMobile = $$v
      },
      expression: "reqOTPToMobile"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.secToWait > 0) ? _c('v-flex', {
    staticClass: "mt-3 text-xs-right",
    attrs: {
      "xs8": ""
    }
  }, [_c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v("Wait " + _vm._s(_vm.secToWait) + " sec to retry")])]) : (_vm.canResend || _vm.reqOTPToMobile) ? _c('v-flex', {
    staticClass: "mt-3 text-xs-left",
    attrs: {
      "xs7": ""
    },
    on: {
      "click": function($event) {
        _vm.isOTPSent = false;
        _vm.reqOTPToMobile = !_vm.reqOTPToMobile
      }
    }
  }, [_c('div', {
    staticClass: "caption"
  }, [_vm._v("Send OTP to mobile as well")])]) : _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-0 pa-0 accent--text",
    attrs: {
      "flat": "",
      "disabled": (!_vm.canResend && !_vm.isValidNumber) || _vm.secToWait > 0
    },
    on: {
      "click": _vm.sendOTP
    }
  }, [_vm._v("\n                          " + _vm._s((_vm.canResend ? 'Resend' : 'Send') + ' OTP') + "\n                        ")])], 1)], 1)], 1)])], 1), _vm._v(" "), (_vm.isOTPSent) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    staticClass: "caption pa-2 mt-0",
    attrs: {
      "value": "true",
      "color": "info"
    }
  }, [(_vm.reqOTPToMobile) ? _c('span', [_vm._v("OTP is sent to your mobile & email. Please check and enter here")]) : _c('span', [_vm._v("OTP is sent to your email " + _vm._s(_vm.OTPRes.contact_email) + ". Please check (including spam folder) and enter here")])])], 1) : _vm._e(), _vm._v(" "), (_vm.isOTPSent) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pt-0",
    attrs: {
      "type": "number",
      "placeholder": "Enter OTP"
    },
    model: {
      value: (_vm.otp),
      callback: function($$v) {
        _vm.otp = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "otp"
    }
  })], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "primary"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.closeDlg.apply(null, arguments)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    staticClass: "text-xs-right accent--text",
    attrs: {
      "flat": "",
      "type": "submit",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("Log in")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.sbarCol,
      "timeout": 4000,
      "multi-line": ""
    },
    model: {
      value: (_vm.sbar),
      callback: function($$v) {
        _vm.sbar = $$v
      },
      expression: "sbar"
    }
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.sbarMsg))])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 763:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": "",
      "fill-height": "",
      "pa-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "fill-height": ""
    }
  }, [_c('div', {
    style: (_vm.$vuetify.breakpoint.smAndUp ? 'position:absolute;top:10%;right:15%' : 'position:absolute;top:60px;right:10px')
  }, _vm._l((_vm.config.SUPPORTED_COUNTRIES), function(comm, c) {
    return _c('v-btn', {
      key: c,
      class: (_vm.commCountryCode === comm.country_code ? 'grey lighten-2 ' : '') + 'ma-0',
      attrs: {
        "fab": "",
        "small": "",
        "flat": ""
      },
      on: {
        "click": function($event) {
          return _vm.changeCountry(comm.country_code, comm.country)
        }
      }
    }, [_c('flag', {
      staticStyle: {
        "font-size": "16px"
      },
      attrs: {
        "squared": false,
        "iso": comm.country_code.toLowerCase()
      }
    })], 1)
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "left-panel"
  }, [_c('img', {
    staticClass: "side-img",
    attrs: {
      "src": "/static/img/others/integrafms.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right-panel d-flex align-center justify-center"
  }, [_c('div', {
    staticClass: "form-container text-xs-center"
  }, [_c('img', {
    attrs: {
      "height": "150",
      "width": "250",
      "src": "/static/img/logo/integra_logo.png"
    }
  }), _vm._v(" "), _c('v-form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.joinComm.apply(null, arguments)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mt-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": 'Search & join your community in ' + _vm.commLocConfig.country,
      "loading": _vm.loading,
      "items": _vm.items,
      "search-input": _vm.search,
      "no-data-text": _vm.search ? 'Community not found in our records' : 'Start typing your community name',
      "hide-details": ""
    },
    on: {
      "update:searchInput": function($event) {
        _vm.search = $event
      },
      "update:search-input": function($event) {
        _vm.search = $event
      }
    },
    model: {
      value: (_vm.selComm),
      callback: function($$v) {
        _vm.selComm = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "selComm"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "type": "submit",
      "block": "",
      "color": "primary"
    }
  }, [_vm._v("Join")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "block": "",
      "color": "accent",
      "light": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.login.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                Already a member? Log in\n              ")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-4",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "primary--text",
    attrs: {
      "flat": "",
      "small": "",
      "href": _vm.website_url
    }
  }, [_vm._v("\n            Contact Us\n          ")])], 1)], 1)])]), _vm._v(" "), (_vm.joining) ? _c('join-comm', {
    attrs: {
      "comm": _vm.selComm,
      "countrycode": _vm.commCountryCode,
      "country": _vm.commLocConfig.country
    },
    on: {
      "closed": function($event) {
        _vm.joining = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loging) ? _c('login', {
    attrs: {
      "countrycode": _vm.commCountryCode
    },
    on: {
      "closed": function($event) {
        _vm.loging = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.sbarCol,
      "timeout": 3000,
      "multi-line": ""
    },
    model: {
      value: (_vm.sbar),
      callback: function($$v) {
        _vm.sbar = $$v
      },
      expression: "sbar"
    }
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.sbarMsg))])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 764:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('router-link', {
    staticStyle: {
      "text-decoration": "none",
      "color": "black"
    },
    attrs: {
      "to": {
        path: '/Facdash/'
      }
    }
  }, [_c('v-btn', {
    staticClass: "px-0 pb-0 pt-2 ml-0",
    attrs: {
      "small": "",
      "flat": ""
    }
  }, [_c('v-icon', [_vm._v("keyboard_backspace")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-btn', {
    staticClass: "accent",
    on: {
      "click": _vm.downoadAsPdf
    }
  }, [_vm._v("Download As Pdf")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "id": "pdf_report"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 title"
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-left pt-2"
  }, [_vm._v(_vm._s(_vm.lReport.comm_name) + " - FM Daily Report (" + _vm._s(_vm.lReport.rep_date) + ")")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-right"
  }, [_c('img', {
    attrs: {
      "height": "30",
      "src": __webpack_require__(169)
    }
  })])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-divider', {
    staticStyle: {
      "border-top": "1px solid black"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center title py-2 warning--text"
  }, [_vm._v("Attendance: " + _vm._s(_vm.lReport.attAve ? _vm.lReport.attAve : 0) + "% (" + _vm._s(_vm.lReport.tot_present + (_vm.lReport.tot_ot ? ' + ' + _vm.lReport.tot_ot : '') + '/' + _vm.lReport.tot_staff) + ")")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', _vm._l((_vm.lReport.roleCat), function(item, i) {
    return _c('v-flex', {
      key: i,
      staticClass: "pa-0",
      style: (i > 0 ? 'border-top: 1px solid black;border-right: 1px solid black;border-bottom: 1px solid black;' : 'border-right: 1px solid black;border-left: 1px solid black;border-bottom: 1px solid black;border-top: 1px solid black;')
    }, [_c('div', {
      staticClass: "text-xs-center py-2",
      staticStyle: {
        "font-size": "12px",
        "background-color": "#215868",
        "color": "#fff"
      }
    }, [_vm._v(_vm._s(item))]), _vm._v(" "), _c('v-data-table', {
      attrs: {
        "headers": _vm.lReport.attHeader.filter(function (rec) { return rec.role_cat === item; }),
        "items": _vm.attList.filter(function (rec) { return rec.role_cat === item; }),
        "hide-actions": "",
        "disable-initial-sort": ""
      },
      scopedSlots: _vm._u([{
        key: "headers",
        fn: function(row) {
          return [_c('tr', _vm._l((row.headers[0].attHead), function(header, k) {
            return _c('th', {
              key: k,
              staticClass: "primary white--text pa-0"
            }, [_vm._v("\n                        " + _vm._s(header.short_form) + "\n                      ")])
          }), 0)]
        }
      }, {
        key: "items",
        fn: function(props) {
          return [_c('tr', {
            staticClass: "text-xs-center"
          }, _vm._l((props.item.attendance), function(att, k) {
            return _c('td', {
              key: k,
              staticClass: "pa-0",
              staticStyle: {
                "font-size": "12px"
              }
            }, [_vm._v("\n                        " + _vm._s(att.tot_present) + "\n                        "), (att.tot_wo || att.tot_holiday || att.tot_leave || att.tot_absent || att.tot_hd) ? _c('span', [_c('br')]) : _vm._e(), _vm._v(" "), (att.tot_wo) ? _c('span', {
              staticStyle: {
                "font-size": "9px"
              }
            }, [_vm._v(_vm._s(' W' + att.tot_wo))]) : _vm._e(), _vm._v(" "), (att.tot_holiday) ? _c('span', {
              staticStyle: {
                "font-size": "9px"
              }
            }, [_vm._v(_vm._s(' H' + att.tot_holiday))]) : _vm._e(), _vm._v(" "), (att.tot_leave) ? _c('span', {
              staticStyle: {
                "font-size": "9px"
              }
            }, [_vm._v(_vm._s(' L' + att.tot_leave))]) : _vm._e(), _vm._v(" "), (att.tot_absent) ? _c('span', {
              staticStyle: {
                "font-size": "9px"
              }
            }, [_vm._v(_vm._s(' A' + att.tot_absent))]) : _vm._e(), _vm._v(" "), (att.tot_hd) ? _c('span', {
              staticStyle: {
                "font-size": "9px"
              }
            }, [_vm._v(_vm._s(' HD' + att.tot_hd))]) : _vm._e()])
          }), 0)]
        }
      }], null, true)
    })], 1)
  }), 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "caption pl-1 text-xs-left",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("\n                  NOTE: Attendance % includes weekly offs(W), holidays(H) and leaves(L)\n                ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "caption pr-1 text-xs-right",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("\n                  X+Y/Z where X total present+HD, Y is OT+S, Z is total number of staff\n                ")])])], 1)], 1), _vm._v(" "), (_vm.lReport.remark_attendance) ? _c('div', {
    staticClass: "caption pl-1"
  }, [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "font-weight": "bold"
    }
  }, [_vm._v("Remark:")]), _vm._v(" " + _vm._s(_vm.lReport.remark_attendance) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center title py-2 warning--text"
  }, [_vm._v("Compliance")])]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "border": "1px solid black"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center py-2",
    staticStyle: {
      "font-size": "12px",
      "background-color": "#215868",
      "color": "#fff"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('span', [_vm._v("COMPLIANCE STATUS")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    staticClass: "text-xs-center",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs4": ""
    }
  }, [_c('div', {
    staticStyle: {
      "border": "2px solid #4caf50",
      "border-radius": "4px",
      "padding": "10px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "24px",
      "font-weight": "bold",
      "color": "#4caf50"
    }
  }, [_vm._v(_vm._s(_vm.complianceData.active))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "12px",
      "color": "#4caf50"
    }
  }, [_vm._v("Active")])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs4": ""
    }
  }, [_c('div', {
    staticStyle: {
      "border": "2px solid #ff9800",
      "border-radius": "4px",
      "padding": "10px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "24px",
      "font-weight": "bold",
      "color": "#ff9800"
    }
  }, [_vm._v(_vm._s(_vm.complianceData.expiring))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "12px",
      "color": "#ff9800"
    }
  }, [_vm._v("Expiring Soon")])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs4": ""
    }
  }, [_c('div', {
    staticStyle: {
      "border": "2px solid #f44336",
      "border-radius": "4px",
      "padding": "10px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "24px",
      "font-weight": "bold",
      "color": "#f44336"
    }
  }, [_vm._v(_vm._s(_vm.complianceData.expired))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "12px",
      "color": "#f44336"
    }
  }, [_vm._v("Expired")])])])], 1), _vm._v(" "), (_vm.complianceData.total > 0) ? _c('v-layout', {
    staticClass: "mt-2",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "12px",
      "font-weight": "bold",
      "text-align": "center"
    }
  }, [_vm._v("\n                      Total Compliances: " + _vm._s(_vm.complianceData.total) + "\n                    ")])])], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (_vm.expiredComplianceList.length > 0) ? _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center py-2",
    staticStyle: {
      "font-size": "12px",
      "background-color": "#f44336",
      "color": "#fff"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('span', [_vm._v("EXPIRED COMPLIANCES")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    staticStyle: {
      "border": "1px solid black"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "primary white--text text-xs-center py-2",
    staticStyle: {
      "font-size": "12px",
      "width": "200px"
    }
  }, [_c('span', [_vm._v("Compliance Name")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "primary white--text text-xs-center py-2",
    staticStyle: {
      "font-size": "12px",
      "width": "150px"
    }
  }, [_c('span', [_vm._v("Category")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "primary white--text text-xs-center py-2",
    staticStyle: {
      "font-size": "12px",
      "width": "150px"
    }
  }, [_c('span', [_vm._v("Subcategory")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "primary white--text text-xs-center py-2",
    staticStyle: {
      "font-size": "12px",
      "width": "120px"
    }
  }, [_c('span', [_vm._v("Category Type")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "primary white--text text-xs-center py-2",
    staticStyle: {
      "font-size": "12px",
      "width": "120px"
    }
  }, [_c('span', [_vm._v("Cost")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "primary white--text text-xs-center py-2",
    staticStyle: {
      "font-size": "12px",
      "width": "120px"
    }
  }, [_c('span', [_vm._v("Expired At")])])], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "hide-headers": "",
      "items": _vm.expiredComplianceList,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          staticClass: "text-xs-center"
        }, [_c('td', {
          staticClass: "pa-2",
          staticStyle: {
            "font-size": "12px",
            "width": "200px"
          }
        }, [_vm._v(_vm._s(props.item.compliance_name))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2",
          staticStyle: {
            "font-size": "12px",
            "width": "150px"
          }
        }, [_vm._v(_vm._s(props.item.category_name || '-'))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2",
          staticStyle: {
            "font-size": "12px",
            "width": "150px"
          }
        }, [_vm._v(_vm._s(props.item.subcategory_name || '-'))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2",
          staticStyle: {
            "font-size": "12px",
            "width": "150px"
          }
        }, [_vm._v(_vm._s(props.item.compliance_type || '-'))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2",
          staticStyle: {
            "font-size": "12px",
            "width": "150px"
          }
        }, [_vm._v(_vm._s(props.item.cost ? '₹' + props.item.cost.toLocaleString() : '-'))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2",
          staticStyle: {
            "font-size": "12px",
            "width": "120px"
          }
        }, [_vm._v(_vm._s(props.item.valid_to ? _vm.handy.formatDate(props.item.valid_to) : '-'))])])]
      }
    }], null, false, 3303308925)
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center title py-2 warning--text"
  }, [_vm._v("Power Management")])]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "border": "1px solid black"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center py-2",
    staticStyle: {
      "font-size": "12px",
      "background-color": "#215868",
      "color": "#fff"
    }
  }, [_vm._v("CONSUMPTION")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center primary white--text py-4",
    staticStyle: {
      "font-size": "12px",
      "height": "78px"
    },
    attrs: {
      "xs4": ""
    }
  }, [_c('span', [_vm._v("EB")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center py-4",
    attrs: {
      "xs8": ""
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.lReport.eb_unit ? _vm.lReport.eb_unit.toFixed(2) : '0') + " units")])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center mt-0 primary white--text py-4",
    staticStyle: {
      "font-size": "12px",
      "height": "78px"
    },
    attrs: {
      "xs4": ""
    }
  }, [_c('span', [_vm._v("DG")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center py-4",
    attrs: {
      "xs8": ""
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.lReport.dg_unit) + " units")])])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": "",
      "sm10": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center py-2",
    staticStyle: {
      "font-size": "12px",
      "background-color": "#215868",
      "color": "#fff"
    }
  }, [_vm._v("DISTRIBUTION (UNITS)")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center",
    attrs: {
      "id": "div_powercons"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "chart_powercons"
    }
  })])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-4 py-0",
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center",
    attrs: {
      "id": "div_powergenset"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "chart_powergenset"
    }
  })])])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mt-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-0",
    staticStyle: {
      "border": "1px solid black"
    },
    attrs: {
      "xs8": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center py-2",
    staticStyle: {
      "font-size": "12px",
      "background-color": "#215868",
      "color": "#fff"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('div', [_vm._v("DG SUMMARY")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.gensetHead), function(genset, i) {
    return _c('v-flex', {
      key: i,
      staticClass: "primary white--text text-xs-center py-2"
    }, [_c('span', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(genset.text))])])
  }), 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "hide-headers": "",
      "disable-initial-sort": "",
      "items": _vm.gensetList,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          staticClass: "text-xs-center"
        }, [_c('td', {
          staticClass: "pa-0",
          staticStyle: {
            "font-size": "12px",
            "width": "139px"
          }
        }, [_vm._v(_vm._s(props.item.genset_nm ? props.item.genset_nm : '-'))]), _vm._v(" "), _c('td', {
          staticClass: "pa-0",
          staticStyle: {
            "font-size": "12px",
            "width": "139px"
          }
        }, [_vm._v(_vm._s(props.item.units_cons ? props.item.units_cons : '-'))]), _vm._v(" "), _c('td', {
          staticClass: "pa-0",
          staticStyle: {
            "font-size": "12px",
            "width": "139px"
          }
        }, [_vm._v(_vm._s(props.item.level ? props.item.level + '%' : '-'))]), _vm._v(" "), _c('td', {
          staticClass: "pa-0",
          staticStyle: {
            "font-size": "12px",
            "width": "139px"
          }
        }, [_vm._v(_vm._s(props.item.run_hrs ? props.item.run_hrs : '-'))])])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    staticStyle: {
      "border-top": "1px solid black",
      "border-bottom": "1px solid black",
      "border-right": "1px solid black"
    },
    attrs: {
      "xs4": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center py-2",
    staticStyle: {
      "font-size": "12px",
      "background-color": "#215868",
      "color": "#fff"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('div', [_vm._v("DIESEL PURCHASE & STOCK")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.dieselHead), function(diesel, i) {
    return _c('v-flex', {
      key: i,
      staticClass: "primary white--text text-xs-center py-2",
      attrs: {
        "xs6": ""
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(diesel.text))])])
  }), 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "hide-headers": "",
      "disable-initial-sort": "",
      "items": _vm.dieselList,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          staticClass: "text-xs-center"
        }, [_c('td', {
          staticClass: "pa-0",
          staticStyle: {
            "font-size": "12px",
            "width": "173px"
          }
        }, [_vm._v(_vm._s(props.item.diesel_nm ? props.item.diesel_nm : '-'))]), _vm._v(" "), _c('td', {
          staticClass: "pa-0",
          staticStyle: {
            "font-size": "12px",
            "width": "173px"
          }
        }, [_vm._v(_vm._s(props.item.val ? props.item.val : '-'))])])]
      }
    }])
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.lReport.remark_power) ? _c('div', {
    staticClass: "caption pl-1"
  }, [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "font-weight": "bold"
    }
  }, [_vm._v("Remark:")]), _vm._v(" " + _vm._s(_vm.lReport.remark_power) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": "",
      "id": _vm.dieselList.length < 4 ? 'pageBreak' : ''
    }
  }, [_c('div', {
    staticClass: "text-xs-center title py-2 warning--text"
  }, [_vm._v("Water Management")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    staticStyle: {
      "border": "1px solid black"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "px-0",
    attrs: {
      "xs12": "",
      "sm5": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center py-2",
    staticStyle: {
      "font-size": "12px",
      "background-color": "#215868",
      "color": "#fff"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('span', [_vm._v("WATER LEVEL (%)")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center",
    attrs: {
      "id": "div_waterlevel"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "chart_waterlevel"
    }
  })])])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "px-0",
    attrs: {
      "xs12": "",
      "sm5": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center py-2",
    staticStyle: {
      "font-size": "12px",
      "background-color": "#215868",
      "color": "#fff"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('span', [_vm._v("CONSUMPTION (KL)")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    attrs: {
      "id": "div_watercons"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "chart_watercons"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "subheading pl-1"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Total water consumed: " + _vm._s(_vm.lReport.tot_water_cons > 0 ? _vm.lReport.tot_water_cons.toFixed(2) + ' KL' : '0 KL'))])])])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "px-0",
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center py-2",
    staticStyle: {
      "font-size": "12px",
      "background-color": "#215868",
      "color": "#fff"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('span', [_vm._v("SOURCES (KL)")])]), _vm._v(" "), _vm._l((_vm.domWatList), function(wat, i) {
    return _c('v-flex', {
      key: i,
      staticClass: "py-2 pl-2",
      attrs: {
        "xs12": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticClass: "text-xs-left",
      attrs: {
        "xs9": ""
      }
    }, [_c('div', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(wat.water_type))])]), _vm._v(" "), _c('v-flex', {
      staticClass: "text-xs-left title",
      attrs: {
        "xs3": ""
      }
    }, [_c('div', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(wat.water_receipt ? wat.water_receipt : 0))])])], 1)], 1)
  })], 2)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center mt-2 py-2",
    staticStyle: {
      "font-size": "12px",
      "background-color": "#215868",
      "color": "#fff"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('div', [_vm._v("WATER QUALITY & CONTROL")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    staticStyle: {
      "border": "1px solid black"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.paramHead), function(param, i) {
    return _c('v-flex', {
      key: i,
      staticClass: "primary white--text text-xs-center py-2"
    }, [_c('span', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(param.text))])])
  }), 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "hide-headers": "",
      "items": _vm.paramList,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          staticClass: "text-xs-center"
        }, [_c('td', {
          staticClass: "pa-0",
          staticStyle: {
            "font-size": "12px",
            "width": "174px"
          }
        }, [_vm._v(_vm._s(props.item.water_qual))]), _vm._v(" "), _vm._l((props.item.waterQualTypeValue), function(watQualVal, i) {
          return _c('td', {
            key: i,
            class: 'pa-0 ' + (watQualVal.val && (watQualVal.val < watQualVal.stdValMin || watQualVal.val > watQualVal.stdValMax) ? 'red white--text' : (watQualVal.val ? 'green lighten-3' : '')),
            staticStyle: {
              "font-size": "12px",
              "width": "174px"
            }
          }, [_vm._v("\n              " + _vm._s(watQualVal.val ? watQualVal.val : '-') + "\n            ")])
        })], 2)]
      }
    }])
  })], 1), _vm._v(" "), (_vm.lReport.remark_water) ? _c('div', {
    staticClass: "caption pl-1"
  }, [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "font-weight": "bold"
    }
  }, [_vm._v("Remark:")]), _vm._v(" " + _vm._s(_vm.lReport.remark_water) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center title py-2 warning--text"
  }, [_vm._v("Waste Management")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    staticStyle: {
      "border": "1px solid black"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center",
    attrs: {
      "id": "div_waste"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "chart_waste"
    }
  })])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": "",
      "id": "pageBreak"
    }
  }, [_c('div', {
    staticClass: "text-xs-center title py-2 warning--text"
  }, [_vm._v("Hygiene Management / Sanity Checks")])]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "border": "1px solid black"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center py-2",
    staticStyle: {
      "font-size": "12px",
      "background-color": "#215868",
      "color": "#fff"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('span', [_vm._v("SANITY CHECKS")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, _vm._l((_vm.hygCats), function(cat, n) {
    return _c('v-flex', {
      key: n,
      staticClass: "pa-0",
      attrs: {
        "xs12": ""
      }
    }, [_c('div', {
      staticClass: "text-xs-left pa-2 primary white--text",
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(cat.check_cat))]), _vm._v(" "), _c('v-data-table', {
      attrs: {
        "hide-headers": "",
        "items": _vm.hygList.filter(function (rec) { return rec.check_cat === cat.check_cat; }),
        "hide-actions": "",
        "disable-initial-sort": ""
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('tr', [_c('td', {
            staticClass: "pr-0",
            staticStyle: {
              "font-size": "12px",
              "width": "400px"
            }
          }, [_vm._v(_vm._s(props.item.check_desc))]), _vm._v(" "), _c('td', {
            staticStyle: {
              "width": "50px"
            }
          }, [_c('v-checkbox', {
            staticClass: "pt-2",
            attrs: {
              "hide-details": "",
              "readonly": ""
            },
            model: {
              value: (props.item.check_value),
              callback: function($$v) {
                _vm.$set(props.item, "check_value", $$v)
              },
              expression: "props.item.check_value"
            }
          })], 1), _vm._v(" "), _c('td', {
            staticStyle: {
              "font-size": "12px"
            }
          }, [_vm._v(_vm._s(props.item.remark))])])]
        }
      }], null, true)
    })], 1)
  }), 1)], 1)], 1), _vm._v(" "), (_vm.lReport.remark_sanity_checks) ? _c('div', {
    staticClass: "caption pl-1"
  }, [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "font-weight": "bold"
    }
  }, [_vm._v("Remark:")]), _vm._v(" " + _vm._s(_vm.lReport.remark_sanity_checks) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center title py-2 warning--text"
  }, [_vm._v("Safety & Security")])]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "border": "1px solid black"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center py-2",
    staticStyle: {
      "font-size": "12px",
      "background-color": "#215868",
      "color": "#fff"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('span', [_vm._v("INCIDENTS")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    staticStyle: {
      "border-top": "1px solid black"
    },
    attrs: {
      "xs12": ""
    }
  }, _vm._l((_vm.incidentTypes), function(incident, n) {
    return _c('v-flex', {
      key: n,
      staticClass: "pa-0",
      attrs: {
        "xs12": ""
      }
    }, [_c('div', {
      staticClass: "text-xs-left pa-2 primary white--text",
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(incident))]), _vm._v(" "), _c('v-flex', {
      staticClass: "pa-0",
      attrs: {
        "xs12": ""
      }
    }, [_c('v-data-table', {
      attrs: {
        "hide-headers": "",
        "items": _vm.incidentList.filter(function (rec) { return rec.incident_type === incident; }),
        "hide-actions": "",
        "disable-initial-sort": ""
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('tr', [_c('td', {
            staticStyle: {
              "font-size": "12px",
              "width": "315px"
            }
          }, [_vm._v(_vm._s(props.item.incident_class))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.incident_on ? (_vm.handy.formatDate(props.item.incident_on) + ' ' + _vm.handy.getTime12Hrs(props.item.incident_on) + (props.item.incident_end ? ' to ' + _vm.handy.formatDate(props.item.incident_end) + ' ' + _vm.handy.getTime12Hrs(props.item.incident_end) : '') + ' - ' + props.item.incident_desc) : ''))])])]
        }
      }], null, true)
    })], 1)], 1)
  }), 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center title py-2 warning--text"
  }, [_vm._v("52 Week PPM Planner")])]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "border": "1px solid black"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center py-2",
    staticStyle: {
      "font-size": "12px",
      "background-color": "#215868",
      "color": "#fff"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('span', [_vm._v("PPM PLANNER")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    staticStyle: {
      "border-top": "1px solid black"
    },
    attrs: {
      "xs12": ""
    }
  }, [(_vm.lPpmHeader.length > 0) ? _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.ppmHeader), function(ppm, i) {
    return _c('v-flex', {
      key: i,
      staticClass: "primary white--text text-xs-left pa-2"
    }, [_c('span', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(ppm.text))])])
  }), 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "hide-headers": "",
      "items": _vm.lPpmHeader,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          staticClass: "text-xs-left"
        }, [_c('td', {
          staticClass: "pa-2",
          staticStyle: {
            "font-size": "12px",
            "width": "162px"
          }
        }, [_vm._v(_vm._s(props.item.asset_tag ? props.item.asset_tag : '-'))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2",
          staticStyle: {
            "font-size": "12px",
            "width": "158px"
          }
        }, [_vm._v(_vm._s(props.item.asset_cat ? props.item.asset_cat : '-'))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2",
          staticStyle: {
            "font-size": "12px",
            "width": "191px"
          }
        }, [_vm._v(_vm._s(props.item.noneq_name ? props.item.noneq_name : '-'))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2",
          staticStyle: {
            "font-size": "12px",
            "width": "164px"
          }
        }, [_vm._v(_vm._s(props.item.freq))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2",
          staticStyle: {
            "font-size": "12px",
            "width": "156px"
          }
        }, [_vm._v(_vm._s(props.item.asset_location ? props.item.asset_location : '-'))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2",
          staticStyle: {
            "font-size": "12px"
          }
        }, [_vm._v(_vm._s(props.item.ppm_status))])])]
      }
    }], null, false, 3576252940)
  })], 1) : _c('v-flex', {
    staticClass: "pl-4",
    attrs: {
      "xs12": ""
    }
  }, [_vm._v("\n      NIL\n    ")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": "",
      "id": "pageBreak"
    }
  }, [_c('div', {
    staticClass: "text-xs-center title py-2 warning--text"
  }, [_vm._v("Complaints & Task Management")])]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "border": "1px solid black"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-0",
    staticStyle: {
      "border-right": "1px solid black"
    },
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center py-2",
    staticStyle: {
      "font-size": "12px",
      "background-color": "#215868",
      "color": "#fff"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('span', [_vm._v("COMPLAINTS")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.compHead), function(comp, i) {
    return _c('v-flex', {
      key: i,
      staticClass: "primary white--text text-xs-left pa-2"
    }, [_c('span', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(comp.text))])])
  }), 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "hide-headers": "",
      "items": _vm.compList,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          staticClass: "text-xs-left"
        }, [_c('td', {
          staticClass: "pa-2",
          staticStyle: {
            "font-size": "12px",
            "width": "139px"
          }
        }, [_vm._v(_vm._s(props.item.comp_cat))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2",
          staticStyle: {
            "font-size": "12px",
            "width": "139px"
          }
        }, [_vm._v(_vm._s(props.item.prev_pend))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2",
          staticStyle: {
            "font-size": "12px",
            "width": "139px"
          }
        }, [_vm._v(_vm._s(props.item.new_today))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2",
          staticStyle: {
            "font-size": "12px",
            "width": "139px"
          }
        }, [_vm._v(_vm._s(props.item.reop_today))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2",
          staticStyle: {
            "font-size": "12px",
            "width": "139px"
          }
        }, [_vm._v(_vm._s(props.item.closed_today))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2",
          staticStyle: {
            "font-size": "12px",
            "width": "139px"
          }
        }, [_vm._v(_vm._s(props.item.closing_bal))])])]
      }
    }])
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center py-2",
    staticStyle: {
      "font-size": "12px",
      "background-color": "#215868",
      "color": "#fff"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('span', [_vm._v("TASK")])]), _vm._v(" "), _c('div', {
    staticClass: "pt-3 pr-1 text-xs-center",
    attrs: {
      "id": "div_task"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "chart_task"
    }
  })])], 1)], 1)], 1), _vm._v(" "), (_vm.lMet.length > 0) ? _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center title py-2 warning--text"
  }, [_vm._v("Custom Metrics")])]) : _vm._e(), _vm._v(" "), (_vm.lMet.length > 0) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.lMet), function(metric, n) {
    return _c('v-flex', {
      key: n,
      staticClass: "pa-0",
      staticStyle: {
        "border": "1px solid black"
      },
      attrs: {
        "xs3": ""
      }
    }, [(metric) ? _c('div', {
      staticClass: "pa-2 text-xs-center",
      staticStyle: {
        "font-size": "12px",
        "background-color": "#215868",
        "color": "#fff"
      }
    }, [_vm._v("\n        " + _vm._s(metric.metric_cat.toUpperCase()) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('v-flex', {
      staticClass: "pa-0",
      attrs: {
        "xs12": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, _vm._l((_vm.metHead), function(met, i) {
      return _c('v-flex', {
        key: i,
        staticClass: "primary white--text text-xs-center py-2"
      }, [_c('span', {
        staticStyle: {
          "font-size": "12px"
        }
      }, [_vm._v(_vm._s(met.text))])])
    }), 1)], 1), _vm._v(" "), _c('v-data-table', {
      attrs: {
        "hide-headers": "",
        "items": _vm.metricList.filter(function (rec) { return rec.metric_cat === metric.metric_cat; }),
        "disable-initial-sort": "",
        "hide-actions": ""
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('tr', {
            staticClass: "text-xs-center"
          }, [_c('td', {
            staticClass: "px-1",
            staticStyle: {
              "font-size": "12px",
              "width": "130px"
            }
          }, [_vm._v(_vm._s(props.item.metric_nm ? props.item.metric_nm : '-'))]), _vm._v(" "), _c('td', {
            staticClass: "px-1",
            staticStyle: {
              "font-size": "12px",
              "width": "130px"
            }
          }, [_vm._v(_vm._s(props.item.metric_val ? props.item.metric_val : 0))])])]
        }
      }], null, true)
    })], 1)], 1)
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lReport.remark_custom_metrics) ? _c('div', {
    staticClass: "caption pl-1"
  }, [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "font-weight": "bold"
    }
  }, [_vm._v("Remark:")]), _vm._v(" " + _vm._s(_vm.lReport.remark_custom_metrics) + "\n")]) : _vm._e(), _vm._v(" "), (_vm.lReport.major_observ) ? _c('div', {
    staticClass: "caption pa-1"
  }, [_c('div', {
    staticClass: "text-xs-center title py-2 warning--text"
  }, [_vm._v("Major Observation")]), _vm._v(" "), _c('div', {
    staticClass: "pa-1",
    staticStyle: {
      "font-size": "12px",
      "border": "1px solid black"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.handy.getEditorStyle() + _vm.lReport.major_observ)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.lDailyUpdateAttach.files && _vm.lDailyUpdateAttach.files.length > 0) ? _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": "",
      "id": "pageBreak"
    }
  }, [_c('div', {
    staticStyle: {
      "color": "#ff7f2a",
      "font-size": "20px",
      "font-weight": "bold",
      "text-align": "center",
      "padding": "7px 0px"
    }
  }, [_vm._v("Photos")])]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [(_vm.lDailyUpdateAttach.files && _vm.lDailyUpdateAttach.files.length > 0) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.lDailyUpdateAttach.files), function(file, index) {
    return _c('v-flex', {
      key: index,
      staticClass: "pa-1 text-xs-center",
      attrs: {
        "xs12": "",
        "sm4": ""
      }
    }, [_c('v-card-media', {
      staticClass: "black--text caption",
      attrs: {
        "height": "210px",
        "src": file.file_url
      }
    }, [_c('div', {
      staticClass: "white--text",
      staticStyle: {
        "background-color": "rgba(125, 125, 125, 0.5)"
      }
    }, [_vm._v(_vm._s(_vm.handy.formatDBDateTime(file.attach_timestamp))), _c('br'), _vm._v("by " + _vm._s(file.user_name))]), _vm._v(" "), (file.notes) ? _c('div', {
      staticClass: "text-xs-center white--text",
      staticStyle: {
        "position": "absolute",
        "bottom": "0px",
        "width": "100%",
        "background-color": "rgba(0, 0, 255, 0.5)"
      }
    }, [_vm._v("\n          " + _vm._s(file.notes) + "\n        ")]) : _vm._e()])], 1)
  }), 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.sbarCol,
      "timeout": 2000,
      "multi-line": ""
    },
    model: {
      value: (_vm.sbar),
      callback: function($$v) {
        _vm.sbar = $$v
      },
      expression: "sbar"
    }
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.sbarMsg))])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 765:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "light": ""
    }
  }, [(_vm.loggedAlready && _vm.config.IS_USER_ACTIVE && _vm.config.IS_USER_LINKED) ? _c('v-navigation-drawer', {
    staticClass: "grey lighten-4",
    attrs: {
      "fixed": "",
      "app": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('img', {
    staticClass: "pl-3",
    attrs: {
      "height": "100",
      "width": "250",
      "src": "/static/img/logo/integra_logo.png"
    }
  })]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    staticClass: "pt-0",
    attrs: {
      "dense": ""
    }
  }, [_vm._l((_vm.items), function(item, i) {
    return [(item.heading) ? _c('v-layout', {
      key: i,
      attrs: {
        "row": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [(item.heading) ? _c('v-subheader', [_vm._v("\n            " + _vm._s(item.heading) + "\n          ")]) : _vm._e()], 1)], 1) : (_vm.isExternalMenuItem(item)) ? _c('v-list-tile', {
      on: {
        "click": function($event) {
          return _vm.handleMenuClick(item)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', {
      on: {
        "click": function($event) {
          return _vm.saveTrackScreenAccess(item)
        }
      }
    }, [_c('v-list-tile-title', [_vm._v("\n            " + _vm._s(item.text) + "\n          ")])], 1), _vm._v(" "), _c('v-list-tile-action', {
      staticClass: "justify-end",
      staticStyle: {
        "min-width": "24px"
      }
    }, [_c('v-icon', {
      staticClass: "grey--text text--darken-1",
      attrs: {
        "small": "",
        "title": "Opens in a new tab"
      }
    }, [_vm._v("open_in_new")])], 1)], 1) : (item.children.length) ? _c('v-list-group', {
      attrs: {
        "prepend-icon": item.icon,
        "no-action": ""
      },
      model: {
        value: (item.model),
        callback: function($$v) {
          _vm.$set(item, "model", $$v)
        },
        expression: "item.model"
      }
    }, [_c('v-list-tile', {
      attrs: {
        "slot": "activator"
      },
      slot: "activator"
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.text))])], 1)], 1), _vm._v(" "), _vm._l((item.children), function(child, i) {
      return _c('v-list-tile', {
        key: i,
        attrs: {
          "to": {
            path: '/' + child.url
          }
        }
      }, [(child.icon) ? _c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(child.icon))])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-content', {
        on: {
          "click": function($event) {
            return _vm.saveTrackScreenAccess(child)
          }
        }
      }, [_c('v-list-tile-title', [_vm._v("\n          " + _vm._s(child.text) + "\n        ")])], 1)], 1)
    })], 2) : _c('v-list-tile', {
      attrs: {
        "to": _vm.isExternalMenuItem(item) ? undefined : {
          path: '/' + item.url
        }
      },
      on: {
        "click": function($event) {
          return _vm.handleMenuClick(item)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', {
      on: {
        "click": function($event) {
          return _vm.saveTrackScreenAccess(item)
        }
      }
    }, [_c('v-list-tile-title', [_vm._v("\n        " + _vm._s(item.text) + "\n      ")])], 1)], 1)]
  }), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "to": {
        path: '/upload-test'
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("science")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    staticClass: "primary--text font-weight-bold"
  }, [_vm._v("\n            Upload Test\n          ")])], 1)], 1)], 2), _vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "pa-0"
  }, [(_vm.commList.length === 1) ? _c('div', {
    staticClass: "pa-3 title"
  }, [_c('span', [_vm._v(_vm._s(_vm.config.COMM_NAME))])]) : _c('div', [_c('v-select', {
    staticClass: "pa-1 title",
    attrs: {
      "items": _vm.commList.filter(function (rec) { return rec.is_active; }).map(function (rec) { return rec.comm_name; }),
      "hide-details": "",
      "solo": "",
      "flat": ""
    },
    on: {
      "input": function($event) {
        _vm.loadComm(_vm.commList.find(function (rec) { return rec.comm_name === _vm.choosenComm; }))
      }
    },
    model: {
      value: (_vm.choosenComm),
      callback: function($$v) {
        _vm.choosenComm = $$v
      },
      expression: "choosenComm"
    }
  })], 1)])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.loggedAlready) ? _c('v-toolbar', {
    attrs: {
      "color": "primary",
      "dark": "",
      "fixed": "",
      "app": "",
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [(_vm.config.IS_USER_ACTIVE && _vm.config.IS_USER_LINKED && (_vm.$route.path.includes('/dashboard') || _vm.$route.path.includes('/visitors'))) ? _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }, [_c('v-icon', [_vm._v("menu")])], 1) : (!_vm.$route.path.includes('/dashboard')) ? _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$router.go(-1)
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back")])], 1) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$route.meta.title) + "\n    "), (_vm.$route.path.includes('/visitors') && _vm.config.SECURITY_POST) ? _c('span', {
    staticClass: "warning--text px-2"
  }, [_vm._v("\n      [" + _vm._s(_vm.config.SECURITY_POST) + "]\n    ")]) : _vm._e()])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.config.IS_USER_ACTIVE && _vm.config.IS_USER_LINKED) ? _c('v-menu', {
    attrs: {
      "offset-y": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
    attrs: {
      "to": {
        path: '/profile'
      }
    }
  }, [_c('v-list-tile-title', [_vm._v("Profile")])], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": _vm.logout
    }
  }, [_c('v-list-tile-title', [_vm._v("Logout")])], 1)], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-content', {
    staticClass: "white"
  }, [_c('router-view')], 1), _vm._v(" "), _c('v-bottom-nav', {
    attrs: {
      "fixed": "",
      "value": _vm.selectedItems.length && _vm.$vuetify.breakpoint.smAndDown && _vm.loggedAlready && _vm.config.IS_USER_ACTIVE && _vm.config.IS_USER_LINKED && _vm.$route.path.includes('/dashboard'),
      "active": _vm.curBot
    },
    on: {
      "update:active": function($event) {
        _vm.curBot = $event
      }
    }
  }, [_vm._l((_vm.selectedItems), function(item, i) {
    return [_c('v-bottom-sheet', {
      attrs: {
        "inset": ""
      },
      model: {
        value: (item.botModel),
        callback: function($$v) {
          _vm.$set(item, "botModel", $$v)
        },
        expression: "item.botModel"
      }
    }, [_c('v-btn', {
      attrs: {
        "slot": "activator",
        "flat": "",
        "value": item.text
      },
      slot: "activator"
    }, [_c('span', {
      staticClass: "secondary--text"
    }, [_vm._v(_vm._s(item.text) + " ")]), _vm._v(" "), _c('v-icon', {
      staticClass: "accent--text"
    }, [_vm._v(_vm._s(item.icon) + " ")])], 1), _vm._v(" "), _c('v-list', _vm._l((item.children), function(child, c) {
      return _c('v-list-tile', {
        key: c,
        attrs: {
          "to": _vm.isExternalMenuItem(child, item) ? undefined : {
            path: '/' + child.url
          }
        },
        on: {
          "click": function($event) {
            item.botModel = false;
            _vm.handleMenuClick(child, item)
          }
        }
      }, [_c('v-list-tile-avatar', [_c('v-icon', {
        staticClass: "accent--text"
      }, [_vm._v(_vm._s(child.icon))])], 1), _vm._v(" "), _c('v-list-tile-title', {
        staticClass: "body-1 secondary--text"
      }, [_vm._v(_vm._s(child.text))])], 1)
    }), 1)], 1)]
  })], 2), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "400px",
      "persistent": ""
    },
    model: {
      value: (_vm.dlgPush),
      callback: function($$v) {
        _vm.dlgPush = $$v
      },
      expression: "dlgPush"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("\n      Wait!\n    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-0"
  }, [_c('div', {
    staticClass: "subheading"
  }, [_vm._v("You are not subscribed to push notification yet.")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_vm._v("\n        Choose the option \"allow\" when you prompted next and start receiving important alerts from Integra Application.\n      ")])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-1"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dlgPush = false
      }
    }
  }, [_vm._v("Remind Me Later")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.reqBrowserPromptForPush()
      }
    }
  }, [_vm._v("Proceed")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 773:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./env.dev.js": 452,
	"./env.production.js": 453,
	"./env.staging.js": 183
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 773;

/***/ }),

/***/ 774:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(388);
module.exports = __webpack_require__(387);


/***/ }),

/***/ 927:
/***/ (function(module, exports) {

module.exports = Tesseract;

/***/ })

},[774]);


// WEBPACK FOOTER //
// static/js/app.7904413a90a3c4347f8c.js